/* THEME: drayki.js — le script du système, pour le thème DRAYKI v3 (Online Store 2.0).
   Port de la maquette :
     source  maquette/site.js — la maquette finale (round 7), la même que
             C:/Users/DRAYKI/AppData/Local/Temp/claude/X--Downloads-theme-export--drayki-com-draki-23-09--23SEP2026-0445pm/416b7db1-6e6f-4f05-8b03-825cec1c533f/scratchpad/site/site.js
     date    2026-09-27 01:05:30 +0200 (maquette r7, finale : revérifiée octet pour octet le 27/09/2026)
     sha256  5e7b7c2d8f87648980cc911cc62a0c1b71b2f92178070c8f978b85fa19a34c16
     copie   work/sync/site.js.base (base des fusions à trois : git merge-file drayki.js
             work/sync/site.js.base <site.js du jour>, fins de ligne CRLF des trois côtés ;
             ou : python work/sync/theme-port/port.py <site.js> <site.css> <sortie>,
             qui refait les retouches THEME sur la nouvelle maquette)
   Le moteur, l'objet, les piles, les rideaux, les dessins, le lecteur… sont ceux de la
   maquette ligne pour ligne. Chaque changement fait pour le thème est marqué « THEME: » :
   - les données viennent de la page (snippets drayki-config et drayki-catalog) : plus de
     catalogue, de morceaux ni de paliers écrits ici ; prix en centimes, formatés comme la
     boutique (fmt, d'après un prix témoin du filtre money) ;
   - l'objet lit ses propres data- d'abord (kit-object), le catalogue ensuite ; il adopte
     l'<img> imprimée ; sur une fiche, un dos périmé est recompté depuis le manifeste ;
   - DRAYKI.countKit / kitCounts : la règle de work/kit-counts/kit_counts.py, portée
     (vérifiée par work/kit-counts/check-countkit.mjs sur les 20 manifestes) ;
   - le VRAI panier de Shopify (/cart/add.js, /cart/change.js, /cart/update.js avec
     Section Rendering : le tiroir et les [data-cart-section] reviennent dans chaque
     réponse) ; le tiroir est la section cart-drawer, adoptée, plus construite ici ;
   - « get the vault » ([data-vault-add]), « more kits » ([data-recs]), l'explorateur sur
     le manifeste imprimé dans la page (data-explorer="inline"), plusieurs listes de
     morceaux, le changement de version (drayki:variant) ;
   - l'éditeur de thème (section load / unload / reorder / select / deselect, block
     select) ; rien n'est mémorisé en mode éditeur ;
   - window.DRAYKI est complet dès l'évaluation ; le système démarre au DOMContentLoaded,
     après les modules des pages (home.js, collection.js, product.js…).
   Les mots de la boutique viennent de locales/en.default.json (drayki-config, strings). */
/*
  drayki — site.js, shared by every page of the store mockup (2026-09-26,
  consolidated). Vanilla, no library. Load it at the end of <body> (in the
  theme: deferred). Everything registers by data- attributes, so a Liquid
  section stays declarative:

    data-kit="machina"          a kit object (a thick tile, cover on its face)
    data-kit="halovst"          HALO's slab (data-shape="halo" is implied)
    data-cycle="a b c"          the object turns from kit to kit, a half turn every
                                data-cycle-every ms (3200), data-cycle-rounds times
                                round the list (1), while on the screen (obj.cycle())
    data-enter                  a card's entrance on any object (automatic in data-shelf):
                                it comes up the screen lying back and stands by the middle
    data-pose="rx ry rz"        its rest pose; data-lay="off" no lay-back by the scroll;
    data-lay-from="rx ry rz"    it arrives in this pose and turns to its rest pose by
                                the middle of the screen (the product page's coda)
    data-focus="off"            a copy of an object (a card's, a rail's): no tab stop, hidden from the reader
    data-travel="#landing"      the object that is carried down the page onto another one
    data-travel-fade            what gives way as the travelling object passes over it
    data-stack="a b c" | "all"  a stack of kit tiles (a bundle), set down tile by tile
    data-t                      a section word uncovered by the ground (curtain)
    data-cur                    a line uncovered the same way (a question, a title)
    data-shelf="h"              the kit's card (object + caption + add), from the data
    data-price / data-count / data-min / data-sum [data-off] / data-sounds   small fills
    data-draw="dl"              a drawing drawn once by the scroll (DRAYKI.DRAW)
    data-odo="sounds" | "252"   a counter rolled up by the scroll
    data-tick                   the marquee, moved by the scroll only
    data-uncover                a cover uncovered once by its card's ground
    data-crop                   a close-up that pans across as the page moves
    data-rail (+ [data-pg])     a rail and a computer's two arrow keys
    data-stars="4.7"            stars, filled = on
    data-explorer="url"         the kit explorer, from a manifest
    data-add="h"                an add key: into the cart, the key says "in cart", the add bar
                                comes up; with data-open the cart opens instead (a product page's
                                own pill); data-label="get {name}" sets its words
    data-cart-open              opens the cart; data-cart-count shows the count
    data-halo                   a link to HALO's page: its href is HALO_URL (written once, below)
    data-theme-toggle           (r7) the top line's theme key: light / dark, following the device
    data-other                  a band in the other palette (night on paper, paper on night)
    data-room                   the top line takes this band's colours while over it
    data-dock="#buy-gone"       the product page's slim bar, up once #buy-gone is above the screen
    data-dock-hide              where the dock goes down (the coda, the mix; the foot always)
    data-madewith="[handles]"   (r6) the tracks made with these kits / halo (all without a value):
                                the track in hand, the list, the bar at hand; [data-limit], [data-tracks]

  The scroll engine: one requestAnimationFrame loop, woken by scroll, pointer
  or a timed turn, that runs only while something moves and sleeps at rest
  (no rAF at all when idle). Every scroll effect is read off a follower of
  the scroll position (a critically damped spring), never takes the scroll
  over, and is gated by an IntersectionObserver. Hidden tab: stopped.
  Reduced motion or forced colours: no engine, every final state at once.

  The phone first (most of drayki's customers): the screen's height is kept
  (--vh / E.vh), never changed by the bars folding away as the page scrolls;
  a finger across an object turns it, up or down is always the page's; in a
  rail the finger is the rail's; objects far from the screen take their
  planes out (.far); the cart is a bottom sheet pulled down by its head; an
  add from a card brings up a slim bar, not the sheet.

  Public: window.DRAYKI (data, cart, mount, unmount, register, section,
  layout...), and the theme's own contracts: window.openCartDrawer /
  closeCartDrawer / refreshCartUI / changeQty, window.draykiToggleTheme,
  [data-cart-open], [data-cart-count], [data-cart-bubble], #cart-count; it
  listens to shopify:section:load / unload / reorder.
*/
(() => {
  'use strict';
  const W = window, doc = document, root = doc.documentElement;
  const D = (W.DRAYKI = W.DRAYKI || {});
  if (D.ready) return;

  /* ------------------------------------------------------------ utilities */
  const clamp = (x, a, b) => (x < a ? a : x > b ? b : x);
  const seg = (x, a, b) => clamp((x - a) / (b - a), 0, 1);
  const ease = (u) => (u < .5 ? 4 * u * u * u : 1 - Math.pow(-2 * u + 2, 3) / 2);
  const out3 = (u) => 1 - Math.pow(1 - u, 3);
  const smooth = (u) => u * u * (3 - 2 * u);
  const lerp = (a, b, t) => a + (b - a) * t;
  const $ = (s, r = doc) => r.querySelector(s);
  const $$ = (s, r = doc) => Array.from(r.querySelectorAll(s));
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  const store = {
    get(k) { try { return W.localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { W.localStorage.setItem(k, v); } catch (e) { /* private window: fine */ } },
    del(k) { try { W.localStorage.removeItem(k); } catch (e) { /* fine */ } },
  };
  const mqReduce = W.matchMedia('(prefers-reduced-motion: reduce)');
  const mqForced = W.matchMedia('(forced-colors: active)');
  const REDUCE = mqReduce.matches || mqForced.matches;
  // the breakpoints, the same as the style's: a phone (<= 700), the top
  // line's menu (<= 760); the dock's own query; a coarse pointer is a finger
  const mqPhone = W.matchMedia('(max-width: 700px)');
  const mqMenu = W.matchMedia('(max-width: 760px)');
  const mqCoarse = W.matchMedia('(pointer: coarse)');
  const mqDock = W.matchMedia('(max-width: 760px), (min-width: 761px) and (max-width: 1100px) and (max-aspect-ratio: 20/23), (pointer: coarse) and (max-height: 520px)');
  const onMQ = (mq, f) => { if (mq.addEventListener) mq.addEventListener('change', f); else if (mq.addListener) mq.addListener(f); };
  const hex2rgb = (h) => { const n = parseInt(h.slice(1), 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; };
  const mix = (a, b, u) => [0, 1, 2].map((i) => Math.round(a[i] + (b[i] - a[i]) * u));
  const rgb = (c) => `rgb(${c[0]},${c[1]},${c[2]})`;
  const lum = (c) => { const f = (v) => { v /= 255; return v <= .03928 ? v / 12.92 : Math.pow((v + .055) / 1.055, 2.4); }; return .2126 * f(c[0]) + .7152 * f(c[1]) + .0722 * f(c[2]); };

  /* ------------------------------------------------------------- the data */
  // The live catalogue (drayki.com, 2026-09-23), newest first, as the store
  // lists it. title = as the owner writes it, without the registered sign
  // (drayki: "enlève les R entourés à côté de mon pseudo ... et partout");
  // name = the word on the page (the title shown); by = who made it, the
  // line over the name ("drayki", "drayki + arthur vitel", derived below);
  // rim = the cover's dominant colour (the object's body).
  // c = WHAT IS IN THE KIT, the real counts (r7, from each kit's
  // custom.kit_manifest on the live store — ref/kit-contents.md v2, which
  // corrects v1's one-shots): one count per category, always in the order
  // of CATS (808s & bass, kicks, snares & claps, hats, percs, loops, vox,
  // misc, one-shots, samples; 0 = none, never engraved). A file goes by its
  // folder first (the kitmaker's own: "808", "hh & oh", "+one shots"…),
  // then, in a generic folder, by its name ("hhseq" → hats, "chant" → vox,
  // "fx" / "scratch" → misc, "fill" / "roll" → percs), else misc (one-shots
  // in a one-shots pack). "one-shots" are melodic only. Everything else is read
  // from it: n (the total), sounds ("252 sounds"), the rows engraved on a
  // large back, the count on a small one. x = what the kit holds besides
  // sounds (supernova's presets), engraved after the categories on a large
  // back. In the theme: product.title | remove: '®'; the counts computed in
  // Liquid from custom.kit_manifest (the owner keeps it up to date in the
  // admin: Products → the kit → Metafields → kit_manifest); custom.rim.
  /* THEME: the data comes from the page, not from this file. The snippets
     drayki-config (<script type="application/json" id="drayki-config">: the
     tiers and the vault from the theme's "Offres" settings, the money
     format, the routes, HALO's page, the cart, the words) and drayki-catalog
     (id="drayki-catalog": one entry a kit of the kits collection, plus halo
     and, in the vault's "product" mode, the vault product) print it; it is
     read here, once, as this file is evaluated (deferred: the page has been
     parsed). The mockup's written catalogue, tracks and tiers are gone.
     Entries keep the mockup's names (h, name, by, collab, type, kit, price,
     compare, img, rim, line, href) plus rows, n, vid, avail, fresh, x,
     created, and rating / reviews for a kit with reviews (its card's
     rating: rateHTML); c, back and sounds are derived from rows as before.
     Prices are CENTS (Shopify's), written by fmt() in the shop's own format. */
  const readJSON = (sel) => { const el = doc.querySelector(sel); if (!el) return null; try { return JSON.parse(el.textContent || 'null'); } catch (e) { return null; } };
  const CONFIG = readJSON('script#drayki-config') || {};
  // THEME: the words come through Liquid's t filter, which escapes them for
  // HTML ("doesn&#39;t"): read back as plain text here, once — the nested
  // ones too (strings.types). Every word the script writes as HTML goes
  // through esc(); the others are text (textContent, an attribute).
  const unent = (() => {
    const ENT = { quot: '"', amp: '&', lt: '<', gt: '>', apos: "'" };
    const ch = (n) => (n > 0 && n <= 0x10ffff ? String.fromCodePoint(n) : '');
    const one = (s) => s.replace(/&(?:#(\d{1,7})|#x([0-9a-f]{1,6})|(quot|amp|lt|gt|apos));/gi, (m, d, x, n) => (n ? ENT[n.toLowerCase()] : ch(d ? +d : parseInt(x, 16))) || m);
    const all = (v) => (typeof v === 'string' ? one(v) : Array.isArray(v) ? v.map(all) : v && typeof v === 'object' ? Object.fromEntries(Object.keys(v).map((k) => [k, all(v[k])])) : v);
    return all;
  })();
  const STR = unent(CONFIG.strings || {});
  // (a word of locales/en.default.json, printed by drayki-config; the mockup's own if absent)
  const S = (k, fb) => (typeof STR[k] === 'string' ? STR[k] : fb);
  const DESIGN = !!CONFIG.design || !!(W.Shopify && W.Shopify.designMode);
  const TYPE = {
    drumkit: ['drumkit', 'drumkits'],
    808: ['808 library', '808s'],
    oneshots: ['one-shots', 'one-shots'],
    multikit: ['multikit', 'multikits'],
    bundle: ['bundle', 'bundles'],
    plugin: ['plugin', 'plugins'],
  };
  if (STR.types) for (const t in STR.types) if (Array.isArray(STR.types[t])) TYPE[t] = STR.types[t];   // (THEME: kits.types, the locale's words)
  const CATS = ['808s & bass', 'kicks', 'snares & claps', 'hats', 'percs', 'loops', 'vox', 'misc', 'one-shots', 'samples'];
  // HALO's page: the one place its address is written (every "get halo",
  // [data-halo], and the catalogue's halo take it from here) — THEME: the
  // theme's setting halo_page, printed in drayki-config (/pages/halo)
  const HALO_URL = CONFIG.halo_url || '/pages/halo';
  // (THEME: "252 sounds", "1 sound": kits.sounds, one / other)
  const soundsOf = (n) => (n === 1 ? S('sounds_one', '1 sound') : S('sounds_other', '9999 sounds').replace('9999', String(n)));
  // THEME: what a kit holds, from its rows ([category, count], in the order
  // of CATS: custom.kit_counts, or counted here from its manifest): its back
  // (the rows), c (a count a category), n, sounds. No rows (the counts out
  // of date, or none): its total only — never a wrong row.
  function setRows(p, rows, n) {
    const ok = Array.isArray(rows) ? rows.filter((r) => Array.isArray(r) && r.length > 1 && +r[1] > 0).map((r) => [String(r[0]), +r[1]]) : [];
    if (ok.length) {
      p.back = ok;
      p.c = CATS.map((c) => { const r = ok.find((x) => x[0] === c); return r ? r[1] : 0; });
      p.n = ok.reduce((a, r) => a + r[1], 0);
    } else {
      p.back = undefined; p.c = undefined;
      p.n = +n > 0 ? +n : 0;
    }
    p.sounds = p.n ? soundsOf(p.n) : undefined;
    return p;
  }
  const PRODUCTS = (readJSON('script#drayki-catalog') || []).filter((p) => p && p.h);
  PRODUCTS.forEach((p) => {
    p.kit = !['plugin', 'bundle'].includes(p.type) && p.kit !== false;
    p.name = String(p.name || p.h);
    p.title = p.name;
    p.local = p.type === 'plugin';                       // (halo's face: a file of the theme, one width)
    p.rim = p.rim || '#26282f';
    // who made it, the line over the name, never an "=" (drayki: "mets drayki
    // sur les kits où je suis tout seul et enlève les ="): "drayki" over a
    // kit of mine alone, "drayki + arthur vitel" over a collab (THEME: decided
    // once, by the snippet kit-field). p.eq is kept as another name for p.by.
    p.by = p.by || 'drayki';
    p.collab = p.by.includes('+');
    p.eq = p.by;
    p.href = p.href || `/products/${p.h}`;
    p.x = Array.isArray(p.x) && p.x.length ? p.x : undefined;
    p.compare = p.compare > p.price ? p.compare : null;
    setRows(p, p.fresh === false ? null : p.rows, p.n);
  });
  // (THEME: the tracks are read from the page at the start: readTracks)
  const TRACKS = [];
  const BY = Object.fromEntries(PRODUCTS.map((p) => [p.h, p]));
  const KITS = PRODUCTS.filter((p) => p.kit);
  // The tiers, one source (THEME: the theme's settings, Offres, printed in
  // drayki-config; Kaching — or Shopify's discounts — applies the real
  // discount: the tiers here only say what the cart will do). off: a share
  // (.2), the config's is a percentage (20).
  const TIERS = (Array.isArray(CONFIG.tiers) && CONFIG.tiers.length ? CONFIG.tiers : [
    { n: 2, off: 20, label: '2 kits' },
    { n: 3, off: 30, label: '3 kits' },
    { n: KITS.length, off: 50, label: 'the vault', vault: true },
  ]).map((t) => ({ n: +t.n || 0, off: (+t.off || 0) / 100, say: (+(t.say != null ? t.say : t.off) || 0) / 100, label: String(t.label || ''), vault: !!t.vault }));
  // (r8) say: the percentage shown (the vault's: its price against its struck prices — drayki:
  // "modifie le pourcentage affiché sur la page (ça ne change rien à la remise)"); off: the one prices are computed with
  const VAULT = TIERS[TIERS.length - 1];
  // THEME: money. drayki-config gives a price formatted by Liquid's money
  // filter (123456 cents: "€1.234,56", "$1,234.56", "1 234,56 €"…); its
  // symbol, its separators and where they stand are read from it once, and
  // every sum the script writes (in cents) is written the same way.
  const MONEY = (() => {
    let s = String((CONFIG.money && CONFIG.money.sample) || '1.234,56 €');
    try { const ta = doc.createElement('textarea'); ta.innerHTML = s; s = ta.value; } catch (e) { /* as it is */ }
    const m = s.match(/\d[\s\S]*\d/);
    if (!m) return { pre: '', post: ' €', th: '.', dec: ',', d: 2 };
    const mid = m[0], runs = mid.split(/(\D+)/), digits = runs.filter((x, i) => !(i % 2)).join('');
    const d = digits === '123456' ? 2 : 0;
    const th = runs.length >= (d ? 5 : 3) ? runs[1] : '';
    const dec = d && runs.length >= 3 ? runs[runs.length - 2] : '';
    return { pre: s.slice(0, m.index), post: s.slice(m.index + mid.length), th, dec, d };
  })();
  const fmt = (cents) => {
    const v = Math.round(+cents || 0), a = Math.abs(v);
    const int = String(MONEY.d ? Math.floor(a / 100) : Math.round(a / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, MONEY.th);
    return `${v < 0 ? '−' : ''}${MONEY.pre}${int}${MONEY.d ? `${MONEY.dec}${String(a % 100).padStart(2, '0')}` : ''}${MONEY.post}`;
  };
  const r2 = (v) => Math.round(v);                        // (THEME: cents are whole)
  const priceHTML = (p, cls = 'price') => `<span class="${cls}"><b>${esc(fmt(p.price))}</b>${p.compare > p.price ? `<s><span class="vh">${esc(S('was', 'was'))} </span>${esc(fmt(p.compare))}</s>` : ''}</span>`;
  const sumOf = (list) => r2(list.reduce((a, p) => a + (+p.price || 0), 0));
  // (r8: the vault, cmp, strikes the sum of the compare-at prices — drayki: "sur the vault
  // prend plutôt les prix de comparaison"; what it costs stays the prices less its share)
  const sumHTML = (list, off, cmp) => { const s = sumOf(list), c = cmp ? r2(list.reduce((a, p) => a + Math.max(+p.compare || 0, +p.price || 0), 0)) : s; return `<span class="price"><b>${esc(fmt(r2(s * (1 - off))))}</b><s><span class="vh">${esc(S('instead_of', 'instead of'))} </span>${esc(fmt(c))}</s></span>`; };
  const typeLabel = (p) => (TYPE[p.type] || [p.type])[0];
  const metaOf = (k) => `${typeLabel(k)}${k.sounds ? ` · ${k.sounds}` : ''}`;
  // one thickness for every kit (drayki: "l'extrude ne fait pas la même
  // taille sur tous"), in cqi, so it is always the same share of the
  // object's size; and one rounding for every cover's corners (R_KIT, cqi)
  const THICK = 5.2, R_KIT = 4.6;
  const thick = () => THICK;
  // THEME: a cover at a width — the catalogue's address is image_url's 720px
  // one, its width= changed (Shopify's CDN); halo's face is a file of the theme
  const cover = (p, w) => {
    const u = String((p && p.img) || '');
    if (!u || p.local) return u;
    return /[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/, `$1${w}`) : `${u}${u.includes('?') ? '&' : '?'}width=${w}`;
  };
  const COVER_W = [240, 360, 540, 720, 1080, 1440];
  const srcsetOf = (k) => COVER_W.map((x) => `${cover(k, x)} ${x}w`).join(', ');
  const SOUNDS = +CONFIG.sounds || KITS.filter((k) => k.n).reduce((a, k) => a + k.n, 0);   // the sounds, counted (THEME: the kits collection's, drayki-config)
  // THEME: the shop's own addresses (Shopify's routes: a market's prefix comes with them)
  const ROUTES = Object.assign({ root: '/', cart: '/cart', cart_add: '/cart/add', cart_change: '/cart/change', cart_update: '/cart/update', recs: '/recommendations/products', search: '/search' }, CONFIG.routes || {});
  const VAULT_URL = CONFIG.vault_url || `${CONFIG.kits_url || '/collections/all'}#vault`;

  /* ------------------------------------------------------ the manifest */
  // The kit explorer's line format: "~" kit name, "^" root, "/path" a folder,
  // any other line a file in the last folder named.
  const manifests = new Map();
  function manifest(url) {
    if (!manifests.has(url)) {
      manifests.set(url, fetch(url).then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); }).then(parseManifest));
    }
    return manifests.get(url);
  }
  const folderLabel = (s) => { let l = s.replace(/^.*?=\s*/, '').toLowerCase(); if (l === 'oneshots') l = 'one-shots'; if (l === 'drumkit') l = 'drums'; return l; };
  function parseManifest(txt) {
    const m = { name: '', root: '', folders: [], files: [], ext: {} };
    let cur = null;
    for (const raw of txt.split(/\r?\n/)) {
      const l = raw.trim();
      if (!l) continue;
      if (l[0] === '~') { m.name = l.slice(1).trim(); continue; }
      if (l[0] === '^') { m.root = l.slice(1).trim(); continue; }
      if (l[0] === '/') {
        const path = l.slice(1);
        cur = { path, label: folderLabel(path.split('/').pop() || ''), files: [] };
        m.folders.push(cur);
        continue;
      }
      if (!cur) { cur = { path: '', label: '', files: [] }; m.folders.push(cur); }
      cur.files.push(l);
      const ext = (l.match(/\.([a-z0-9]+)$/i) || [, ''])[1].toLowerCase();
      m.ext[ext] = (m.ext[ext] || 0) + 1;
      m.files.push({ folder: cur.path, file: l, ext });
    }
    m.total = m.files.length;
    // THEME: audio is .wav .mp3 .aif .aiff .flac .ogg (the mockup counted .wav only: draykit vol. 3, emerald, nebula and spectra 2 have .mp3s too)
    m.audio = m.folders.filter((f) => f.files.some((x) => AUDIO_RX.test(x))).map((f) => ({ label: f.label, path: f.path, count: f.files.filter((x) => AUDIO_RX.test(x)).length }));
    return m;
  }

  /* THEME: THE BACK'S COUNTS — the rule of work/kit-counts/kit_counts.py
     (ref/kit-contents.md v2, made exact), ported line for line: the same
     rules in the same order (the first that matches wins), the same word
     boundaries (a "word" is letters, digits and "_": "fill_doubleup" is one
     word), the folder's parts deepest first, then the file's name without
     its extension, else misc — one-shots in a pack of one-shots. It gives
     the tool's value on the 20 kits (work/kit-counts/check-countkit.mjs).
     DRAYKI.countKit(text, type) -> { v: 2, n, rows }; DRAYKI.kitCounts() ->
     the value to paste in Products → the kit → Metafields → kit_counts, for
     the product page's kit (in the console: copy(DRAYKI.kitCounts())).
     The theme prints the counts (custom.kit_counts, the snippet kit-field):
     this is the product page's fallback when they are out of date. (The
     rules are built at the first count, in a try: a browser without
     lookbehind in its regular expressions — Safari before 16.4 — only loses
     this fallback.) */
  // THEME: countKit begin
  const AUDIO_EXT = ['.wav', '.mp3', '.aif', '.aiff', '.flac', '.ogg'];
  const AUDIO_RX = /\.(wav|mp3|aif|aiff|flac|ogg)$/i;
  let KC_RULES = null;
  // (Python's str.splitlines: CR LF, LF, VT, FF, CR, the three separators 1C to 1E, NEL and the two Unicode ones)
  const KC_LINES = new RegExp(`\r\n|[\n\v\f\r\x1c-\x1e\x85${String.fromCharCode(0x2028, 0x2029)}]`);
  const kcRules = () => {
    if (KC_RULES) return KC_RULES;
    const B = '(?<![\\p{L}\\p{N}_])', A = '(?![\\p{L}\\p{N}_])';
    const w = (s) => `${B}${s}${A}`;     // a whole word (Python's \bword\b)
    const st = (s) => `${B}${s}`;        // a word that starts so (\bword)
    KC_RULES = [
      ['samples', [w('samples?'), w('chops?')]],
      ['808s & bass', ['808', w('80x'), w('bass(es)?'), w('subs?')]],
      ['kicks', [w('kicks?')]],
      ['snares & claps', [w('snares?'), w('claps?'), w('rims?'), w('snaps?'), w('s\\+c')]],
      ['hats', [st('hh'), w('oh'), w('hats?'), st('cym'), w('ride'), w('shakers?')]],
      ['percs', [w('percs?'), w('toms?'), w('cowbells?'), w('fills?'), w('rolls?'), w('congas?'), w('bongos?')]],
      ['loops', ['loop']],
      ['vox', [w('vox'), w('vocals?'), w('chants?')]],
      ['misc', [w('fx'), st('scratch'), w('risers?'), w('lasers?'), w('stomps?')]],
      ['one-shots', ['one ?shots?', w('synths?'), w('keys'), w('bells?'), w('pads?'), w('plucks?'), w('strings'), w('textures?'), w('melody'), w('runs'), w('accents?')]],
    ].map(([c, ps]) => [c, new RegExp(ps.join('|'), 'iu')]);
    return KC_RULES;
  };
  const kcMatch = (t) => { for (const [c, rx] of kcRules()) if (rx.test(t)) return c; return null; };
  // (Python's os.path.splitext: the last dot after the last separator, never
  // a leading one — ".wav" alone has no extension)
  const kcStem = (f) => {
    const sep = Math.max(f.lastIndexOf('/'), f.lastIndexOf('\\')), dot = f.lastIndexOf('.');
    if (dot > sep) for (let i = sep + 1; i < dot; i++) if (f[i] !== '.') return f.slice(0, dot);
    return f;
  };
  function countKit(text, type) {
    try { kcRules(); } catch (e) { return null; }
    const one = String(type || '').trim().toUpperCase() === 'ONESHOTS';
    const n = Object.fromEntries(CATS.map((c) => [c, 0]));
    let folder = '/';
    for (const raw of String(text || '').split(KC_LINES)) {
      const line = raw.trim();
      if (!line || line[0] === '~' || line[0] === '^') continue;
      if (line[0] === '/') { folder = line; continue; }
      const low = line.toLowerCase();
      if (!AUDIO_EXT.some((x) => low.endsWith(x))) continue;
      let cat = null;
      const segs = folder.split('/').filter(Boolean);
      for (let i = segs.length - 1; i >= 0 && !cat; i--) cat = kcMatch(segs[i]);
      if (!cat) cat = kcMatch(kcStem(line));
      n[cat || (one ? 'one-shots' : 'misc')] += 1;
    }
    const rows = CATS.filter((c) => n[c]).map((c) => [c, n[c]]);
    return { v: 2, n: rows.reduce((a, r) => a + r[1], 0), rows };
  }
  // THEME: countKit end
  // THEME: the manifest printed in a product page (snippet manifest-inline:
  // <script type="text/plain" data-manifest>, its "</" written "<\/"), its
  // text and its kit (data-manifest="handle", or the explorer beside it,
  // #kitx-handle)
  const manifestText = (el) => String((el && el.textContent) || '').replace(/<\\\//g, '</');
  const manifestKit = (el) => {
    const v = el.getAttribute('data-manifest');
    if (v && v !== 'inline') return v;
    const s = el.closest('.shopify-section, section') || doc, x = $('[id^="kitx-"]', s) || $('[id^="kitx-"]');
    return x ? x.id.slice(5) : '';
  };
  // THEME: the kits counted on this page from their manifest, when the
  // theme's counts are out of date or missing (the catalogue says fresh:
  // false, or the object has no data-back): the product page's back stays
  // whole before the owner has pasted the new value
  const LIVE = {};
  function liveCounts() {
    for (const el of $$('script[type="text/plain"][data-manifest]')) {
      const h = manifestKit(el);
      if (!h || LIVE[h]) continue;
      const k = BY[h], objs = $$('.kit[data-kit]').filter((o) => o.dataset.kit === h && o.dataset.shape !== 'halo');
      const need = (k && k.kit && (k.fresh === false || !k.back)) || objs.some((o) => o.dataset.fresh === 'false' || !o.dataset.back);
      if (!need) continue;
      const r = countKit(manifestText(el), (k && k.type) || (objs[0] && objs[0].dataset.type) || '');
      if (!r || !r.n) continue;
      LIVE[h] = r;
      if (k) setRows(k, r.rows, r.n);
    }
  }
  function kitCounts() {
    const el = $('script[type="text/plain"][data-manifest]');
    if (!el) return null;
    const h = manifestKit(el), k = BY[h], o = $$('.kit[data-kit]').find((x) => x.dataset.kit === h);
    const r = countKit(manifestText(el), (k && k.type) || (o && o.dataset.type) || '');
    return r ? JSON.stringify(r) : null;
  }
  // THEME: an object's kit — its own data- first (printed by the snippet
  // kit-object: data-name, data-by, data-type, data-rim, data-back, data-n,
  // data-x, data-href, data-shape), the catalogue's by data-kit second (a
  // hero's carousel, a stack's tiles, an object written by hand)
  function kitOf(el) {
    const ds = el.dataset, base = BY[ds.kit] || null;
    const k = Object.assign({ h: ds.kit || '', name: ds.kit || '', by: S('by_default', 'drayki'), type: '', rim: '#26282f', href: '' }, base || {});
    if (ds.name) k.name = ds.name;
    if (ds.by) { k.by = ds.by; k.eq = ds.by; k.collab = ds.by.includes('+'); }
    if (ds.type) k.type = ds.type;
    if (ds.rim) k.rim = ds.rim;
    if (ds.href) k.href = ds.href;
    if (ds.shape === 'halo') k.local = true;
    k.kit = !['plugin', 'bundle'].includes(k.type);
    let rows = null, x = null;
    try { rows = ds.back ? JSON.parse(ds.back) : null; } catch (e) { rows = null; }
    try { x = ds.x ? JSON.parse(ds.x) : null; } catch (e) { x = null; }
    if (rows && ds.fresh !== 'false') setRows(k, rows, ds.n);
    else if (LIVE[k.h]) setRows(k, LIVE[k.h].rows, LIVE[k.h].n);
    else if (ds.n || ds.fresh === 'false') setRows(k, null, ds.n);
    if (Array.isArray(x)) k.x = x.length ? x : undefined;
    return k;
  }
  /* ------------------------------------------------------------- engine */
  const E = { Y: W.scrollY, S: W.scrollY, V: 0, vh: W.innerHeight, vw: W.innerWidth, fx: [], raf: 0, last: 0, restT: 0, layT: 0, dirty: false };
  const io = 'IntersectionObserver' in W ? new IntersectionObserver((es) => {
    for (const e of es) (e.target._fx || []).forEach((f) => { f.seen = e.isIntersecting; if (f.onSeen) f.onSeen(e.isIntersecting); });
    wake();
  }, { rootMargin: '30% 0px 30% 0px' }) : null;
  // Cheap layers: an object or a stack more than a screen and a half from
  // the screen (three quarters on a phone), or a screen across in a rail,
  // has its planes taken out of the page (.far: display none on its planes,
  // its box untouched), so a phone composites only the few near the eye.
  // No frame, no rAF: the observer alone.
  const farIO = 'IntersectionObserver' in W ? new IntersectionObserver((es) => {
    for (const e of es) { e.target.classList.toggle('far', !e.isIntersecting); if (e.isIntersecting && e.target._stack) e.target._stack.preload(); }
  }, { rootMargin: mqPhone.matches ? '75% 100% 75% 100%' : '150% 100% 150% 100%' }) : null;
  const sleepFar = (el) => { if (farIO && !el.closest('.drawer, [data-hero]')) farIO.observe(el); };
  // register(effect, element, first): one more entry in the loop, seen while
  // the element is near the screen (or always, without an element). An
  // effect is { frame(now, dt) -> busy, layout?(), settle?(), onSeen?(seen) }.
  function register(f, el, first) {
    f.seen = !io || !el || !!f.always;
    f.el = el || f.el || null;
    if (first) E.fx.unshift(f); else E.fx.push(f);
    if (io && el && !f.always) { el._fx = (el._fx || []).concat(f); io.observe(el); }
    if (f.layout && D.ready) f.layout();
    wake();
    return f;
  }
  function unregister(f) { if (f) { f.dead = true; E.dirty = true; } }
  // every effect, object and observer under a scope let go (a section taken
  // out in the theme's editor)
  function unmount(scope) {
    for (const f of E.fx) if (f.el && scope.contains(f.el)) { f.dead = true; if (io) io.unobserve(f.el); }
    for (const el of $$('.kit, .stack', scope)) { if (farIO) farIO.unobserve(el); if (el._obj) el._obj.stopCycle(); }
    mwUnmount(scope);
    E.dirty = true;
  }
  function wake() {
    if (!E.raf && !doc.hidden) { E.last = performance.now(); E.raf = W.requestAnimationFrame(tick); }
  }
  function follow(dt) {
    if (E.S === E.Y && E.V === 0) return false;
    const w = 15, n = Math.max(1, Math.ceil(dt * 240)), h = dt / n, to = E.Y;
    let x = E.S, v = E.V;
    for (let i = 0; i < n; i++) { v += (w * w * (to - x) - 2 * w * v) * h; x += v * h; }
    const L = E.vh * .6;                                  // never more than .6 of a screen behind
    if (x < to - L) x = to - L; else if (x > to + L) x = to + L;
    if (Math.abs(to - x) < .2 && Math.abs(v) < 3) { x = to; v = 0; }
    E.S = x; E.V = v;
    return true;
  }
  function tick(now) {
    E.raf = 0;
    const dt = Math.min(.05, Math.max(.001, (now - E.last) / 1000));
    E.last = now;
    let busy = follow(dt);
    for (let i = 0; i < E.fx.length; i++) {
      const f = E.fx[i];
      if (!f.dead && (f.seen || f.hot) && f.frame(now, dt)) busy = true;
    }
    if (E.dirty) { E.fx = E.fx.filter((f) => !f.dead); E.dirty = false; }
    if (busy) { E.last = now; E.raf = W.requestAnimationFrame(tick); }
  }
  function atRest() { for (const f of E.fx) if (!f.dead && typeof f.settle === 'function') f.settle(); wake(); }
  function layout() {
    // E.vh is the screen's height as KEPT (see setVH): a phone's bars
    // folding away as the page scrolls are not a new screen, so nothing
    // read off the scroll jumps under the reader's thumb
    E.vh = E.kh || W.innerHeight; E.vw = W.innerWidth; E.Y = W.scrollY;
    fitWords();
    fitDrawings();
    for (const f of E.fx) if (!f.dead && f.layout) f.layout();
    headerLayout();
    wake();
  }
  function layoutSoon(ms = 90) { clearTimeout(E.layT); E.layT = setTimeout(layout, ms); }

  // An arrival that happens once: read off the scroll (from a top at `a` of
  // the screen to `b`), never faster than `min` seconds for the whole,
  // finished on its own clock at rest, then gone from the loop.
  class Once {
    constructor(el, write, min, a, b) { this.el = el; this.w = write; this.min = min || 1.1; this.a = a == null ? .96 : a; this.b = b == null ? .4 : b; this.p = 0; }
    layout() { const r = this.el.getBoundingClientRect(); this.top = r.top + W.scrollY; }
    frame(now, dt) {
      if (this.done) return false;
      const tgt = seg((this.top - E.S) / E.vh, this.a, this.b);
      const cap = this.p + dt / this.min;
      const p = this.fin ? Math.min(1, cap) : Math.max(this.p, Math.min(tgt, cap));
      if (p !== this.p) { this.p = p; this.w(p); }
      if (p >= 1) { this.done = true; this.dead = true; this.hot = false; E.dirty = true; return false; }
      const busy = this.fin || p < tgt;
      this.hot = busy;
      return busy;
    }
    settle() { if (!this.done && this.p > 0 && this.seen) { this.fin = true; this.hot = true; } }
  }

  /* -------------------------------------------------- the section words */
  // On a phone the words are a quarter of the width (--t-word); a long one
  // is brought down just enough to stay inside the gutter, never cut, never
  // wrapped. All reset, then all read, then all written.
  function fitWords() {
    const ws = $$('.ttl .word');
    if (!ws.length) return;
    ws.forEach((w) => w.style.removeProperty('--wf'));
    const m = ws.map((w) => { const s = $('.w', w) || w; return [w, s.offsetWidth, w.clientWidth]; });
    for (const [w, need, room] of m) if (need > 0 && room > 0 && need > room) w.style.setProperty('--wf', (Math.floor(room / need * 1000) / 1000 - .005).toFixed(3));
  }

  /* ------------------------------------------------------------ lighting */
  // A light fixed in the room (up and to the right, in front). Only the rim
  // takes it: never the face. Shades are quantised and written on change.
  const LIGHT = (() => { const v = [.52, -.5, .69], m = Math.hypot(...v); return v.map((x) => x / m); })();
  const R3 = {
    x(a) { const c = Math.cos(a), s = Math.sin(a); return [1, 0, 0, 0, c, -s, 0, s, c]; },
    y(a) { const c = Math.cos(a), s = Math.sin(a); return [c, 0, s, 0, 1, 0, -s, 0, c]; },
    z(a) { const c = Math.cos(a), s = Math.sin(a); return [c, -s, 0, s, c, 0, 0, 0, 1]; },
    mul(A, B) {
      const r = new Array(9);
      for (let i = 0; i < 3; i++) for (let j = 0; j < 3; j++) r[i * 3 + j] = A[i * 3] * B[j] + A[i * 3 + 1] * B[3 + j] + A[i * 3 + 2] * B[6 + j];
      return r;
    },
  };
  const DEG = Math.PI / 180;
  const shadeCache = new Map();
  // the rim's gradient runs from the back (top of the plane) to the face (its
  // foot): deep at the back, the body's colour, a hairline of light at the lip.
  const tone = (hex, d, graphite) => {
    const c = hex2rgb(hex);
    const dark = graphite ? [19, 20, 25] : mix(c, [16, 12, 38], .66);
    const lit = graphite ? [54, 57, 67] : mix(c, [255, 255, 255], .1);
    const base = mix(dark, lit, Math.pow(d, 1.2));
    const lip = mix(base, [246, 245, 252], (graphite ? 0 : .1) + Math.pow(d, 2.2) * (graphite ? .75 : .5));
    return { back: mix(base, [8, 6, 22], .4), base, lip };
  };
  function shades(hex, LV) {
    const key = hex + LV;
    if (shadeCache.has(key)) return shadeCache.get(key);
    const graphite = hex.toLowerCase() === '#26282f', out = [];
    for (let i = 0; i <= LV; i++) {
      const t = tone(hex, i / LV, graphite);
      out.push(`linear-gradient(${rgb(t.back)},${rgb(t.base)} 68%,${rgb(t.base)} 91%,${rgb(t.lip)} 96%,${rgb(t.lip)})`);
    }
    shadeCache.set(key, out);
    return out;
  }
  // thin planes standing on the rounded outline, facing out (HALO's rim).
  // w, h, R in cqi; n chords a corner (see chords()); each plane is a little
  // longer than its share (ov, in cqi, plus --ov, a pixel and a half of
  // the object's own) so no two leave a seam where their smoothed ends
  // meet; tuck puts each plane just inside the face's outline, so the
  // face's own smoothed edge lies over the rim and no ground shows between
  // them; and it stops DS short of the face and of the back, so no pixel
  // of it is ever drawn through them (level with the face, its edge came
  // through the face's smoothed edge as a dotted line). Its two ends are
  // drawn inside a clear pixel (its transparent side borders, .kit-rim),
  // smoothed where the chords meet; its long edges are not (seen side-on,
  // a clear pixel there is squeezed to a dotted line: the plates do it).
  const DS = .3;   // (the rim stops a hair short of the face and the back: never level with them, never through them)
  // (r6, drayki: "les cover dépassent un peu de l'extrude") The rim stands
  // ON the face's outline, never inside it: the runs exactly on its edges
  // (tk = 0), and each corner's chords laid across the face's rounded
  // corner as closely as they can be — half in, half out of the arc (the
  // polygon that strays least from it: a hundredth of the radius with four
  // chords). Before, the chords lay wholly inside the arc and the rim was
  // tucked in by .14cqi: the cover's corner stood out past the rim wherever
  // the rim met the ground (up to 3px on a laptop's hero). The seam the
  // tuck used to hide (the face's smoothed edge over the ground) is now
  // the face's own edge: a pixel of the body's colour round the cover
  // (.kit-fc::after in the style), so what shows there is the slab.
  // (r7, a stack's tile: fit = true. drayki: "y a un problème sur les coins
  // des kits dans le stack bundle, on dirait qu'ils sont bugués". Its corner
  // is a few pixels round, and the object's rule above — chords half out of
  // the arc, each .2cqi and a pixel and a half longer than its share — made
  // every chord nearly twice its length there: their ends stood out past
  // the cover and past the next plane, a notch at every joint, a step in
  // the lip at every chord, a column of teeth down the vault. A tile's
  // corner is the polygon INSCRIBED in the cover's arc: each chord's two
  // ends exactly on the arc, the runs exactly the straight edges, nothing
  // longer than its share but the overlap that closes a joint (--ov, a
  // device pixel at each end, .tile .kit-rim in the style). The cover lies
  // over the whole rim, never a hair of it past the cover's edge.)
  function buildRim(host, w, h, R, n, ds = DS, fit = false) {
    const P = [], ov = fit ? 0 : .2, tk = 0;
    // (p0, p1: the directions of the plane's two ends — a chord's run from
    // one to the other round its corner; a straight run faces one way)
    const add = (cx, cy, len, phi, p0 = phi, p1 = phi) => P.push({ cx, cy, len, phi, p0, p1 });
    add(w / 2, tk, w - 2 * R + ov, -Math.PI / 2);
    add(w - tk, h / 2, h - 2 * R + ov, 0);
    add(w / 2, h - tk, w - 2 * R + ov, Math.PI / 2);
    add(tk, h / 2, h - 2 * R + ov, Math.PI);
    if (n > 0 && R > 0) {
      const st = Math.PI / 2 / n;
      const rr = fit ? R * Math.cos(st / 2) : (R - tk) * (1 + Math.cos(st / 2)) / 2;
      const cl = fit ? 2 * R * Math.sin(st / 2) : 2 * rr * Math.tan(st / 2) + ov;
      for (const [ox, oy, a0] of [[w - R, R, -Math.PI / 2], [w - R, h - R, 0], [R, h - R, Math.PI / 2], [R, R, Math.PI]]) {
        for (let k = 0; k < n; k++) { const a = a0 + (k + .5) * st; add(ox + rr * Math.cos(a), oy + rr * Math.sin(a), cl, a, a - st / 2, a + st / 2); }
      }
    }
    const frag = doc.createDocumentFragment();
    const rim = P.map((p) => {
      const el = doc.createElement('i');
      el.className = 'kit-rim';
      el.style.cssText = `left:calc(${(p.cx - p.len / 2).toFixed(3)}cqi - var(--ov) / 2 - 1px);top:calc(${p.cy.toFixed(3)}cqi - var(--d) / 2 + ${ds / 2}cqi);` +
        `width:calc(${p.len.toFixed(3)}cqi + var(--ov));height:calc(var(--d) - ${ds}cqi);` +
        `transform:rotateZ(${(p.phi + Math.PI / 2).toFixed(5)}rad) rotateX(90deg)`;
      frag.appendChild(el);
      return { el, nx: Math.cos(p.phi), ny: Math.sin(p.phi), lv: -1, cn: p.p0 !== p.p1, ax: Math.cos(p.p0), ay: Math.sin(p.p0), bx: Math.cos(p.p1), by: Math.sin(p.p1) };
    });
    host.appendChild(frag);
    return rim;
  }
  const rimLevel = (e, M, LV) => {
    const qx = M[0] * e.nx + M[1] * e.ny, qy = M[3] * e.nx + M[4] * e.ny, qz = M[6] * e.nx + M[7] * e.ny;
    const l = Math.max(0, qx * LIGHT[0] + qy * LIGHT[1] + qz * LIGHT[2]) * (1 - .45 * Math.max(0, qz));
    return Math.round(clamp(.06 + .94 * l, 0, 1) * LV);
  };
  function shadeRim(rim, M, hex, LV) {
    const S = shades(hex, LV);
    for (const e of rim) {
      const lv = rimLevel(e, M, LV);
      if (lv !== e.lv || e.hex !== hex) { e.lv = lv; e.hex = hex; e.el.style.backgroundImage = S[lv]; }
    }
  }
  // (r7) A STACK'S TILES, shaded without steps round their corners (drayki:
  // "y a un problème sur les coins des kits dans le stack bundle, on dirait
  // qu'ils sont bugués"): a tile's corner is three planes (two on the
  // vault's twenty), each in one flat shade, so a corner read as stripes —
  // three strips of different darkness with a seam between each, on a
  // corner five pixels round. Here each plane of a corner runs from the
  // light at its one end to the light at its other (its two ends' own
  // directions), so the shade flows from one side of the tile round to the
  // other as it would on a rounded slab, and the seams have nothing to
  // show. The same back-to-lip darkening over it (the tone's own, as a
  // veil: back = the base under 40 % of the indigo shadow; the lip, a veil
  // of light as strong as the plane is lit).
  // (r7, the lip too: its light runs from one end of the plane to the other
  // as the body's shade does — a band of the plane's last 9 % toward the
  // cover, placed by the style, .tile .kit-rim —, so the hairline of light
  // along the tile's top edge goes round the corner in one line, never a
  // dash per chord at its own brightness)
  const flowCache = new Map();
  function flowBg(hex, LV, l0, l1) {
    const key = `${hex}|${LV}|${l0}|${l1}`;
    let v = flowCache.get(key);
    if (v) return v;
    const g = hex.toLowerCase() === '#26282f', a = tone(hex, l0 / LV, g), b = tone(hex, l1 / LV, g);
    const lip = (l) => ((g ? 0 : .1) + Math.pow(l / LV, 2.2) * (g ? .75 : .5)).toFixed(3);
    v = `linear-gradient(90deg,rgba(246,245,252,${lip(l0)}),rgba(246,245,252,${lip(l1)})),linear-gradient(rgba(8,6,22,.4),rgba(8,6,22,0) 68%),` +
      (l0 === l1 ? `linear-gradient(${rgb(a.base)},${rgb(a.base)})` : `linear-gradient(90deg,${rgb(a.base)},${rgb(b.base)})`);
    flowCache.set(key, v);
    return v;
  }
  function shadeFlow(rim, M, hex, LV) {
    for (const e of rim) {
      const l0 = e.cn ? rimLevel({ nx: e.ax, ny: e.ay }, M, LV) : rimLevel(e, M, LV), l1 = e.cn ? rimLevel({ nx: e.bx, ny: e.by }, M, LV) : l0;
      const k = l0 * 256 + l1;
      if (k !== e.lv || e.hex !== hex) { e.lv = k; e.hex = hex; e.el.style.backgroundImage = flowBg(hex, LV, l0, l1); }
    }
  }
  // The rim's far edge, seen against the ground, is the edge of a plane
  // seen nearly side-on: no clear margin can smooth it (its pixels are
  // squeezed tenfold that way). On a screen of less than 2x — where a pixel
  // shows — two plates stand at the rim's two ends, a hair wider than it,
  // facing out, in its darkest tone (.kit-pl): seen from the front, the
  // outline against the ground is the back plate's, drawn nearly face-on
  // and smoothed like the face; the rim's own hard edge lies over it, in
  // the same tone. Never where WebKit draws (Safari, any iPhone browser):
  // it can sort a plane behind the face in front of it (see write), and a
  // 2x or 3x screen has the pixels anyway.
  const UA = navigator.userAgent || '';
  const WEBKIT = /iPhone|iPad|iPod/.test(UA) || (/Macintosh/.test(UA) && navigator.maxTouchPoints > 1) || (/AppleWebKit/.test(UA) && !/Chrome|Chromium|Edg\/|Firefox/.test(UA));
  const PLATES = !WEBKIT && (W.devicePixelRatio || 1) < 1.9;
  // (the object's own scale K: see build. 1 where WebKit draws: it keeps
  // the object's planes out of a size container, whose containment it
  // could take as a reason to flatten them)
  const superK = (s) => (WEBKIT || (W.devicePixelRatio || 1) >= 2.5 ? 1 : 1 / s);
  // How many chords round a corner: as many as it takes for the chords to
  // stay within 0.4 of a screen pixel of the true curve (rpx: the corner's
  // radius as drawn, in CSS px; the screen's density counts), three at
  // least, six at most — a phone's card takes four, a laptop's hero six.
  const chords = (rpx) => { const r = rpx * Math.min(3, W.devicePixelRatio || 1); return r > .6 ? clamp(Math.ceil((Math.PI / 4) / Math.acos(Math.max(-1, 1 - .4 / r))), 3, 6) : 3; };
  // The engraving on the back: the body's own colour, taken toward ink (a
  // light body) or toward white (a dark one) until it reads at 4.6:1 at
  // least (WCAG's 4.5, with room), whichever side has the more room; a
  // one-pixel bevel keeps it engraved. (The old tint read at 1.4–2.7:1.)
  const contrast = (a, b) => { const x = lum(a), y = lum(b); return (Math.max(x, y) + .05) / (Math.min(x, y) + .05); };
  const INK = [9, 6, 24], PALE = [255, 255, 255];
  const engrave = (hex) => {
    const c = hex2rgb(hex);
    const dark = contrast(c, INK) >= contrast(c, PALE), to = dark ? INK : PALE;
    let u = .35, ink = mix(c, to, u);
    while (contrast(c, ink) < 4.6 && u < 1) { u = Math.min(1, u + .01); ink = mix(c, to, u); }
    return dark
      ? { ink: rgb(ink), sh: '0 calc(var(--K, 1) * 1px) 0 rgba(255,255,255,.2)' }
      : { ink: rgb(ink), sh: '0 calc(var(--K, 1) * -1px) 0 rgba(0,0,0,.35)' };
  };

  /* ---------------------------------------------------------- the object */
  // A kit: a square tile — its face, its back, 4 runs and 3 to 6 chords
  // round each rounded corner (see chords), and on a screen under 2x two
  // plates at the rim's ends (PLATES) — all kits the same thickness, the
  // same corners. HALO: the landscape slab. Pose = the rest pose (data-pose
  // "rx ry rz", degrees), laid back by the scroll as it comes in, plus the
  // hand's turn (world pitch and yaw) which always springs home.
  const DEF_POSE = [20, -28, 1];
  const FLAT = { rx: 78, ry: 14, rz: -5 };       // lying on the table, face up (see lie())
  let objN = 0;
  // AN OVERLAY over the page — the cart (sheet or drawer), the phone's
  // menu, any open dialog: a cover that cycles holds still under it (no
  // turn starts; one under way ends), and goes on a full wait after it
  // closes. The cart and the menu say when they open and close
  // ('drayki:overlay'); a turn already due checks again.
  const CYC = new Set();
  const overlaid = () => root.classList.contains('lock') || !!(TOP && TOP.classList.contains('open')) || !!doc.querySelector('dialog[open]');
  const overlayChanged = () => W.dispatchEvent(new CustomEvent('drayki:overlay', { detail: { open: overlaid() } }));
  W.addEventListener('drayki:overlay', () => {
    const on = overlaid();
    for (const C of CYC) { clearTimeout(C.t); C.t = on ? 0 : setTimeout(C.next, C.every); }
  });
  const pose3 = (s) => { const p = (s || '').trim() ? s.trim().split(/\s+/).map(Number) : []; return p.length === 3 && p.every(isFinite) ? p : null; };
  class Obj {
    constructor(el) {
      this.el = el; el._obj = this; this.n = ++objN;
      const ds = el.dataset;
      // THEME: halo by its shape (printed for a PLUGIN), its handle or its type;
      // its kit: its own data- first, the catalogue second (kitOf)
      this.halo = ds.shape === 'halo' || ds.kit === 'halovst' || !!(BY[ds.kit] && BY[ds.kit].type === 'plugin');
      if (this.halo) ds.shape = 'halo';
      this.k = kitOf(el);
      const pose = pose3(ds.pose) || [];
      const def = this.halo ? [26, -14, 3] : DEF_POSE;
      this.rest = { rx: isFinite(pose[0]) ? pose[0] : def[0], ry: isFinite(pose[1]) ? pose[1] : def[1], rz: isFinite(pose[2]) ? pose[2] : def[2] };
      this.from = pose3(ds.layFrom);
      this.s = ds.scale ? +ds.scale : .78;
      this.lay = !REDUCE && !('travel' in ds) && (!!this.from || ds.lay !== 'off');
      this.grid = !!el.closest('.shelf:not(.rail)');
      // a card's object (a shelf, a rail, a board: data-shelf's .item, or
      // data-enter on the object): it comes in lying back and stands up as
      // its card comes up the screen (see layPose)
      this.card = !!el.closest('.item') || 'enter' in ds;
      this.lag = 0;
      this.turn = ds.turn !== 'off';
      this.LV = +(ds.lv || (this.halo ? 64 : 32));
      this.drag = { y: 0, p: 0, vy: 0, vp: 0, gy: 0, gp: 0, mode: 0, ct: 0 };
      this.driver = null; this.spin = null; this.intro = null; this.la = null; this.lk = 0; this.gk = 0;
      this.lastT = ''; this.sh = null;
      this.build();
      if (this.turn) this.bindHand();
      this.write(this.rest.rx, this.rest.ry, this.rest.rz);
    }
    build() {
      const el = this.el, k = this.k, ds = el.dataset;
      el.classList.add('kit');
      const w = 100, h = this.halo ? 100 * 680 / 1100 : 100;
      const R = this.halo ? 1.3 : R_KIT;
      const width = el._w || el.getBoundingClientRect().width || 200;
      this.bw = width;
      this.size = this.sizeOf(width); this.fbw = width;
      this.small = this.size !== 'lg';
      el.classList.toggle('sm-back', this.small); el.classList.toggle('xs-back', this.size === 'xs');
      // drawn at the size it is shown (HALO's way, measured here): the
      // object is laid out K times its box and brought back down by its own
      // transform (scale s / K), so its pictures are drawn at the pixels
      // they are shown at, one to one at rest — the cover, the rounded
      // corners and the clear margins smoothed by the browser at their own
      // size. (K = 1 / s: laid out any larger, 2x as HALO's slab, the edge a
      // browser smooths over one of its pixels came down to 0.4 of one and
      // read as steps; a 3x phone keeps K = 1: its pixels are fine enough,
      // and each cover's memory is kept.) data-k="1" turns it off.
      this.K = ds.k ? Math.max(1, +ds.k || 1) : superK(this.s);
      el.style.setProperty('--K', String(this.K));
      el.classList.toggle('kk', this.K !== 1);
      // (the plates' margin: a pixel of the screen, in the object's own)
      if (PLATES) el.style.setProperty('--pm', `${(1.1 * this.K / this.s).toFixed(2)}px`);
      const lazy = ds.eager === undefined && !el.closest('[data-hero]');
      // the cover: a server-rendered <img> inside .kit is adopted (the theme
      // prints it, so it is found early and shows flat without the script);
      // else it is written, at the width drawn (see sizesFor)
      const pre = $(':scope > img', el);
      let img;
      if (pre) { pre.alt = ''; pre.draggable = false; if (!pre.sizes && !k.local) pre.sizes = this.sizesFor(width); img = pre; }
      const imgHTML = pre || !k.img ? '' : k.local   // THEME: no cover, no picture (the body's colour shows)
        ? `<img src="${esc(k.img)}" alt="" width="2400" height="1484" decoding="async" draggable="false"${lazy ? ' loading="lazy"' : ''}>`
        : `<img src="${cover(k, 720)}" srcset="${srcsetOf(k)}" sizes="${this.sizesFor(width)}" alt="" width="1080" height="1080" decoding="async" draggable="false"${lazy ? ' loading="lazy"' : ''}>`;
      // who can reach it: a showcase object (a hero, halo, a landing) is one
      // tab stop that turns under the arrow keys; a copy (data-focus="off")
      // and every object in a shelf or a rail are not (the name and the add
      // key next to it say the same)
      const quiet = ds.focus === 'off' || !!el.closest('.shelf, .rail, .rail-sm, .item, .drawer');
      const focus = this.turn && !quiet;
      const name = this.halo ? 'halo' : k.name;
      const rows = this.halo ? '' : (k.back || []).concat(k.x || []).map(([a, b]) => `${a} ${b}`).concat(k.n ? [k.sounds] : []).concat([`by ${k.by}`]).join(', ');
      const help = `${S('object_help', 'drag, or use the arrow keys, to turn it.')}${rows ? ` ${S('on_its_back', 'on its back: {rows}').replace('{rows}', rows)}.` : ''}`;   // THEME: the locale's words
      el.innerHTML = `<div class="kit-scene"${focus ? ` tabindex="0" role="group" aria-roledescription="3d object" aria-label="${esc(name)}" aria-describedby="obj-d${this.n}"` : quiet ? ' aria-hidden="true"' : ` role="img" aria-label="${esc(name)}"`}>` +
        (focus ? `<span class="vh" id="obj-d${this.n}">${esc(help)}</span>` : '') +
        `<i class="kit-ground" aria-hidden="true"></i><div class="kit-obj">${PLATES ? '<i class="kit-pl b"><i></i></i><i class="kit-pl f"><i></i></i>' : ''}<div class="kit-face"><i class="kit-fc">${imgHTML}</i></div>` +
        `<div class="kit-back" aria-hidden="true"><div class="kit-bc">${this.backHTML()}</div></div></div></div>`;
      this.scene = el.firstElementChild;
      this.objEl = $('.kit-obj', el);
      this.faceBox = $('.kit-face', el);
      if (img) $('.kit-fc', el).appendChild(img);
      this.face = $('img', this.faceBox);
      this.ground = $('.kit-ground', el);
      // (the rounded corners in chords, as many as the corner's size on
      // the screen needs to be a curve: see chords())
      this.rim = buildRim(this.objEl, w, h, R, chords(R / 100 * width * this.s));
      this.back = $('.kit-back', el); this.backIn = $('.kit-bc', el); this.facing = true;
      this.paint();
      el.classList.add('built');
      sleepFar(el);
      // (data-hint: on a touch screen, once per viewer, a quiet line under the
      // object says it turns; gone with the first turn. Nothing moves.)
      if ('hint' in ds && this.turn && mqCoarse.matches && !store.get('drayki-turned')) {
        this.hint = doc.createElement('p'); this.hint.className = 'kit-hint'; this.hint.textContent = S('drag_hint', 'drag to turn');
        el.appendChild(this.hint);
      }
    }
    // the cover's width as drawn, and a fifth more for the turn's near edge
    // (except on a 3x phone screen, where the fifth cannot be seen and would
    // pick the next width up: half the memory for each card)
    sizesFor(width) { return `${Math.round(width * this.s * ((W.devicePixelRatio || 1) >= 2.5 ? 1 : 1.2))}px`; }
    // the link a press on the object follows: its card's (or shelf item's)
    // title; none for a travelling object, or with data-link="off"
    link() {
      if (this.el.dataset.link === 'off' || this.el.hasAttribute('data-travel')) return null;
      const box = this.el.closest('.card, .item, [data-shelf]');
      return box ? $('.capt a[href], .hd a[href]', box) : null;
    }
    // THE BACK (r6, drayki: "sur le back des covers sur desktop garde les
    // énumérations du contenu ; sur mobile : nom du kit, nombre de sons juste
    // en dessous, nom des kitmakers, enlève le wav, mets juste le tag sous le
    // nom du kit"; r7: "sur mobile je préférerais le type de kit avant le
    // nombre de sons"). Three sizes, by the object's own width:
    //   lg (385px and more, wider than a phone: a hero, a large object — its
    //      rows at 4cqi read at 12px from 385px): the name, its tag, then the
    //      contents one row a category ("808s & bass 44", "snares & claps
    //      54"), in the order of CATS, a category at 0 left out, the total
    //      ("252 sounds"), and who made it at the foot;
    //   sm (250px and more on a phone — its hero too —, 250–385px wider: a
    //      laptop's card) and xs (under 250: a phone's card, a small laptop's):
    //      the name, its TAG right under it ("multikit"), then its count
    //      ("252 sounds"), and who made it at the foot; between them the
    //      contents, in one wrapped line, where they fit at a size that reads
    //      (never under 12px on the screen): every category if they fit,
    //      else the families (808s; drums — kicks to misc, loops and vox
    //      with them —; one-shots; samples), else none (a phone's card: no
    //      room at 12px, it shows the four lines only).
    // Never "wav". The ink reads at 4.6:1 at least on every kit (engrave).
    // (r8, drayki: "sur mobile les backs doivent être les mêmes que sur desktop") an object on
    // its own (a page's, never a card's) has its whole back on a phone too, as it has wide
    sizeOf(w) { return this.halo || w >= 385 || (!this.card && w >= 240) ? 'lg' : w >= 250 ? 'sm' : 'xs'; }
    backHTML() {
      const k = this.k;
      if (this.halo) {
        return '<b class="en">halo</b><ul class="tb"><li class="ft"><span>hybrid synth / sampler · vst3 · au · standalone</span><span>drayki</span></li></ul>' +
          '<i class="screw" style="left:3.2%;top:4%"></i><i class="screw" style="right:3.2%;top:4%"></i><i class="screw" style="left:3.2%;bottom:4%"></i><i class="screw" style="right:3.2%;bottom:4%"></i>';
      }
      const rows = (k.back || []).filter((x) => x[0] !== 'with');
      const tag = typeLabel(k);
      if (this.size === 'lg') {
        const all = rows.concat(k.x || []), many = all.length >= 8;
        const fs = Math.min(many ? 11 : 13, 84 / Math.max(3, k.name.length * .56));
        return `<div class="bk lg${many ? ' dense denser' : all.length > 6 ? ' dense' : ''}"><div class="bh"><b class="en" style="font-size:${fs.toFixed(2)}cqi">${esc(k.name)}</b><span class="tg">${esc(tag)}</span></div>` +
          `<ul class="tb">${all.map(([a, b]) => `<li><span>${esc(a)}</span><span>${esc(b)}</span></li>`).join('')}` +
          `${k.n ? `<li class="tt"><span>${esc(k.sounds)}</span></li>` : ''}<li class="ft"><span>${esc(k.by)}</span></li></ul></div>`;
      }
      // (sizes in cqi of the object: 1cqi is a hundredth of its drawn face,
      // bw * s / 100 px = ppc; the lines never read under 12px on the screen
      // — sm's at 12.5–13px, its categories at 12px —, nor grow past 6.2cqi)
      const xs = this.size === 'xs', bw = this.fbw || this.bw || 200, ppc = Math.max(.5, bw * (this.s || .78) / 100);
      const fs = Math.min(xs ? 18 : 15, 84 / Math.max(3, k.name.length * .56));
      const lf = xs ? clamp(12 / ppc, 6.2, 10.6) : clamp(13 / ppc, 4.4, 6.2);
      const cf = xs ? lf : Math.max(12 / ppc, lf * .9);
      // do the contents fit, in one wrapped line, between the tag and the
      // foot? (estimated from their letters, never read from the layout:
      // an average letter .6em with its tracking, a gap .9em; 84cqi a line)
      const CH = .56, L = 84;
      const wrapN = (items, f, gap) => { let n = 1, x = 0; for (const it of items) { const w = it.length * CH * f; if (x && x + gap * f + w > L) { n++; x = w; } else x += (x ? gap * f : 0) + w; } return n; };
      const items = rows.map(([a, b]) => `${a} ${b}`);
      // (the families, summed from the same rows: 808s, drums — kicks to
      // misc —, one-shots, samples)
      const fam = [['808s', 0], ['drums', 0], ['one-shots', 0], ['samples', 0]];
      for (const [a, b] of rows) fam[a === '808s & bass' ? 0 : a === 'one-shots' ? 2 : a === 'samples' ? 3 : 1][1] += +b || 0;
      const fams = fam.filter((r) => r[1] > 0).map(([a, b]) => `${a} ${b}`);
      // (who made it: each name kept whole, "drayki +" / "arthur vitel")
      const who = k.by.split(' + ');
      const footN = wrapN(who.map((x, i) => (i < who.length - 1 ? `${x} +` : x)), lf, .3);
      // the name, the tag, the count, the foot (its rule and lines), the gap over it
      const used = fs * .86 + .5 * lf + 2 * 1.25 * lf + .45 * lf + footN * 1.25 * lf + .5 * lf;
      const fits = (l) => l.length > 0 && .55 * cf + wrapN(l, cf, .9) * 1.3 * cf <= L - used - 2;
      const cats = fits(items) ? items : fams.length < items.length && fits(fams) ? fams : null;
      return `<div class="bk ${this.size}" style="--lf:${lf.toFixed(2)}cqi;--cf:${cf.toFixed(2)}cqi"><div class="bh"><b class="en" style="font-size:${fs.toFixed(2)}cqi">${esc(k.name)}</b>` +
        `<span class="tg">${esc(tag)}</span>${k.n ? `<span class="ct">${esc(k.sounds)}</span>` : ''}</div>` +
        `${cats ? `<ul class="cs">${cats.map((t) => `<li>${esc(t)}</li>`).join('')}</ul>` : ''}<p class="ft">${who.map((x) => `<span class="nw">${esc(x)}</span>`).join(' + ')}</p></div>`;
    }
    paint() {
      const k = this.k, st = this.el.style;
      const e = engrave(k.rim);
      st.setProperty('--rim', k.rim);
      st.setProperty('--eng', e.ink);
      st.setProperty('--eng-sh', e.sh);
      if (PLATES) st.setProperty('--rim-back', rgb(tone(k.rim, .5, k.rim.toLowerCase() === '#26282f').back));
      if (!this.halo) { this.d = thick(k); st.setProperty('--d', `${this.d.toFixed(2)}cqi`); }
      this.sh = null;
    }
    setKit(h) {
      const k = BY[h];
      if (!k || k === this.k || k.h === this.k.h) return;   // THEME: the object's kit is a copy (its own data- first)
      this.k = k; this.el.dataset.kit = h;
      if (!k.local && this.face && k.img) { const sz = this.face.getAttribute('sizes'); this.face.srcset = srcsetOf(k); this.face.sizes = sz; this.face.src = cover(k, 720); }
      this.backIn.innerHTML = this.backHTML();
      const d = this.d;
      this.paint();
      if (this.spin) { this.spin.d0 = d; this.spin.d1 = this.d; this.el.style.setProperty('--d', `${d.toFixed(2)}cqi`); }
      this.lastT = '';
    }
    setBack(rows) { this.k = setRows(Object.assign({}, this.k), rows, this.k.n); this.backIn.innerHTML = this.backHTML(); }   // THEME: its total and count follow
    layout() {
      const r = this.el.getBoundingClientRect(), w = this.el.offsetWidth;
      this.top = r.top + W.scrollY; this.h = r.height;
      // (in a row, the further right a card stands, the later it stands up: the row comes up as a wave)
      if (this.card) this.lag = .1 * clamp((r.left + r.width / 2) / (E.vw || 1), 0, 1);
      // (a phone turned, a window resized: the cover's width and the back's
      // rows follow; the box's own width, never its transformed one)
      if (w > 0 && Math.abs(w - this.bw) > this.bw * .2) {
        this.bw = w;
        if (this.face && !this.k.local) this.face.sizes = this.sizesFor(w);
        if (!this.pinBack) this.setSize(this.sizeOf(w), w);
      } else if (w > 0 && !this.pinBack && this.sizeOf(w) !== this.size) this.setSize(this.sizeOf(w), w);   // (the phone's line crossed)
      this.camera();
    }
    // (a grid of kits seen by one eye: each object's perspective origin is
    // moved toward the middle of the page, so a row reads as one camera;
    // at layout only, nothing at rest)
    camera() {
      if (!this.grid) return;
      const r = this.el.getBoundingClientRect(), w = r.width || 1;
      const x = clamp(50 - ((r.left + w / 2) - E.vw / 2) / w * 35, 20, 80);
      this.scene.style.perspectiveOrigin = `${x.toFixed(1)}% 46%`;
    }
    // the back at another size (a window resized; the travelling object takes
    // its target's, with the target's width for its letters: the same pixels
    // at the hand-over). setSmall(bool) is kept for a page that still calls it.
    setSize(size, bw) {
      const f = bw || this.bw;
      if (size === this.size && Math.abs(f - (this.fbw || 0)) < 1) return;
      this.size = size; this.fbw = f; this.small = size !== 'lg';
      this.el.classList.toggle('sm-back', this.small); this.el.classList.toggle('xs-back', size === 'xs');
      this.backIn.innerHTML = this.backHTML();
    }
    setSmall(small) { this.setSize(small ? (this.bw < 250 ? 'xs' : 'sm') : 'lg'); }
    layPose() {
      const cy = this.top + this.h * .5 - E.S;
      if (this.from) {
        // it arrives in its first pose and turns to its rest pose by the
        // time it reaches the middle of the screen (read off the scroll)
        const u = clamp((cy - E.vh * .5) / (E.vh * .5 + this.h * .25), 0, 1);
        if (u === 0) return this.rest;
        const e = smooth(u), f = this.from, r = this.rest;
        return { rx: lerp(r.rx, f[0], e), ry: lerp(r.ry, f[1], e), rz: lerp(r.rz, f[2], e) };
      }
      if (this.card) {
        // THE CARDS COMING IN (the first home's, drayki: "les anims sur
        // featured quand les cartes apparaissent ... je les trouvais
        // géniales"): each card's object comes up the screen lying back on
        // its table, 40°, and stands up at its reading angle by the middle
        // of the screen (a computer: by 60 %), a little later the further
        // right it stands. Read off the scroll, both ways; still at rest.
        const at = (E.vw > 1100 ? .6 : .5) - this.lag;
        const u = clamp((cy - E.vh * at) / (E.vh * (1 - at) + this.h * .25), 0, 1);
        if (u === 0) return this.rest;
        const e = smooth(u);
        return { rx: this.rest.rx + 40 * e, ry: this.rest.ry + 16 * e, rz: this.rest.rz - 5 * e };
      }
      // it lies back a little as it comes in from the foot of the screen,
      // and stands at its reading angle once past the lower part (wide: by
      // 80 % of the screen, half as far back; a phone: by the middle)
      const wide = E.vw > 1100, at = wide ? .8 : .5;
      const u = clamp((cy - E.vh * at) / (E.vh * (1 - at) + this.h * .25), 0, 1);
      if (u === 0) return this.rest;
      const e = smooth(u), m = this.halo ? (wide ? 16 : 36) : (wide ? 17 : 40);
      return { rx: this.rest.rx + m * e, ry: this.rest.ry + (wide ? 8 : 16) * e, rz: this.rest.rz - (wide ? 2.5 : 5) * e };
    }
    // lying down on the table and standing up again (the kits' table, re-laid):
    // lie(k) at once, or lie(k, dur, delay) on its own clock; 1 is flat, face up
    flat(t, k) { return { rx: t.rx + (Math.max(FLAT.rx, t.rx) - t.rx) * k, ry: t.ry + FLAT.ry * k, rz: t.rz + FLAT.rz * k }; }
    shadow(k) {
      if (!this.ground || k === this.gk) return;
      this.gk = k;
      const s = this.ground.style;
      if (k > .001) { s.opacity = (1 - .6 * k).toFixed(3); s.transform = `translateY(${(-18 * k).toFixed(2)}cqi) scaleY(${(1 - .45 * k).toFixed(3)})`; } else { s.opacity = ''; s.transform = ''; }
    }
    lie(k, dur = 0, delay = 0) {
      const from = this.la ? this.la.cur : this.lk;
      if (!dur || REDUCE || !E.on) { this.la = null; this.lk = k; this.lastT = ''; const p = this.flat(this.lay ? this.layPose() : this.rest, k); this.write(p.rx, p.ry, p.rz); this.shadow(k); return; }
      this.la = { k0: from, k1: k, t0: performance.now() + delay, dur, cur: from };
      this.hot = true; wake();
    }
    // brought to the eye: it turns round once and back (a kit named in the link)
    present() {
      if (REDUCE || !E.on) return;
      clearTimeout(this.pt1); clearTimeout(this.pt2);
      const d = this.drag;
      this.pt1 = setTimeout(() => { d.gy = 180; d.mode = 3; this.hot = true; wake(); }, 650);
      this.pt2 = setTimeout(() => { d.gy = 0; d.mode = 3; this.hot = true; wake(); }, 2600);
    }
    frame(now, dt) {
      let busy = false;
      let p = this.driver || (this.lay ? this.layPose() : this.rest);
      let L = this.lk;
      if (this.la) {
        const a = this.la, u = clamp((now - a.t0) / a.dur, 0, 1);
        L = a.k0 + (a.k1 - a.k0) * (a.k1 > a.k0 ? u * u : out3(u));
        a.cur = L;
        if (u >= 1) { this.la = null; this.lk = L = a.k1; } else busy = true;
      }
      if (L > 0) p = this.flat(p, L);
      this.shadow(L);
      let { rx, ry, rz } = p;
      if (this.intro) {
        const u = clamp((now - this.intro.t0) / this.intro.dur, 0, 1), e = 1 - out3(u);
        ry -= 52 * e; rx += 10 * e; rz -= 4 * e;
        if (u >= 1) this.intro = null; else busy = true;
      }
      if (this.spin) {
        // a half turn that passes edge-on: the face becomes the next kit's
        // at the moment the slab is seen edge-on, at once (never a fade)
        const sp = this.spin, u = clamp((now - sp.t0) / sp.dur, 0, 1), A = 180 * ease(u);
        let y = ry + A;
        if (!sp.swapped && y > 90) { sp.swapped = true; this.setKit(sp.h); }
        if (sp.swapped) y -= 180;
        ry = y;
        if (sp.d1 !== undefined) this.el.style.setProperty('--d', `${lerp(sp.d0, sp.d1, seg(u, .45, 1)).toFixed(2)}cqi`);
        if (u >= 1) { this.spin = null; if (!sp.swapped) this.setKit(sp.h); this.paint(); } else busy = true;
      }
      if (this.stepDrag(dt)) busy = true;
      this.write(rx, ry, rz);
      this.hot = busy;
      return busy;
    }
    write(rx, ry, rz) {
      const d = this.drag, s = +(this.s / this.K).toFixed(5);
      const t = `rotateX(${d.p.toFixed(2)}deg) rotateY(${d.y.toFixed(2)}deg) rotateX(${rx.toFixed(2)}deg) rotateY(${ry.toFixed(2)}deg) rotateZ(${rz.toFixed(2)}deg) scale3d(${s},${s},${s})`;
      if (t === this.lastT) return;
      this.lastT = t;
      this.objEl.style.transform = t;
      const sh = this.sh;
      if (!sh || Math.abs(sh[0] - rx) + Math.abs(sh[1] - ry) + Math.abs(sh[2] - rz) + Math.abs(sh[3] - d.p) + Math.abs(sh[4] - d.y) > .6) {
        this.sh = [rx, ry, rz, d.p, d.y];
        const M = R3.mul(R3.mul(R3.mul(R3.x(d.p * DEG), R3.y(d.y * DEG)), R3.mul(R3.x(rx * DEG), R3.y(ry * DEG))), R3.z(rz * DEG));
        shadeRim(this.rim, M, this.k.rim, this.LV);
        // Only the side facing the eye is drawn at all (HALO's iPhone fix: a
        // WebKit that sorts the planes wrongly would draw the engraved back
        // through the face). The face's normal, turned, points at the eye
        // while its z is positive.
        const facing = M[8] > 0;
        if (facing !== this.facing) {
          this.facing = facing;
          this.faceBox.style.visibility = facing ? '' : 'hidden';
          this.back.style.visibility = facing ? 'hidden' : '';
        }
      }
    }
    turnTo(h) {
      if (REDUCE || !E.on) { this.setKit(h); this.lastT = ''; this.write(this.rest.rx, this.rest.ry, this.rest.rz); return; }
      this.spin = { t0: performance.now(), dur: 1100, h, swapped: false, d0: this.d, d1: thick(BY[h]) };
      this.hot = true; wake();
    }
    // THE COVER THAT CYCLES (a hero's carousel): cycle(['25stash', '10k',
    // 'mantra'], { every: 3200, rounds: 1, delay }) — or data-cycle="…"
    // [data-cycle-every] [data-cycle-rounds] on the object. It turns from
    // kit to kit, a half turn each, the face (and its colour, its back)
    // becoming the next kit's at the moment it is seen edge-on (turnTo),
    // every `every` ms while it is on the screen and the page is shown;
    // `rounds` times round the list (the last turn brings back the first;
    // 0 = until a hand turns it — never forever at rest by default), and
    // never again once a hand has turned it. Its covers are fetched first,
    // at the size it is drawn. Between two turns only a timer waits: no
    // frame runs at rest. Mouvement réduit: nothing turns (the first kit).
    cycle(hs, o = {}) {
      this.stopCycle();
      if (REDUCE || !E.on || this.halo) return;
      const list = (hs || []).filter((h) => BY[h] && BY[h].kit);
      if (list.length < 2) return;
      const every = Math.max(1600, +o.every || 3200), rounds = o.rounds == null ? 1 : Math.max(0, +o.rounds || 0);
      let i = Math.max(0, list.indexOf(this.k.h)), left = rounds ? rounds * list.length : Infinity;
      for (const h of list) {
        if (h === this.k.h) continue;
        const im = new Image(); im.decoding = 'async';
        if (this.face && this.face.sizes) im.sizes = this.face.sizes;
        im.srcset = srcsetOf(BY[h]); im.src = cover(BY[h], 720);
      }
      const C = this.cyc = { t: 0, every };
      const next = () => {
        if (this.cyc !== C) return;
        // (away from the screen, in a hidden tab, in a hand, or under the
        // cart, the menu or a dialog: it waits)
        if (doc.hidden || !this.seen || this.drag.mode || overlaid()) { C.t = setTimeout(next, every); return; }
        i = (i + 1) % list.length; left--;
        this.turnTo(list[i]);
        if (left > 0) C.t = setTimeout(next, every + 1100); else { this.cyc = null; CYC.delete(C); }
      };
      C.next = next; CYC.add(C);
      C.t = setTimeout(next, o.delay != null ? +o.delay : every);
    }
    stopCycle() { if (this.cyc) { clearTimeout(this.cyc.t); CYC.delete(this.cyc); this.cyc = null; } }
    stepDrag(dt) {
      const d = this.drag;
      if (d.mode === 1) return true;
      if (d.mode === 2) {                                  // coasting after a flick
        d.y += d.vy * dt; d.p = clamp(d.p + d.vp * dt, -60, 60);
        const k = Math.pow(.04, dt); d.vy *= k; d.vp *= k; d.ct += dt;
        if (d.ct > .7 || (Math.abs(d.vy) < 18 && Math.abs(d.vp) < 18)) this.home();
        return true;
      }
      if (d.mode === 3) {                                  // a spring back to rest, the short way
        const w = 6.8, z = .88, n = Math.max(1, Math.ceil(dt * 240)), h = dt / n;
        for (let i = 0; i < n; i++) {
          d.vy += (w * w * (d.gy - d.y) - 2 * z * w * d.vy) * h; d.y += d.vy * h;
          d.vp += (w * w * (d.gp - d.p) - 2 * z * w * d.vp) * h; d.p += d.vp * h;
        }
        if (Math.abs(d.gy - d.y) < .04 && Math.abs(d.gp - d.p) < .04 && Math.abs(d.vy) < .2 && Math.abs(d.vp) < .2) {
          d.y = d.gy; d.p = d.gp; d.vy = d.vp = 0; d.mode = 0;
          if (d.gy === 0) d.y = 0;
          return false;
        }
        return true;
      }
      return false;
    }
    home() {
      const d = this.drag;
      d.y = d.gy + ((((d.y - d.gy + 180) % 360) + 360) % 360) - 180;
      d.mode = 3; d.ct = 0; this.hot = true; wake();
    }
    bindHand() {
      // The hand. A mouse turns it every way. A FINGER: the object is only
      // taken by a move that is first of all across (8px, and more across
      // than up or down — the browser's own rule for pan-y, so no gesture
      // falls between the two); any other move is the page's (touch-action:
      // pan-y pinch-zoom lets the browser scroll at once). Once taken, the
      // page stays where it is until the finger lifts. Inside a rail the
      // finger is the rail's (on a coarse pointer no touch listener is even
      // attached there, so the compositor never waits); the mouse and the
      // keys still turn it. A press that does not move follows the link of
      // the card the object is in.
      const sc = this.scene, d = this.drag;
      const inRail = () => { const r = this.el.closest('.rail, .rail-sm'); return !!(r && r.scrollWidth > r.clientWidth + 1); };
      const railed = mqCoarse.matches && this.el.closest('.rail, .rail-sm');
      let held = false, moved = false, touch = false, pid = 0, px = 0, py = 0, lt = 0, eat = false;
      sc.addEventListener('pointerdown', (e) => {
        if ((e.pointerType === 'mouse' && e.button !== 0) || e.ctrlKey) return;
        touch = e.pointerType !== 'mouse';
        if (touch && (railed || inRail())) return;
        held = true; moved = false; pid = e.pointerId; px = e.clientX; py = e.clientY; lt = e.timeStamp; d.vy = d.vp = 0;
      });
      sc.addEventListener('pointermove', (e) => {
        if (!held || e.pointerId !== pid) return;
        const dx = e.clientX - px, dy = e.clientY - py;
        if (!moved) {
          if (touch) {
            if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
            if (Math.abs(dx) <= Math.abs(dy)) { held = false; return; } // up or down: the page's
          } else if (Math.hypot(dx, dy) < 7) return;
          moved = true;
          this.stopCycle();
          try { sc.setPointerCapture(pid); } catch (err) { /* ignore */ }
          this.el.classList.add('dragging');
          if (this.hint) { this.hint.remove(); this.hint = null; if (!DESIGN) store.set('drayki-turned', '1'); /* THEME: never in the editor */ }
          d.mode = 1; this.hot = true;
          px = e.clientX; py = e.clientY; lt = e.timeStamp;
          return;
        }
        const t = e.timeStamp, dtm = Math.max(8, t - lt) / 1000;
        // (a finger tilts it half as much: a thumb going across is never quite level)
        const ay = dx * .42, ap = -dy * (touch ? .16 : .32);
        d.y += ay; d.p = clamp(d.p + ap, -60, 60);
        const k = 1 - Math.exp(-dtm / .045);
        d.vy = lerp(d.vy, ay / dtm, k); d.vp = lerp(d.vp, ap / dtm, k);
        px = e.clientX; py = e.clientY; lt = t;
        if (REDUCE || !E.on) { this.lastT = ''; this.write(this.rest.rx, this.rest.ry, this.rest.rz); } else wake();
      });
      const up = (e) => {
        if (!held || e.pointerId !== pid) return;
        held = false;
        if (!moved) return;
        eat = true; setTimeout(() => { eat = false; }, 0);
        this.el.classList.remove('dragging');
        if (REDUCE || !E.on) { d.y = d.p = d.vy = d.vp = 0; d.mode = 0; this.lastT = ''; this.write(this.rest.rx, this.rest.ry, this.rest.rz); return; }
        if (e.type !== 'pointercancel' && e.timeStamp - lt < 80 && Math.hypot(d.vy, d.vp) > 40) { d.mode = 2; d.ct = 0; this.hot = true; wake(); }
        else this.home();
      };
      sc.addEventListener('pointerup', up);
      sc.addEventListener('pointercancel', up);
      // once a finger has the object, the page stays where it is
      if (!railed) sc.addEventListener('touchmove', (e) => { if (held && moved && e.cancelable) e.preventDefault(); }, { passive: false });
      sc.addEventListener('click', (e) => {
        if (eat) { e.preventDefault(); e.stopPropagation(); eat = false; return; }
        const a = this.link(); if (a) a.click();
      }, true);
      sc.addEventListener('dragstart', (e) => e.preventDefault());
      sc.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') { const a = this.link(); if (a) { e.preventDefault(); a.click(); } return; }
        let hit = true;
        if (e.key === 'ArrowLeft') d.gy -= 30;
        else if (e.key === 'ArrowRight') d.gy += 30;
        else if (e.key === 'ArrowUp') d.gp = clamp(d.gp - 20, -60, 60);
        else if (e.key === 'ArrowDown') d.gp = clamp(d.gp + 20, -60, 60);
        else if (e.key === 'Escape' || e.key === 'Home') { d.gy = 0; d.gp = 0; }
        else hit = false;
        if (!hit) return;
        e.preventDefault();
        this.stopCycle();
        if (REDUCE || !E.on) { d.y = d.gy; d.p = d.gp; this.lastT = ''; this.write(this.rest.rx, this.rest.ry, this.rest.rz); return; }
        d.mode = 3; this.hot = true; wake();
      });
      sc.addEventListener('blur', () => {
        if (!d.gy && !d.gp) return;
        d.gy = 0; d.gp = 0;
        if (REDUCE || !E.on) { d.y = d.p = 0; this.lastT = ''; this.write(this.rest.rx, this.rest.ry, this.rest.rz); return; }
        this.home();
      });
    }
  }

  /* ------------------------------------------------------------ a stack */
  // A bundle: kit tiles lying one on another, each whole, set down one by
  // one as its row comes up (read off the scroll — from its centre at
  // 90 % of the screen to 45 %; data-q="from to" to move it — never
  // faster than a pile a second, and finished at rest). The stacks share a baseline, so 2, 3 and the vault
  // read as three bars of real kits. Every tile comes down turning and is
  // set down square on the one under it, whatever the kits: under the top
  // cover only their rims show, a band per kit in its own colour (the
  // kits counted as on the vault), never a corner of a cover peeking out
  // as a thin sliver; a cover set under another turns to its kit's body
  // colour, so no hairline of it shows at a seam.
  // (r7, drayki: "problème d'animation 3d sur les stacks bundles, on dirait
  // que ça smooth les côtés des covers à la fin de l'animation") Once set
  // down, the pile stays exactly as it came down: the vault was swapped at
  // the end for its top tile and ONE block painted with a band per kit —
  // bands drawn inside a picture, which the browser smooths when it lays
  // it on a plane seen edge-on, where the tiles' bands are the planes' own
  // edges: the sides went soft in the last frame. The tiles stay; the pile
  // is still, so they cost nothing at rest (and the .far observer takes
  // them out away from the screen). Its corners are shaded without steps
  // (shadeFlow).
  class Stack {
    constructor(el) {
      this.el = el; el._stack = this;
      const ds = el.dataset;
      const list = ds.stack === 'all' ? KITS.slice().reverse() : ds.stack.split(/\s+/).map((h) => BY[h]).filter(Boolean);
      this.list = list;
      this.tw = +(ds.tw || 44);                            // a tile's width, cqi of the stack's box
      const pose = ds.pose && ds.pose.trim() ? ds.pose.trim().split(/\s+/).map(Number) : [];
      this.rx = isFinite(pose[0]) ? pose[0] : 58; this.rz = isFinite(pose[1]) ? pose[1] : -36;
      this.base = +(ds.base || 70);                         // the baseline, % of the box's height
      // (data-q="from to": where the stack's centre is on the screen as its
      // first tile comes down and as its last is set — by default from 90 %
      // of the screen, the pile just in view, to 45 %. An absent data-q is
      // the default: '' read as a number was 0, and every stack was
      // finished before it came into view.)
      const q = (ds.q || '').trim() ? ds.q.trim().split(/\s+/).map(Number) : [];
      this.qa = q.length > 1 && isFinite(q[0]) ? q[0] : .9; this.qb = q.length > 1 && isFinite(q[1]) ? q[1] : .45;
      this.q = REDUCE ? 1 : 0; this.fin = false; this.done = REDUCE;
      this.big = list.length > 4;
      this.drag = { y: 0, p: 0, vy: 0, vp: 0, gy: 0, gp: 0, mode: 0, ct: 0 };
      el.classList.add('stack');
      const quiet = ds.focus === 'off';
      const label = `${this.big ? `${S('the_vault', 'the vault')}: ` : ''}${S('stacked', '{count} kits stacked: {names}.').replace('{count}', String(list.length)).replace('{names}', list.slice().reverse().map((k) => k.name).join(', '))}`;   // THEME: the locale's words
      el.innerHTML = `<div class="stack-scene"${quiet ? ' aria-hidden="true"' : ` tabindex="0" role="group" aria-roledescription="3d object" aria-label="${esc(label)}"`}>` +
        '<i class="stack-ground" aria-hidden="true"></i><div class="stack-obj"></div></div>';
      this.scene = el.firstElementChild;
      this.objEl = $('.stack-obj', el);
      // (every tile a kit's own: the same thickness, the same rounded
      // corners, the vault's too; the corners in as many chords as their
      // size in the box asks for)
      const tw = this.tw, r = R_KIT * tw / 100;
      // (r7: the corners in as many chords as their size on the screen asks
      // for — the object's rule, within 0.4 of a screen pixel of the curve —
      // from the first frame, never changed at the end. The vault's twenty
      // too (the system's fix: held to three, its front corner was a column
      // of notches, the lip stepping at each of its two joints on a 2x or
      // 3x screen; four on a phone, five on a laptop's 2x read as one round
      // edge) — five at most, they are that many planes each)
      const nc = chords(r / 100 * (el.getBoundingClientRect().width || 300) * (parseFloat(getComputedStyle(el).getPropertyValue('--stack-s')) || 1));
      this.n = list.length > 4 ? Math.min(5, nc) : nc;
      // (r7, drayki: "on dirait que ça smooth les côtés des covers à la fin
      // de l'animation") A COVER DRAWN AT THE SCREEN'S PIXELS. Laid flat and
      // steep under the stack's perspective, a tile's face was drawn by the
      // browser at far fewer pixels than it shows (a phone's: blocky art,
      // soft letters — sharp only if the stack is flattened). The faces
      // whose cover can be seen at rest (every tile of a 2- or 3-kit stack;
      // the vault's top one — the nineteen under it are hidden) are laid
      // out twice their size and brought back down in their own transform
      // (--ss 2, scale .5; the object's --K, for one face), so the cover is
      // drawn at twice the pixels and comes down to the screen's own. Its
      // rounded corner, clear margin and edge ring are taken up with it
      // (.tile-face in the style). At every density (r7, the system's fix:
      // a laptop's 1x drew 25stash's small words and mantra's lines as soft
      // as a phone's; the object does the same there, with its K).
      const SSX = 2;
      let z = 0;
      this.tiles = list.map((k, i) => {
        const d = thick(k) * tw / 100;
        const ss = SSX > 1 && (list.length <= 4 || i === list.length - 1) ? SSX : 1;
        const t = doc.createElement('div');
        t.className = 'tile';
        t.style.cssText = `left:${-tw / 2}cqi;top:${-tw / 2}cqi;width:${tw}cqi;height:${tw}cqi;--d:${d.toFixed(3)}cqi;--rim:${k.rim};--r:${r.toFixed(3)}cqi`;
        t.innerHTML = `<div class="tile-face" style="${ss > 1 ? `--ss:${ss};` : ''}transform:translateZ(${(d / 2).toFixed(3)}cqi)${ss > 1 ? ` scale(${1 / ss})` : ''}"><i class="tile-fc"><img src="${cover(k, 360)}" srcset="${srcsetOf(k)}" sizes="160px" alt="" width="360" height="360" loading="lazy" decoding="async" draggable="false"></i></div>`;
        this.objEl.appendChild(t);
        const rim = buildRim(t, tw, tw, r, this.n, 0, true);   // (a tile's rim runs its whole depth: tiles set on one another leave no line between them)
        const tile = { el: t, k, d, z: z + d / 2, rim, i, ss, lastT: '', spin: (i % 2 ? 1 : -1) * (9 + (i * 7) % 8), img: $('img', t), under: false };
        z += d;
        return tile;
      });
      this.H = z;
      this.scale();
      const g = this.ground = $('.stack-ground', el);
      g.style.top = `calc(${this.base}% - ${tw * .3}cqi)`;
      this.write(true);
      el.classList.add('built');
      sleepFar(el);
      this.bindHand();
    }
    // a tile is display:none until it starts to fall, and its cover is lazy, so the
    // browser would only fetch it as it appears, mid-fall (a bare slab for a few
    // frames). As soon as the stack comes near the screen (the .far observer),
    // its covers are fetched and decoded, before the first tile drops.
    preload() {
      if (this.pre) return; this.pre = true;
      for (const t of this.tiles) { if (!t.img) continue; t.img.loading = 'eager'; if (t.img.decode) t.img.decode().catch(() => {}); }
    }
    // (--stack-s, from the style: the whole stack drawn larger in its box —
    // a phone's short stacks, which have the room; read at layout time only)
    scale() {
      const v = parseFloat(getComputedStyle(this.el).getPropertyValue('--stack-s')), sc = v > 0 ? v : 1;
      if (sc !== this.sc) { this.sc = sc; for (const t of this.tiles || []) t.drop = null; }
    }
    // THE HEIGHT A TILE FALLS FROM (cqi of the box): 120 at most, and never
    // so high that a corner of it, turned as it starts, would leave the
    // stack's own box (4cqi under its top edge; the box clips what leaves
    // it). A short box (a phone's pile under its title) sees each tile start
    // close to the pile, inside the box: never over the words above it,
    // never cut straight by the box's edge. Worked out once per tile from
    // the pose, the box's perspective (420cqi, seen from 30 % of its
    // height) and the scale; at layout time only.
    dropFor(t) {
      if (t.drop != null) return t.drop;
      const P = 420, oy = 92 * .3, cy = 46 + (this.base - 50) * .92, sc = this.sc || 1, h = this.tw / 2;
      const M = R3.mul(R3.x(this.rx * DEG), R3.z((this.rz + t.spin) * DEG));
      const top = (D) => {
        const z = (t.z + t.d / 2 + D) * sc;
        let m = Infinity;
        for (const [x, y] of [[-h, -h], [h, -h], [h, h], [-h, h]]) {
          const X = x * sc, Y = y * sc;
          const py = cy + M[3] * X + M[4] * Y + M[5] * z, pz = M[6] * X + M[7] * Y + M[8] * z;
          m = Math.min(m, oy + (py - oy) * P / Math.max(1, P - pz));
        }
        return m;
      };
      let lo = 0, hi = 120;
      if (top(hi) >= 4) lo = hi;
      else for (let i = 0; i < 16; i++) { const mid = (lo + hi) / 2; if (top(mid) >= 4) lo = mid; else hi = mid; }
      return (t.drop = lo);
    }
    // one tile set down from above on its own clock (the mix: the kit just
    // picked), from the same height as the scroll's; nothing runs after it
    dropIn(h) {
      const t = this.tiles.find((x) => x.k.h === h);
      if (!t || !E.on || REDUCE || !t.el.animate) return;
      const to = t.el.style.transform, drop = this.dropFor(t);
      // (the cover under it stays a cover until the tile is on it — to the
      // eye: within half a pixel of it, well before the fall's last frame,
      // so the last frame is the one before it; see write)
      const u = this.tiles[t.i - 1], keep = u && u.under && t.i === this.tiles.length - 1;
      if (keep) this.veil(u, false);
      const a = t.el.animate([
        { transform: `translate3d(0,0,${(t.z + drop).toFixed(2)}cqi) rotateZ(${t.spin.toFixed(2)}deg)` },
        { transform: to },
      ], { duration: 950, easing: 'cubic-bezier(.2,.7,.2,1)' });
      if (keep) {
        // (when the ease has brought it within half a pixel: the curve sampled)
        const left = .5 / Math.max(.01, drop * this.ppc);
        let at = 1;
        for (let i = 1; i <= 200; i++) {
          const s = i / 200, m = 1 - s, x = 3 * m * m * s * .2 + 3 * m * s * s * .2 + s * s * s, y = 3 * m * m * s * .7 + 3 * m * s * s + s * s * s;
          if (1 - y <= left) { at = x; break; }
        }
        const tm = setTimeout(() => { if (u.under) this.veil(u, true); }, Math.round(950 * at));
        a.onfinish = () => { clearTimeout(tm); if (u.under) this.veil(u, true); };
      }
    }
    // a cover with a tile set down on it: out of sight, its face all its
    // kit's colour (its edge ring too: on violet night that ring is taken
    // toward the paper, and it came through the joints of the tile over it
    // as specks of light down the pile's corners)
    veil(t, hide) { t.el.classList.toggle('u', hide); }
    layout() {
      const r = this.el.getBoundingClientRect(); this.top = r.top + W.scrollY; this.h = r.height; this.scale();
      this.ppc = r.width / 100 * this.sc;
      // (each tile's cover at the width it is drawn: a cover seen at rest,
      // drawn at twice its pixels (ss), at its width under the perspective
      // too, about 1.4 times its box's share, at every density; the vault's
      // hidden ones at their box's share)
      const px = Math.round(r.width * this.tw / 100 * this.sc * ((W.devicePixelRatio || 1) >= 2.5 ? 1 : 1.15));
      if (px > 0 && px !== this.px) { this.px = px; for (const t of this.tiles) t.img.sizes = `${t.ss > 1 ? Math.round(r.width * this.tw / 100 * this.sc * 1.4) : px}px`; }
    }
    frame(now, dt) {
      let busy = false;
      if (!this.done) {
        // read off the scroll, never faster than a pile a second (the
        // vault's twenty: 1.6 s), so a quick flick or a jump to #bundles
        // still sees the tiles come down one by one
        const tgt = seg((this.top + this.h / 2 - E.S) / E.vh, this.qa, this.qb);
        // (r7: a stack first seen already past its range — the nav's jump
        // to #bundles, a page opened halfway down — is set down twice as
        // fast: never an empty stage for long under its title)
        if (this.q === 0 && tgt >= 1 && !this.fin) this.jump = true;
        const cap = this.q + dt / ((this.big ? 1.6 : 1.05) * (this.jump ? .5 : 1));
        if (this.fin) this.q = Math.min(1, cap); else this.q = Math.max(this.q, Math.min(tgt, cap));
        busy = this.fin ? this.q < 1 : this.q < tgt;
        if (this.q >= 1) { this.q = 1; this.done = true; busy = false; }
      }
      if (this.stepDrag(dt)) busy = true;
      this.write();
      this.hot = busy;
      return busy;
    }
    settle() { if (!this.done && this.q > 0 && this.seen) { this.fin = true; this.hot = true; } }
    write(force) {
      const d = this.drag;
      const sc = this.sc || 1;
      const ot = `translate3d(0, ${(this.base - 50) * .92}cqi, 0) rotateX(${(this.rx + d.p).toFixed(2)}deg) rotateZ(${(this.rz + d.y).toFixed(2)}deg)${sc !== 1 ? ` scale3d(${sc},${sc},${sc})` : ''}`;
      if (ot !== this.lastO || force) {
        this.objEl.style.transform = ot; this.lastO = ot;
        const M = R3.mul(R3.x((this.rx + d.p) * DEG), R3.z((this.rz + d.y) * DEG));
        for (const t of this.tiles) shadeFlow(t.rim, M, t.k.rim, 24);
      }
      const N = this.tiles.length, span = N > 4 ? .26 : .5;
      const ppc = this.ppc || (this.el.getBoundingClientRect().width || 300) / 100 * sc;
      let left = Infinity;                                 // how far (px) the tile above still has to fall
      for (let j = N - 1; j >= 0; j--) {
        const t = this.tiles[j];
        const a = N === 1 ? 0 : (t.i / (N - 1)) * (1 - span);
        const k = this.done ? 1 : seg(this.q, a, a + span);
        // (a cover with a tile set down on it: out of sight, its kit's
        // colour. r7: set down TO THE EYE — the tile over it within half a
        // pixel of it —, not at the fall's very last frame: its light edge
        // showed along the sides of the tile over it through the fall's
        // last moments and went in the last frame, a change as the pile
        // came to rest; now the pile's last frames are all the same)
        const under = j < N - 1 && left < .5;
        left = k <= 0 ? Infinity : (1 - out3(k)) * this.dropFor(t) * ppc;
        if (under !== t.under) { t.under = under; this.veil(t, under); }
        const e = out3(k);
        const tr = k === 0 ? 'hide' : `translate3d(0,0,${(t.z + (1 - e) * this.dropFor(t)).toFixed(2)}cqi) rotateZ(${((1 - e) * t.spin).toFixed(2)}deg)`;
        if (tr === t.lastT && !force) continue;
        t.lastT = tr;
        // (a tile not yet set down is out of the page: no layer at all)
        if (tr === 'hide') { t.el.style.display = 'none'; continue; }
        t.el.style.display = '';
        t.el.style.transform = tr;
      }
      // the floor's shadow comes with the first tile, as it lands: never a
      // shadow under an empty table (in sixteenths, painted only when it changes)
      const g = this.done ? 1 : Math.round(seg(this.q, .55 * span, span) * 16) / 16;
      if (g !== this.lg && this.ground) { this.lg = g; this.ground.style.opacity = g === 1 ? '' : String(g); }
    }
    stepDrag(dt) { return Obj.prototype.stepDrag.call(this, dt); }
    home() { return Obj.prototype.home.call(this); }
    bindHand() {
      // a stack turns on the table: a drag spins it about its own upright
      // (a finger: the same rule as an object's — taken only by a move across)
      const sc = this.scene, d = this.drag;
      let held = false, moved = false, pid = 0, px = 0, py = 0, lt = 0;
      sc.addEventListener('pointerdown', (e) => { if ((e.pointerType === 'mouse' && e.button !== 0) || e.ctrlKey) return; held = true; moved = false; pid = e.pointerId; px = e.clientX; py = e.clientY; lt = e.timeStamp; });
      sc.addEventListener('touchmove', (e) => { if (held && moved && e.cancelable) e.preventDefault(); }, { passive: false });
      sc.addEventListener('pointermove', (e) => {
        if (!held || e.pointerId !== pid) return;
        const dx = e.clientX - px, dy = e.clientY - py;
        if (!moved) {
          if (e.pointerType === 'mouse' ? Math.hypot(dx, dy) < 7 : Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          if (e.pointerType !== 'mouse' && Math.abs(dx) <= Math.abs(dy)) { held = false; return; }
          moved = true; try { sc.setPointerCapture(pid); } catch (err) { /* ignore */ }
          this.el.classList.add('dragging'); d.mode = 1; this.hot = true; px = e.clientX; py = e.clientY; lt = e.timeStamp; return;
        }
        const t = e.timeStamp, dtm = Math.max(8, t - lt) / 1000, ay = -dx * .5, ap = clamp(-dy * .25, -30, 30);
        d.y += ay; d.p = clamp(d.p + ap, -24, 20);
        const k = 1 - Math.exp(-dtm / .045); d.vy = lerp(d.vy, ay / dtm, k); d.vp = 0;
        px = e.clientX; py = e.clientY; lt = t;
        if (REDUCE || !E.on) this.write(); else wake();
      });
      const up = (e) => {
        if (!held || e.pointerId !== pid) return;
        held = false; if (!moved) return;
        this.el.classList.remove('dragging');
        if (REDUCE || !E.on) { d.y = d.p = 0; d.mode = 0; this.write(); return; }
        if (e.type !== 'pointercancel' && e.timeStamp - lt < 80 && Math.abs(d.vy) > 40) { d.mode = 2; d.ct = 0; this.hot = true; wake(); } else this.home();
      };
      sc.addEventListener('pointerup', up);
      sc.addEventListener('pointercancel', up);
      sc.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'Escape') return;
        e.preventDefault();
        d.gy = e.key === 'Escape' ? 0 : d.gy + (e.key === 'ArrowLeft' ? 30 : -30);
        if (REDUCE || !E.on) { d.y = d.gy; this.write(); return; }
        d.mode = 3; this.hot = true; wake();
      });
      sc.addEventListener('blur', () => { if (!d.gy) return; d.gy = 0; if (REDUCE || !E.on) { d.y = 0; this.write(); return; } this.home(); });
    }
  }

  /* -------------------------------------------------------- the curtains */
  // A section word (data-t) is uncovered by the page's own ground: a window
  // as wide as the word, a soft-edged strip of --bg sliding off it; the word
  // rises 30px, then its rule is drawn, then its index comes. Once only; read
  // off the scroll while the page moves; finished on its own clock at rest.
  // The first screen's word (data-t="pre", the page's h1: the words the
  // first paint is made of) is never covered: it is painted whole from the
  // first frame, whenever this script comes, and only its rule is drawn
  // under it, on its own clock (ruleOnly). (Covering it, even before the
  // first paint, would still show a first frame without it: that paint
  // waits for the style sheets, not for the script.)
  // how far a line's letters reach out of its box, above and under (px):
  // a line set tighter than its font (a title at line-height .8 – .92)
  // leaves its tallest letters or its tails outside it. Measured on its
  // own words, in its own font (a canvas; the font's metrics if it cannot);
  // at layout time only.
  let inkCtx = null;
  function inkOut(el) {
    const cs = getComputedStyle(el), fs = parseFloat(cs.fontSize) || 16, lh = parseFloat(cs.lineHeight);
    const txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!txt || !(lh > 0) || lh >= fs * 1.3) return { top: 0, bottom: 0, right: Math.max(0, -(parseFloat(cs.letterSpacing) || 0)) };
    let aA = fs * .76, aD = fs * .24, fA = fs * .969, fD = fs * .242;
    try {
      inkCtx = inkCtx || doc.createElement('canvas').getContext('2d');
      inkCtx.font = `${cs.fontStyle} ${cs.fontWeight} ${fs}px ${cs.fontFamily}`;
      const m = inkCtx.measureText(txt);
      if (m.actualBoundingBoxAscent != null) { aA = m.actualBoundingBoxAscent; aD = m.actualBoundingBoxDescent; }
      if (m.fontBoundingBoxAscent) { fA = m.fontBoundingBoxAscent; fD = m.fontBoundingBoxDescent; }
    } catch (e) { /* the font's metrics */ }
    const hl = (lh - fA - fD) / 2;
    // (and at the right: a title tracked tight is a box narrower than its
    // letters — the arm and the leg of the k of "10k" stood out of it)
    const ls = parseFloat(cs.letterSpacing) || 0;
    return { top: aA - (hl + fA) - (parseFloat(cs.paddingTop) || 0), bottom: aD - (hl + fD) - (parseFloat(cs.paddingBottom) || 0), right: Math.max(0, -ls) };
  }
  class Curtain {
    constructor(el, kind) {
      this.el = el; this.kind = kind;
      this.host = kind === 'word' ? ($('.w', el) || el) : el;
      this.p = 0; this.fin = el.dataset.t === 'pre';
      this.ruleOnly = this.fin && kind === 'word';
      if (!this.ruleOnly) {
        const cw = doc.createElement('span');
        cw.className = 'cw'; cw.setAttribute('aria-hidden', 'true');
        cw.innerHTML = '<i class="cur"></i>';
        this.cw = cw; this.host.appendChild(cw);
      }
      el.classList.add('cur-on');
      el.addEventListener('focusin', () => { this.fin = true; this.hot = true; wake(); });
      this.write();
    }
    layout() {
      const r = this.el.getBoundingClientRect();
      this.top = r.top + W.scrollY;
      const ww = this.host.offsetWidth;
      // (r6, drayki: "le 0 % royalty free … on dirait qu'il est doublé") A
      // FIGURE (.big: "0 %", a price cut) is uncovered by a short soft edge,
      // an eighth of its size: the long one (half the row, up to 220px) lay
      // over a thin 76–164px numeral for most of its way, one stroke of the
      // 0 whole and the other a ghost of it, the % a faint second 0 beside
      // it — it read as a doubled figure. Words and titles keep the long one.
      const fig = this.kind !== 'word' && this.el.classList.contains('big');
      this.host.style.setProperty('--ce', `${this.kind === 'word' ? ww * .5 : fig ? Math.max(6, (parseFloat(getComputedStyle(this.el).fontSize) || 80) * .125) : Math.min(ww * .5, 220)}px`);
      // (a row's window reaches as far above and under it as its own
      // letters do, and a pixel more: "before you buy.", set at .92, has
      // the tails of its y's 2px under its box — shown before the strip
      // came. Measured on the row's words, so a row whose letters stay in
      // their box keeps its box: the window never covers a neighbour.)
      if (this.cw && this.kind !== 'word') {
        const o = inkOut(this.el), px = (v) => `${v > 0 ? Math.ceil(v) + 1 : 0}px`;
        this.el.style.setProperty('--ct', px(o.top)); this.el.style.setProperty('--cb', px(o.bottom)); this.el.style.setProperty('--cr', `${Math.ceil(o.right) + 2}px`);
      }
    }
    frame(now, dt) {
      // (the strip is its own layer only while it moves: near the screen, until uncovered)
      if (!this.wc && this.cw) { this.wc = true; this.cw.firstChild.style.willChange = 'transform'; }
      if (this.fin) this.p = Math.min(1, this.p + dt / .9);
      else this.p = Math.max(this.p, seg((this.top - E.S) / E.vh, .92, .42));
      this.write();
      if (this.p >= 1) { this.finish(); return false; }
      this.hot = this.fin;
      return this.fin;
    }
    settle() { if (this.p > 0 && this.p < 1) { this.fin = true; this.hot = true; } }
    write() {
      const p = this.p;
      if (p === this.lp) return;
      this.lp = p;
      if (this.ruleOnly) { this.el.style.setProperty('--rq', ease(p).toFixed(4)); return; }
      this.host.style.setProperty('--cq', ease(p).toFixed(4));
      if (this.kind === 'word') {
        const s = this.el.style;
        s.setProperty('--wy', `${((1 - out3(p)) * 30).toFixed(2)}px`);
        s.setProperty('--rq', ease(seg(p, .12, 1)).toFixed(4));
        s.setProperty('--iq', seg(p, .72, 1).toFixed(3));
      }
    }
    finish() {
      if (this.cw) this.cw.remove();
      this.el.classList.remove('cur-on'); this.el.classList.add('cur-done');
      ['--wy', '--rq', '--iq'].forEach((v) => this.el.style.removeProperty(v));
      unregister(this); this.hot = false;
    }
  }

  /* --------------------------------------------------------- templates */
  const plus = '<svg class="pl" viewBox="0 0 10 10" aria-hidden="true"><path d="M5 1v8M1 5h8"/></svg>';
  const arrow = (sm) => (sm
    ? '<svg class="arr" viewBox="0 0 34 14" aria-hidden="true"><path class="sh" d="M0 7H33"/><path d="M27 1l6 6-6 6"/></svg>'
    : '<svg class="arr" viewBox="0 0 64 14" aria-hidden="true"><path class="sh" d="M0 7H63"/><path d="M57 1l6 6-6 6"/></svg>');
  const thumbHTML = (k) => `<span class="thumb" style="--rim:${k.rim}"><img src="${cover(k, 120)}" srcset="${cover(k, 120)} 1x, ${cover(k, 240)} 2x" alt="" width="120" height="120" loading="lazy" decoding="async"></span>`;
  // THEME: a kit's rating on its card, as the snippet stars prints it (compact):
  // a filled star, the figure, the count in brackets; read as one thing. Only
  // a kit with reviews (kit-json: rating, reviews — Judge.me's metafields)
  const STAR = 'M6 .7L7.41 4.36L11.33 4.57L8.28 7.04L9.29 10.83L6 8.7L2.71 10.83L3.72 7.04L.67 4.57L4.59 4.36Z';
  const rateHTML = (k) => {
    const n = Math.round(+k.reviews || 0), r = Math.min(5, +k.rating || 0);
    if (!(n > 0 && r > 0)) return '';
    const v = r.toFixed(1), say = (n === 1 ? S('rated_one', 'rated {rating} out of 5, {count} review') : S('rated_other', 'rated {rating} out of 5, {count} reviews')).replace('{rating}', v).replace('{count}', String(n));
    return `<span class="rt" role="img" aria-label="${esc(say)}"><svg class="st" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="${STAR}"/></svg>${v}<span class="rn">(${n})</span></span>`;
  };
  const TPL = {
    // the kit's card: the object, a hairline, who made it ("drayki",
    // "drayki + arthur vitel"), the name, the price, its tag ("multikit" —
    // r6: its count is no longer beside it, drayki: "il est déjà sur le back
    // de la cover"), the add key (its name hidden before "add"). o.h: the
    // name's heading level (3; 2 on the kits' page)
    shelf(k, o = {}) {
      const hl = o.h || 3;
      return `<div class="kit" data-kit="${k.h}" data-focus="off"></div>` +
        `<div class="capt"><span class="eq">${esc(k.by)}</span><h${hl} class="t"><a class="t" href="${esc(k.href)}"><span class="ul">${esc(k.name)}</span></a></h${hl}>${priceHTML(k)}<span class="meta">${esc(typeLabel(k))}${rateHTML(k)}</span></div>` +   // THEME: its rating (rateHTML)
        `<button class="btn" type="button" data-add="${k.h}"${k.vid ? ` data-variant="${k.vid}"` : ''}>${plus}<span class="vh">${esc(k.name)}, </span><span class="lb">${esc(S('add', 'add'))}</span></button>`;   // THEME: the version it adds, the locale's word
    },
    thumb: thumbHTML,
    arrow,
    plus,
  };
  function fill(scope) {
    for (const el of $$('[data-shelf]', scope)) {
      if (el._filled) continue; el._filled = true;
      const k = BY[el.dataset.shelf]; if (!k) continue;
      el.classList.add('item'); if (!el.id) el.id = `k-${k.h}`;
      el.innerHTML = TPL.shelf(k, { h: +el.dataset.hl || 3 });
    }
    for (const el of $$('[data-price]', scope)) { const k = BY[el.dataset.price]; if (k && !el.childElementCount) el.outerHTML = priceHTML(k); }   // THEME: only an empty one (Liquid prints the price)
    for (const el of $$('[data-count]', scope)) {
      const t = el.dataset.count;
      if (el.textContent.trim()) continue;   // THEME: only an empty one (Liquid prints the count)
      el.textContent = t === 'all' ? KITS.length : KITS.filter((k) => k.type === t).length;
    }
    for (const el of $$('[data-min]', scope)) if (!el.textContent.trim() && KITS.length) el.textContent = fmt(Math.min(...KITS.map((k) => k.price)));   // THEME: only an empty one
    for (const el of $$('[data-sounds]', scope)) if (!el.textContent.trim()) el.textContent = soundsOf(SOUNDS).replace(String(SOUNDS), `${SOUNDS}+`);   // THEME: only an empty one; the locale's words
    for (const el of $$('[data-sum]', scope)) {
      if (el.childElementCount) continue;   // THEME: only an empty one (the snippet bundle-sum prints the sum)
      const all = el.dataset.sum === 'all';
      const list = all ? KITS : el.dataset.sum.split(/\s+/).map((h) => BY[h]).filter(Boolean);
      const off = el.dataset.off != null && el.dataset.off !== '' ? +el.dataset.off / 100 : all   // THEME: data-off is a percentage
        ? VAULT.off : (TIERS.slice().reverse().find((t) => list.length >= t.n) || { off: 0 }).off;
      el.outerHTML = sumHTML(list, off, all);
    }
    // "get halo": its one address (HALO_URL)
    for (const a of $$('a[data-halo]', scope)) a.href = HALO_URL;
    // a price line (.from): each separator is held with what follows it
    // (<span class="fg"><i class="dot">·</i>…</span>, the one before it
    // marked .fp), so a line never ends on a "·"; a group that starts a
    // line hangs its "·" in the clipped margin (see .from in the style).
    // In Liquid the groups can be written as they are; then nothing moves.
    for (const f of $$('.from', scope)) {
      for (const d of $$(':scope > .dot', f)) {
        const nx = d.nextElementSibling;
        if (!nx) continue;
        const g = doc.createElement('span');
        g.className = 'fg';
        if (d.previousElementSibling) d.previousElementSibling.classList.add('fp');
        f.insertBefore(g, d);
        g.append(d, nx);
      }
    }
  }

  /* ------------------------------------------------------------ drawings */
  // Hairlines in one hand, each part drawn in its turn by the scroll, once.
  // DRAYKI.DRAW holds the drawings by name (a page adds its own before the
  // start: DRAYKI.DRAW.sf = ({ S, T, Dt, A }) => { ... }). S a stroke, T a
  // word, Dt a dot, A a shaded area; each with its share of the drawing
  // (a..b of 0..1).
  const NS = 'http://www.w3.org/2000/svg';
  const mk = (tag, a, p) => { const e = doc.createElementNS(NS, tag); for (const k in a) e.setAttribute(k, a[k]); if (p) p.appendChild(e); return e; };
  const f1 = (v) => String(Math.round(v * 10) / 10);
  const G = {
    f1,
    rr: (x, y, w, h, r) => `M${x + r} ${y}H${x + w - r}A${r} ${r} 0 0 1 ${x + w} ${y + r}V${y + h - r}A${r} ${r} 0 0 1 ${x + w - r} ${y + h}H${x + r}A${r} ${r} 0 0 1 ${x} ${y + h - r}V${y + r}A${r} ${r} 0 0 1 ${x + r} ${y}Z`,
    ring: (cx, cy, r) => `M${f1(cx - r)} ${f1(cy)}A${r} ${r} 0 1 1 ${f1(cx + r)} ${f1(cy)}A${r} ${r} 0 1 1 ${f1(cx - r)} ${f1(cy)}`,
    folder: (x, y, w, h) => `M${x} ${y + 16}V${y + 4}Q${x} ${y} ${x + 4} ${y}H${x + 40}L${x + 50} ${y + 10}H${x + w - 6}Q${x + w} ${y + 10} ${x + w} ${y + 16}V${y + h - 6}Q${x + w} ${y + h} ${x + w - 6} ${y + h}H${x + 6}Q${x} ${y + h} ${x} ${y + h - 6}Z`,
    poly: (pts) => pts.map((p, i) => `${i ? 'L' : 'M'}${f1(p[0])} ${f1(p[1])}`).join(''),
  };
  const DRAW = {
    // instant download: you pay, the email, your files (across a card)
    dl: ({ S, T, Dt }) => {
      S(G.rr(22, 50, 148, 48, 24), 0, .18); T(96, 79, 'checkout', .1, .22, '', 'middle');
      S('M186 74H240', .18, .28); S('M233 67l7 7-7 7', .24, .3);
      S(G.rr(256, 36, 124, 76, 6), .28, .44); S('M260 42L318 82L376 42', .38, .5);
      S('M394 74H440', .48, .56); S('M433 67l7 7-7 7', .52, .58);
      S(G.folder(456, 26, 122, 96), .56, .76);
      [[76, 540], [90, 556], [104, 528]].forEach(([yy, x2], j) => { Dt(478, yy, 2.2, .7 + j * .05, .76 + j * .05); S(`M488 ${yy}H${x2}`, .7 + j * .05, .8 + j * .05); });
      T(96, 150, 'you pay', .16, .26, 's', 'middle'); T(318, 150, 'the email', .44, .54, 's', 'middle'); T(517, 150, 'your files', .76, .86, 's', 'middle');
    },
    // the same, down a half card (a phone)
    dlv: ({ S, T, Dt }) => {
      S(G.rr(12, 8, 126, 42, 21), 0, .16); T(75, 34, 'checkout', .08, .2, '', 'middle');
      S('M75 60V94', .16, .26); S('M68 87l7 7 7-7', .22, .28);
      S(G.rr(24, 104, 102, 66, 6), .28, .42); S('M28 110L75 146L122 110', .36, .48);
      T(75, 190, 'the email', .42, .52, 's', 'middle');
      S('M75 202V236', .48, .56); S('M68 229l7 7 7-7', .52, .58);
      S(G.folder(18, 246, 114, 86), .56, .76);
      [[280, 110], [294, 118], [308, 102]].forEach(([yy, x2], j) => { Dt(38, yy, 2.2, .7 + j * .05, .76 + j * .05); S(`M48 ${yy}H${x2}`, .7 + j * .05, .8 + j * .05); });
      T(75, 352, 'your files', .76, .86, 's', 'middle');
    },
  };
  function drawing(svg, build) {
    const parts = [];
    const S = (d, a, b, cls) => { const e = mk('path', { class: `st${cls ? ` ${cls}` : ''}`, d, pathLength: '1' }, svg); parts.push({ e, a, b, s: 1, k: -1 }); return e; };
    const F = (e, a, b) => { e.classList.add('fd'); parts.push({ e, a, b, s: 0, k: -1 }); return e; };
    const T = (x, y, s, a, b, cls, anchor) => { const e = mk('text', { class: `tx${cls ? ` ${cls}` : ''}`, x, y }, svg); if (anchor) e.setAttribute('text-anchor', anchor); e.textContent = s; return F(e, a, b); };
    const Dt = (cx, cy, r, a, b) => F(mk('circle', { class: 'dt', cx: f1(cx), cy: f1(cy), r }, svg), a, b);
    const A = (d, a, b) => F(mk('path', { class: 'ar', d }, svg), a, b);
    build({ S, T, Dt, A, G });
    return (p) => {
      for (const q of parts) {
        const k = seg(p, q.a, q.b);
        if (k === q.k) continue;
        q.k = k;
        if (q.s) { q.e.style.strokeDashoffset = (1 - ease(k)).toFixed(4); q.e.style.visibility = k > 0 ? 'visible' : 'hidden'; }
        else q.e.style.opacity = k >= 1 ? '1' : k.toFixed(3);
      }
    };
  }
  let DRAWN = [];
  function drawings(scope) {
    for (const svg of $$('svg[data-draw]', scope)) {
      if (svg._dr) continue;
      const b = DRAW[svg.dataset.draw]; if (!b) continue;
      svg._dr = true;
      const write = drawing(svg, b);
      DRAWN.push(svg);
      if (!E.on) { write(1); continue; }
      write(0);
      register(new Once(svg, write, 1.3, .98, .38), svg);
    }
  }
  // the drawings' words and strokes keep their size on the screen (--k: the
  // drawing's units to a pixel), with or without motion; read then written
  function fitDrawings() {
    DRAWN = DRAWN.filter((s) => s.isConnected);
    const m = DRAWN.map((s) => [s, s.getBoundingClientRect().width, s.viewBox.baseVal.width]);
    for (const [s, w, vw] of m) if (w > 0) s.style.setProperty('--k', (vw / w).toFixed(4));
  }

  /* ------------------------------------------------------------ a counter */
  // <p class="big odo" data-odo="sounds">: a column of digits for each
  // place, rolled up by the scroll (once), the real count at the end.
  // (r7: never a leading zero — "000 one-shots", "026 sounds" read as the
  // zero-padded numbering he banned. Every place above the units starts
  // BLANK and rolls from blank into its first digit as the count reaches
  // it: 2 → 26 → 252. Its column is a blank, then 1 … 9, 0, 1 (the 0 after
  // the 9, the 1 again for the roll over); the units' 0 … 9, 0. Every
  // column keeps its width: nothing moves beside it.)
  function odometers(scope) {
    for (const el of $$('[data-odo]', scope)) {
      if (el._odo) continue; el._odo = true;
      const v = el.dataset.odo, N = v === 'sounds' ? SOUNDS : +v || 0;
      const places = String(N).length;
      let h = '<span class="od" aria-hidden="true" style="display:flex">';
      for (let i = places - 1; i >= 0; i--) h += `<span class="dg"><b data-pl="${i}">${(i ? ['', ...'1234567890', '1'] : [...'0123456789', '0']).map((d) => `<i>${d}</i>`).join('')}</b></span>`;
      h += `${v === 'sounds' ? '<span class="pl">+</span>' : ''}</span>`;
      el.insertAdjacentHTML('beforeend', h);
      { const tx = Array.from(el.children).find((c) => c.classList.contains('odo-t')); if (tx) tx.classList.add('vh'); }   // THEME: the number printed in clear stays for the reader only
      const cols = $$('b[data-pl]', el).map((b) => ({ e: b, i: +b.dataset.pl, s: '' }));
      // (a digit's cell in a column above the units: 1 … 9 at 1 … 9, 0 at 10)
      const cell = (d) => (d === 0 ? 10 : d);
      const write = (p) => {
        const x = N * out3(p);
        for (const c of cols) {
          const P = Math.pow(10, c.i);
          let pos;
          if (p >= 1) pos = c.i === 0 ? N % 10 : cell(Math.floor(N / P) % 10);
          else if (c.i === 0) pos = x % 10;
          else if (x < P) pos = seg(x, P - 1, P);            // blank, rolling into its 1 as the count reaches the place
          else pos = cell(Math.floor(x / P) % 10) + seg(x % P, P - 1, P);
          const s = pos.toFixed(3);
          if (s !== c.s) { c.s = s; c.e.style.transform = `translateY(${(-pos).toFixed(3)}em)`; }
        }
      };
      if (!E.on) { write(1); continue; }
      write(0);
      register(new Once(el, write, 1.4, .95, .45), el);
    }
  }

  /* ------------------------------------------- the ticker, the close-ups */
  function tickers(scope) {
    for (const tick of $$('[data-tick]', scope)) {
      if (tick._tk) continue; tick._tk = true;
      const tape = $('.tick-t', tick); if (!tape || !E.on) continue;
      register({
        x: 1e9,
        // (the tape is its own layer only while it is near the screen)
        onSeen(on) { tape.style.willChange = on ? 'transform' : ''; },
        layout() {
          const s = $('.tick-s', tape); if (!s) return;
          this.w = s.offsetWidth || 1;
          const need = Math.ceil(tick.clientWidth / this.w) + 1;
          while ($$('.tick-s', tape).length < need) {
            const c = s.cloneNode(true);
            c.setAttribute('aria-hidden', 'true');
            $$('a', c).forEach((a) => { a.tabIndex = -1; });
            tape.appendChild(c);
          }
          this.x = 1e9;
        },
        frame() {
          const x = -((((E.S * .55) % this.w) + this.w) % this.w);
          if (Math.abs(x - this.x) < .3) return false;
          this.x = x; tape.style.transform = `translate3d(${x.toFixed(1)}px,0,0)`;
          return false;
        },
      }, tick);
    }
  }
  // a cover uncovered once by its card's ground, settling as it goes
  function uncovers(scope) {
    for (const cv of $$('[data-uncover]', scope)) {
      if (cv._uc) continue; cv._uc = true;
      const img = $('img', cv); if (!img || !E.on) continue;
      // (the style keeps the cover unseen until this strip is over it: it
      // never shows, then goes, then comes)
      cv.classList.add('uc-on');
      const cur = doc.createElement('i');
      cur.className = 'rel-cur'; cur.setAttribute('aria-hidden', 'true');
      cv.appendChild(cur);
      const write = (p) => {
        const e = ease(p);
        cur.style.transform = `translate3d(${(-28.6 + 100 * e).toFixed(2)}%,0,0)`;
        img.style.transform = p >= 1 ? '' : `scale(${(1.08 - .08 * out3(p)).toFixed(4)})`;
        if (p >= 1) cur.remove();
      };
      write(0);
      register(new Once(cv, write, 1.2, .92, .3), cv);
    }
  }
  // a close-up that pans across as the page moves (halo's interface on a
  // phone), read off the scroll both ways, still at rest
  function crops(scope) {
    for (const crop of $$('[data-crop]', scope)) {
      if (crop._cr) continue; crop._cr = true;
      const img = $('img', crop); if (!img) continue;
      if (!E.on) { img.style.transform = 'translate3d(-16%,0,0)'; continue; }
      register({
        v: '',
        layout() { const r = crop.getBoundingClientRect(); this.c = r.top + W.scrollY + r.height / 2; this.on = r.width > 0; this.v = ''; },
        frame() {
          if (!this.on) return false;
          const p = seg((this.c - E.S) / E.vh, .92, .18);
          const v = (-31.67 * p).toFixed(2);
          if (v !== this.v) { this.v = v; img.style.transform = `translate3d(${v}%,0,0)`; }
          return false;
        },
      }, crop);
    }
  }

  /* ------------------------------------------------------------ the rails */
  // a rail's two arrow keys (a computer: one card a press; off at the ends)
  function rails(scope) {
    for (const r of $$('[data-rail]', scope)) {
      if (r._rl) continue; r._rl = true;
      const keys = r.id ? $$(`[data-pg][aria-controls="${r.id}"]`) : [];
      if (!keys.length) continue;
      const step = () => { const it = r.firstElementChild; const gap = parseFloat(getComputedStyle(r).columnGap) || 0; return it ? it.getBoundingClientRect().width + gap : r.clientWidth * .8; };
      keys.forEach((b) => b.addEventListener('click', () => { r.scrollBy({ left: +b.dataset.pg * step(), behavior: E.on ? 'smooth' : 'auto' }); }));
      let q = 0;
      const sync = () => {
        q = 0;
        const max = r.scrollWidth - r.clientWidth - 2;
        keys.forEach((b) => { const off = +b.dataset.pg < 0 ? r.scrollLeft <= 2 : r.scrollLeft >= max; if (b.disabled !== off) b.disabled = off; });
      };
      r.addEventListener('scroll', () => { if (!q) q = W.requestAnimationFrame(sync); }, { passive: true });
      W.addEventListener('resize', sync);
      sync();
    }
  }

  /* ------------------------------------------------------------- the travel */
  // <div class="kit" data-travel="#landing">: the object in the first screen
  // is held almost still while the page runs under it, turns on the way
  // toward its target's pose (the product's own: back up, its contents
  // engraved), lies back a little and comes down to the size of its target,
  // set exactly on it: at the end it is hidden and the target (same pose,
  // same pixels) is simply there. In the page, not fixed: locked to the
  // native scroll at both ends. The target's shadow only comes as it is set
  // down (the two shadows cross, never a smudge in an empty card). What is
  // under its path ([data-travel-fade] in the same column) gives way as it
  // passes. No target: an ordinary object.
  function travels() {
    for (const kEl of $$('[data-travel]')) {
      const o = kEl._obj; if (!o || kEl._tv) continue;
      kEl._tv = true;
      const tEl = kEl.dataset.travel ? $(kEl.dataset.travel) : null, tob = tEl && tEl._obj;
      if (!E.on) continue;
      if (!tob) { kEl.removeAttribute('data-travel'); register(o, kEl); if (!W.scrollY) { o.intro = { t0: performance.now(), dur: 1500 }; o.hot = true; } continue; }
      // (the two carry the same engraving, so the hand-over is the same pixels)
      o.pinBack = true; o.setSize(tob.size, tob.fbw);
      const sec = kEl.closest('section') || doc.body;
      const fades = $$('[data-travel-fade]', sec);
      let hx = 0, hy = 0, hw = 1, tx = 0, ty = 0, tw = 1, land = 1, foot = [];
      const T = { always: true, landed: null, tr: '', fo: -1, gq: null };
      tob.objEl.style.visibility = 'hidden';
      tob.ground.style.opacity = '0';
      T.layout = () => {
        o.setSize(tob.size, tob.fbw);
        const st = kEl.parentElement.getBoundingClientRect();
        // THEME: nothing to travel from — the product's stage folded to
        // nothing (an app's widget in the page, Kaching's): at hw = 1 the
        // object was scaled some 300 times, a blurred slab over the page.
        // It waits hidden, its target simply shown, until a layout with a
        // real size (see frame)
        T.skip = kEl.offsetWidth < 8 || st.height < 8;
        hx = st.left + st.width / 2; hy = st.top + st.height / 2 + W.scrollY; hw = kEl.offsetWidth || 1;
        const r = tEl.getBoundingClientRect();
        tx = r.left + r.width / 2; ty = r.top + r.height / 2 + W.scrollY; tw = r.width || 1;
        land = Math.max(1, ty - E.vh / 2);
        // (only what lies under the object's column gives way)
        foot = fades.filter((f) => { const b = f.getBoundingClientRect(); return b.width > 0 && b.left < st.right - 1 && b.right > st.left + 1; });
        fades.forEach((f) => { if (!foot.includes(f)) { f.style.opacity = ''; f.style.visibility = ''; } });
        T.landed = null; T.tr = ''; T.fo = -1; T.gq = null;
      };
      T.frame = (now, dt) => {
        if (T.skip) {
          // (THEME: no size to travel from: no transform, the object hidden,
          // its target and its shadow shown, what lies under the path whole;
          // written once — the next layout's reset writes it all again)
          if (T.landed !== 'skip') {
            T.landed = 'skip'; T.tr = ''; T.gq = ''; T.fo = 1;
            kEl.style.transform = ''; kEl.style.visibility = 'hidden'; o.ground.style.opacity = '';
            tob.objEl.style.visibility = ''; tob.ground.style.opacity = '';
            for (const el of foot) { el.style.opacity = ''; el.style.visibility = ''; }
            o.driver = null;
          }
          T.hot = false;
          return false;
        }
        const u = clamp(E.S / land, 0, 1), t = lerp(u, smooth(u), .5), a = Math.sin(Math.PI * t);
        const landed = u >= 1;
        if (landed !== T.landed) {
          T.landed = landed;
          kEl.style.visibility = landed ? 'hidden' : '';
          tob.objEl.style.visibility = landed ? '' : 'hidden';
        }
        const gq = landed ? '' : smooth(seg(u, .85, 1)).toFixed(3);
        if (gq !== T.gq) { T.gq = gq; tob.ground.style.opacity = gq; }
        const fo = foot.length ? 1 - seg(E.S, E.vh * .05, E.vh * .22) : 1;
        if (fo !== T.fo) {
          T.fo = fo;
          for (const el of foot) { el.style.opacity = fo < 1 ? fo.toFixed(3) : ''; el.style.visibility = fo <= 0 ? 'hidden' : ''; }
        }
        const sc = lerp(1, tw / hw, t);
        const tr = u > 0 ? `translate3d(${((tx - hx) * t).toFixed(1)}px,${((ty - hy) * t).toFixed(1)}px,0) scale(${sc.toFixed(4)})` : '';
        if (tr !== T.tr) { T.tr = tr; kEl.style.transform = tr; o.ground.style.opacity = u > 0 ? ((1 - t) * (1 - t)).toFixed(3) : ''; }
        const R0 = o.rest, R1 = tob.rest;
        o.driver = u > 0 ? { rx: lerp(R0.rx, R1.rx, t) + 22 * a, ry: lerp(R0.ry, R1.ry, t), rz: lerp(R0.rz, R1.rz, t) + 4 * a } : null;
        T.hot = o.frame(now, dt);
        return T.hot;
      };
      register(T, null);
      T.el = kEl;
      // (THEME: the object's and its stage's own sizes, watched: an app's
      // widget that folds the stage, or gives it back, once the page is up
      // need not move the page's height to be seen — the travel follows at
      // the next layout. Only on a change: nothing at rest.)
      if ('ResizeObserver' in W) { let first = true; const ro = new ResizeObserver(() => { if (first) { first = false; return; } layoutSoon(); }); ro.observe(kEl); ro.observe(kEl.parentElement); }
      // the entrance: it comes round to face the page once, as it opens
      if (!W.scrollY) { o.intro = { t0: performance.now(), dur: 1500 }; T.hot = true; }
    }
  }

  /* ---------------------------------------------------------- questions */
  // One answer open at a time; the height eases from where it is; the cross's
  // upright folds away at once. Works natively without the script.
  function questions(scope) {
    for (const q of $$('details.q', scope)) {
      if (q._q) continue; q._q = true;
      const sum = $('summary', q), a = $('.a', q);
      if (!sum || !a) continue;
      sum.addEventListener('click', (e) => {
        const box = q.closest('.qs') || q.parentElement;
        const others = $$('details.q[open]', box).filter((x) => x !== q);
        if (REDUCE) { if (!q.open) others.forEach((x) => { x.open = false; }); return; }
        e.preventDefault();
        if (q.open) close(q); else { others.forEach(close); open(q); }
      });
    }
    function open(q) {
      const a = $('.a', q);
      q.classList.remove('off'); q.classList.add('on'); q.open = true;
      const h = a.scrollHeight;
      if (q._an) q._an.cancel();
      q._an = a.animate([{ height: '0px' }, { height: `${h}px` }], { duration: Math.min(mqPhone.matches ? 300 : 520, 300 + h * .8), easing: 'cubic-bezier(.65,0,.35,1)' });
      if (a.firstElementChild) a.firstElementChild.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 500, delay: 100, fill: 'backwards', easing: 'cubic-bezier(.2,.7,.2,1)' });
      q._an.onfinish = () => { q.classList.remove('on'); q._an = null; layoutSoon(); };
    }
    function close(q) {
      const a = $('.a', q);
      q.classList.remove('on'); q.classList.add('off');
      const h = a.offsetHeight;
      if (q._an) q._an.cancel();
      q._an = a.animate([{ height: `${h}px` }, { height: '0px' }], { duration: Math.min(mqPhone.matches ? 280 : 460, 260 + h * .7), easing: 'cubic-bezier(.65,0,.35,1)' });
      q._an.onfinish = () => { q.open = false; q.classList.remove('off'); q._an = null; layoutSoon(); };
    }
  }

  /* ------------------------------------------------------------ the stars */
  // filled = on, drawn = off; a part star is the filled one cut to its part
  function stars(scope) {
    const P = 'M6 .7L7.41 4.36L11.33 4.57L8.28 7.04L9.29 10.83L6 8.7L2.71 10.83L3.72 7.04L.67 4.57L4.59 4.36Z';
    for (const el of $$('[data-stars]', scope)) {
      if (el._st) continue; el._st = true;
      const v = +el.dataset.stars;
      let h = '';
      for (let i = 0; i < 5; i++) {
        const f = clamp(v - i, 0, 1);
        h += `<svg class="st" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path class="o" d="${P}"/>` +
          (f > 0 ? `<path class="f" d="${P}"${f < 1 ? ` style="clip-path:inset(0 ${((1 - f) * 100).toFixed(0)}% 0 0)"` : ''}/>` : '') + '</svg>';
      }
      el.innerHTML = h;
    }
  }

  /* --------------------------------------------------------- the explorer */
  // <div class="kx-wrap" id="kitx-machina" data-explorer="data/machina.txt">:
  // the real manifest as a tree (folders open and close, file names without
  // the kit's prefix, a count on each folder), a search that opens the
  // folders it finds in, the keys of a tree (arrows, Home, End, Enter), the
  // path in the bar and, wide, the thing chosen in big. One listener per
  // kind of event, never one per row. No audio: the proof, file by file.
  function explorers(scope) {
    for (const host of $$('[data-explorer]', scope)) {
      if (host._kx) continue; host._kx = true;
      // THEME: data-explorer="inline": the manifest printed in the page (snippet
      // manifest-inline, in the same section): no request
      const inl = ['inline', ''].includes(host.dataset.explorer || '') ? ($('script[type="text/plain"][data-manifest]', host.closest('.shopify-section, section') || doc) || $('script[type="text/plain"][data-manifest]')) : null;
      (inl ? Promise.resolve(parseManifest(manifestText(inl))) : manifest(host.dataset.explorer))
        .then((m) => { explorer(host, m); layoutSoon(); })
        .catch(() => { const n = $('[data-kx-slot="tree"]', host); if (n) n.innerHTML = '<li class="kx-none">the file list could not be read here.</li>'; });
    }
  }
  function explorer(host, m) {
    const tree = $('[data-kx-slot="tree"]', host), insp = $('[data-kx-slot="inspector"]', host);
    const pathEl = $('[data-kx-slot="path"]', host), led = $('.kx-path .led', host);
    const input = $('.kx-search', host), clr = $('.kx-clr', host), meta = $('[data-kx-slot="meta"]', host);
    const kitName = (host.dataset.name || m.name.replace(/^.*?=\s*/, '') || 'the kit').toLowerCase();
    const R = { kind: 'dir', real: m.root || '', name: kitName, kids: [], parent: null };
    for (const f of m.folders) {
      let d = R;
      for (const part of (f.path ? f.path.split('/') : [])) {
        let c = d.kids.find((x) => x.kind === 'dir' && x.real === part);
        if (!c) { c = { kind: 'dir', real: part, name: folderLabel(part) === 'drums' ? 'drumkit' : folderLabel(part), kids: [], parent: d }; d.kids.push(c); }
        d = c;
      }
      for (const file of f.files) {
        // (no kit prefix on any name: "DRAYKI® = 808 alpha.wav" -> "808 alpha.wav")
        const nm = file.replace(/^[^=]*=\s*/, '').toLowerCase(), dot = nm.lastIndexOf('.');
        d.kids.push({ kind: 'file', real: file, name: nm, base: dot > 0 ? nm.slice(0, dot) : nm, ext: dot > 0 ? nm.slice(dot + 1) : '', parent: d });
      }
    }
    const audio = (n) => (n.kind === 'file' ? AUDIO_EXT.includes(`.${n.ext}`) : n.kids.some(audio));   // THEME: .wav .mp3 .aif .aiff .flac .ogg
    const order = (n) => {
      if (n.kind !== 'dir') return;
      const ds = n.kids.filter((k) => k.kind === 'dir'), fs = n.kids.filter((k) => k.kind === 'file');
      n.kids = [...ds.filter(audio), ...ds.filter((k) => !audio(k)), ...fs];
      n.kids.forEach(order);
    };
    order(R);
    const nodes = [];
    const walk = (n, depth) => {
      n.depth = depth; n.id = nodes.length; nodes.push(n);
      if (n.kind === 'file') { n.count = 1; return; }
      n.count = 0; n.open = false;
      for (const k of n.kids) { walk(k, depth + 1); n.count += k.count; }
    };
    walk(R, 0);
    R.open = true;
    const first = R.kids.find((k) => k.kind === 'dir'); if (first) first.open = true;
    const pathOf = (n) => { const a = []; for (let x = n; x; x = x.parent) a.unshift(x.kind === 'file' ? `${x.base}.${x.ext}` : x.name); return a; };
    const nameHTML = (n, q) => {
      if (!q) return `${esc(n.base)}<span class="kx-e">.${esc(n.ext)}</span>`;
      const s = n.name, i = s.indexOf(q);
      return i < 0 ? esc(s) : `${esc(s.slice(0, i))}<mark>${esc(s.slice(i, i + q.length))}</mark>${esc(s.slice(i + q.length))}`;
    };
    const rowHTML = (n) => {
      const lv = n.depth - 1;
      if (n.kind === 'dir') {
        // (a folder of folders — machina's drumkit, which holds the 808s and
        // the drums — gives its total only while closed: open, its folders
        // are right under it with their own counts, the same rows as the
        // object's back, and nothing on the screen says a second number)
        const sum = n.kids.some((k) => k.kind === 'dir') ? ' sum' : '';
        return `<li role="treeitem" class="kx-d" aria-expanded="${n.open}" aria-selected="false" aria-label="${esc(n.name)}, ${n.count} ${n.count === 1 ? 'file' : 'files'}" tabindex="-1" data-id="${n.id}">` +
          `<div class="kx-r" style="--lv:${lv}"><i class="kx-ch" aria-hidden="true"></i><span class="kx-nm">${esc(n.name)}</span><span class="kx-c${sum}">${n.count}</span></div>` +
          `<ul role="group"${n.open ? '' : ' hidden'}>${n.kids.map(rowHTML).join('')}</ul></li>`;
      }
      return `<li role="treeitem" class="kx-f" aria-selected="false" aria-label="${esc(n.name)}" tabindex="-1" data-id="${n.id}">` +
        `<div class="kx-r" style="--lv:${lv}"><i class="kx-no" aria-hidden="true"></i><span class="kx-nm">${nameHTML(n, '')}</span></div></li>`;
    };
    tree.innerHTML = R.kids.map(rowHTML).join('');
    for (const li of $$('[data-id]', tree)) {
      const n = nodes[+li.dataset.id]; n.li = li; n.nm = $(':scope > .kx-r .kx-nm', li);
      if (n.kind === 'dir') { n.grp = $(':scope > [role="group"]', li); n.cn = $(':scope > .kx-r .kx-c', li); }
    }
    // a folder's count: all its files, or while a search runs, the ones it
    // finds in it (the rows then agree with the head's "18 files called …")
    const setCount = (n, c) => {
      if (n.shownCount === c) return;
      n.shownCount = c; n.cn.textContent = c;
      n.li.setAttribute('aria-label', `${n.name}, ${c} ${c === 1 ? 'file' : 'files'}`);
    };
    let cur = R.kids[0], sel = null, q = '';
    if (!cur) return;
    cur.li.tabIndex = 0;
    const shown = (n) => !n.li.hidden && (n.parent === R || (n.parent.open && shown(n.parent)));
    const visible = () => nodes.filter((n) => n !== R && shown(n));
    const setOpen = (n, on) => {
      if (n.kind !== 'dir' || n === R) return;
      n.open = on; n.li.setAttribute('aria-expanded', on ? 'true' : 'false'); n.grp.hidden = !on;
    };
    const focusNode = (n, focus) => {
      if (!n) return;
      if (cur && cur.li) cur.li.tabIndex = -1;
      cur = n; n.li.tabIndex = 0;
      if (focus) n.li.focus();
    };
    // the bar and, wide, the inspector: the thing chosen, big, and where it
    // lies. While a search hides the thing chosen, they go back to the kit
    // (the bar never names a file the list is not showing; the search's
    // words are already in its field and its count in the head)
    function show(n) {
      if (q && n !== R && !shown(n)) n = R;
      const p = pathOf(n);
      pathEl.innerHTML = n === R ? `<b>${esc(R.name)}</b>${q ? '' : ' — every file'}` : `${esc(p.slice(0, -1).join(' / '))} / <b>${esc(p[p.length - 1])}</b>`;
      if (led) led.classList.toggle('on', n.kind === 'file');
      if (!insp || getComputedStyle(insp).display === 'none') return;
      let k, rows = [];
      if (n.kind === 'file') {
        k = esc(n.parent.name);
        rows = [['type', AUDIO_EXT.includes(`.${n.ext}`) ? `${n.ext} audio` : n.ext === 'png' ? 'png artwork' : n.ext === 'nfo' ? 'nfo text' : n.ext]];
      } else {
        k = n === R ? 'the kit' : 'folder';
        if (n.parent && n.parent !== R) rows.push(['in', esc(n.parent.name)]);
      }
      insp.innerHTML = `<p class="kx-k">${k}</p><p class="kx-n">${esc(n.kind === 'file' ? n.base : n.name)}</p>` +
        (rows.length ? `<ul class="kx-dl">${rows.map(([a, b]) => `<li><span>${a}</span><span>${b}</span></li>`).join('')}</ul>` : '');
    }
    const select = (n) => {
      if (sel && sel.li) sel.li.setAttribute('aria-selected', 'false');
      sel = n; if (n.li) n.li.setAttribute('aria-selected', 'true');
      show(n);
    };
    tree.addEventListener('click', (e) => {
      const li = e.target.closest('[data-id]'); if (!li || !tree.contains(li)) return;
      const n = nodes[+li.dataset.id];
      focusNode(n, true);
      if (n.kind === 'dir') setOpen(n, !n.open);
      select(n);
      layoutSoon();
    });
    tree.addEventListener('keydown', (e) => {
      const vis = visible(), i = vis.indexOf(cur);
      let to = null;
      switch (e.key) {
        case 'ArrowDown': to = vis[Math.min(vis.length - 1, i + 1)]; break;
        case 'ArrowUp': to = vis[Math.max(0, i - 1)]; break;
        case 'Home': to = vis[0]; break;
        case 'End': to = vis[vis.length - 1]; break;
        case 'ArrowRight':
          if (cur.kind === 'dir') { if (!cur.open) { setOpen(cur, true); to = cur; } else to = cur.kids.find((k) => !k.li.hidden) || cur; }
          break;
        case 'ArrowLeft':
          if (cur.kind === 'dir' && cur.open) { setOpen(cur, false); to = cur; } else if (cur.parent && cur.parent !== R) to = cur.parent;
          break;
        case 'Enter': case ' ':
          if (cur.kind === 'dir') setOpen(cur, !cur.open);
          to = cur; break;
        default: return;
      }
      e.preventDefault();
      if (to) { focusNode(to, true); select(to); }
    });
    // the search: the files whose name holds it, their folders opened
    const kept = new Map();
    const filter = (v) => {
      q = v.trim().toLowerCase();
      if (clr) clr.hidden = !v;
      if (!q) {
        for (const n of nodes) { if (n === R) continue; n.li.hidden = false; if (n.kind === 'file') n.nm.innerHTML = nameHTML(n, ''); else setCount(n, n.count); }
        for (const [n, o] of kept) setOpen(n, o);
        kept.clear();
        if (meta) meta.textContent = '';
        const none = $('.kx-none', tree); if (none) none.remove();
        if (sel) show(sel);
        layoutSoon();
        return;
      }
      let hits = 0;
      // (returns the files found under n)
      const pass = (n) => {
        if (n.kind === 'file') { const hit = n.name.includes(q); n.li.hidden = !hit; n.nm.innerHTML = nameHTML(n, hit ? q : ''); hits += hit; return +hit; }
        let found = 0;
        for (const k of n.kids) found += pass(k);
        if (n !== R) {
          if (!kept.has(n)) kept.set(n, n.open);
          n.li.hidden = !found; setOpen(n, found > 0);
          if (found) setCount(n, found);
        }
        return found;
      };
      pass(R);
      // (no hit: the list says it once; the head stays quiet)
      if (meta) meta.innerHTML = hits ? esc((hits === 1 ? S('found_one', '1 file called “{query}”') : S('found_other', '9999 files called “{query}”')).replace('{query}', q)).replace(hits === 1 ? '1' : '9999', `<b>${hits}</b>`) : '';   // THEME: the locale's words
      let none = $('.kx-none', tree);
      if (!hits) { if (!none) { none = doc.createElement('li'); none.className = 'kx-none'; tree.appendChild(none); } none.textContent = S('nothing', 'nothing called “{query}” in here.').replace('{query}', q); }
      else if (none) none.remove();
      if (cur.li.hidden) { const v0 = visible()[0]; if (v0) focusNode(v0, false); }
      if (sel) show(sel);
      layoutSoon();
    };
    if (input) {
      input.addEventListener('input', () => filter(input.value));
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && input.value) { e.preventDefault(); input.value = ''; filter(''); }
        if (e.key === 'ArrowDown' || e.key === 'Enter') { const v0 = visible()[0]; if (v0) { e.preventDefault(); focusNode(v0, true); select(v0); } }
      });
    }
    if (clr) clr.addEventListener('click', () => { input.value = ''; filter(''); input.focus(); });
    select(R);
    let rt = 0;
    W.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(() => sel && show(sel), 150); });
  }

  /* --------------------------------------------------------------- cart */
  // THEME: THE REAL CART (Shopify's), in place of the mockup's list kept in
  // the browser. Its state: the cart as the page was printed (drayki-config),
  // then as each answer brings it back — every request asks Shopify to render
  // the cart drawer with it, and every [data-cart-section] element of the
  // page (Section Rendering: the answers of /cart/add.js, /cart/change.js and
  // /cart/update.js already hold that HTML), and the state is read again in
  // the drawer's <script data-cart-state>; /cart.js is fetched only when
  // that fails. A kit is a digital good: one in the cart is never added
  // twice (its key says "in cart" and opens the cart). The tiers only say
  // what the cart will do; the discount shown is the cart's own (Kaching,
  // Shopify), never worked out here.
  const Cart = {
    st: null,
    set(c) {
      c = c || {};
      const it = Array.isArray(c.items) ? c.items : [];
      this.st = {
        items: it.map((i) => ({ key: String(i.key), h: String(i.h || ''), vid: +i.vid || 0, qty: +i.qty || 0, final: +i.final || 0, kit: i.kit != null ? !!i.kit : !!(BY[i.h] && BY[i.h].kit) })),
        count: +c.count || 0, kits: +c.kits || 0, discount: +c.discount || 0, subtotal: +c.subtotal || 0, total: +c.total || 0, sale: !!c.sale,
      };
      if (c.kits == null) this.st.kits = this.st.items.filter((i) => i.kit).reduce((a, i) => a + i.qty, 0);
    },
    // (the fallback's /cart.js: Shopify's own shape)
    fromShopify(c) {
      this.set({
        items: (c.items || []).map((i) => ({ key: i.key, h: i.handle, vid: i.variant_id, qty: i.quantity, final: i.final_line_price, kit: BY[i.handle] ? BY[i.handle].kit : !['PLUGIN', 'BUNDLE'].includes(String(i.product_type || '').toUpperCase()) })),
        count: c.item_count, discount: c.total_discount, subtotal: c.original_total_price, total: c.total_price,
        sale: (c.items || []).some((i) => (i.line_level_discount_allocations || []).some((a) => /launch/i.test(String((a.discount_application || {}).title || '')))),
      });
    },
    // a reference: a variant's id, or a product's handle (its default version, from the catalogue)
    vidOf(ref) { const s = String(ref == null ? '' : ref); if (/^\d+$/.test(s)) return +s; const k = BY[s]; return k && k.vid ? +k.vid : 0; },
    has(ref) {
      const s = String(ref == null ? '' : ref);
      if (!this.st || !s) return false;
      return /^\d+$/.test(s) ? this.st.items.some((i) => i.vid === +s) : this.st.items.some((i) => i.h === s);
    },
    items() { return this.st ? this.st.items.map((i) => Object.assign({ k: BY[i.h] || null }, i)) : []; },
    totals() {
      const s = this.st || { kits: 0, count: 0, subtotal: 0, discount: 0, total: 0 };
      const n = s.kits;
      const tier = TIERS.filter((t) => n >= t.n).pop() || null;
      const next = TIERS.find((t) => n < t.n) || null;
      return { n, count: s.count, sub: s.subtotal, off: s.discount, total: s.total, tier, next, sale: !!s.sale };
    },
  };
  // the sections every cart request brings back: the drawer, and the page's
  // own [data-cart-section] elements (/cart, /pages/bundles) — five at most
  const cartSections = () => {
    const ids = ['cart-drawer'];
    for (const el of $$('[data-cart-section]')) { const id = el.getAttribute('data-cart-section'); if (id && !ids.includes(id)) ids.push(id); }
    return ids.slice(0, 5);
  };
  const cssq = (s) => (W.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&'));
  // THEME: ONE LINE FOR THE CART. Every change (add, add many, change,
  // update, remove) and every refresh waits for the one before it, first
  // come first served: two "+ add" pressed within one round trip on a first
  // visit (no cart cookie yet) made two carts, and the first kit was lost.
  // Each step reads the cart as the step before left it (the cookie set,
  // the state read back). cartPost runs only inside a step.
  let cartQ = Promise.resolve();
  function cartQueue(run) {
    const p = cartQ.then(run, run);
    cartQ = p.then(() => {}, () => {});
    return p;
  }
  function cartPost(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(Object.assign({}, body, { sections: cartSections().join(','), sections_url: location.pathname })),
    }).then((r) => r.json().catch(() => ({})).then((j) => {
      if (!r.ok || (j && j.status && +j.status >= 400)) { const e = new Error((j && (j.description || j.message)) || String(r.status)); e.data = j; throw e; }
      return j;
    })).then((j) => applySections(j && j.sections).then(() => j));
  }
  // the sections the cart sent back, in place: the drawer's parts (see
  // swapDrawer), then each [data-cart-section] element's content — let go
  // (unmount) and mounted again. No drawer in the answer (an app changed
  // the request): the sections are asked for again, then /cart.js.
  function applySections(secs, again) {
    let got = false;
    if (secs && typeof secs === 'object') {
      const P = new DOMParser();
      for (const id in secs) {
        const html = secs[id];
        if (typeof html !== 'string') continue;
        const d = P.parseFromString(html, 'text/html');
        if (id === 'cart-drawer') { if (swapDrawer(d)) got = true; continue; }
        const fresh = d.querySelector(`[data-cart-section="${cssq(id)}"]`);
        if (!fresh) continue;
        for (const el of $$(`[data-cart-section="${cssq(id)}"]`)) { unmount(el); el.innerHTML = fresh.innerHTML; mount(el); }
      }
    }
    if (!got) return again ? refreshState() : refreshSections();
    cartChanged();
    return Promise.resolve();
  }
  function refreshState() {
    return fetch(`${ROUTES.cart}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((r) => r.json()).then((c) => { Cart.fromShopify(c); cartChanged(); }).catch(() => { cartChanged(); });
  }
  // the whole cart again (refreshCartUI: an app changed it, the page came
  // back from the history): the sections rendered for this page
  function refreshSections() {
    return fetch(`${location.pathname}?sections=${encodeURIComponent(cartSections().join(','))}`, { credentials: 'same-origin' })
      .then((r) => { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
      .then((secs) => applySections(secs, true))
      .catch(() => refreshState());
  }
  function refresh(o = {}) { return cartQueue(refreshSections).then(() => { if (o.open) openDrawer(o.from); }); }
  function cartChanged() {
    syncCount(); syncAdd();
    doc.dispatchEvent(new CustomEvent('drayki:cart', { detail: Object.assign(Cart.totals(), { items: Cart.items() }) }));
  }
  // (THEME: in the line; whether it is in the cart is read when its turn
  // comes, so a kit the step before put in is never added twice)
  function cartAdd(ref, o = {}) {
    const vid = Cart.vidOf(ref);
    if (!vid) return Promise.reject(new Error(`nothing to add: ${ref}`));
    return cartQueue(() => (Cart.has(ref) || Cart.has(vid) ? false : cartPost(`${ROUTES.cart_add}.js`, { items: [{ id: vid, quantity: 1 }] }).then(() => true)))
      .then((added) => { if (o.open) openDrawer(o.from); return added; });
  }
  // several at once (the mix's "get all 3", the vault): one request; the ones in the cart already are left out
  function cartAddMany(refs, o = {}) {
    const list = [].concat(refs || []);
    return cartQueue(() => {
      const ids = [];
      for (const r of list) {
        if (Cart.has(r)) continue;
        const vid = Cart.vidOf(r);
        if (vid && !ids.includes(vid) && !Cart.has(vid)) ids.push(vid);
      }
      return ids.length ? cartPost(`${ROUTES.cart_add}.js`, { items: ids.map((id) => ({ id, quantity: 1 })) }).then(() => true) : false;
    }).then((added) => { if (o.open) openDrawer(o.from); return added; });
  }
  // a line's key, a variant's id or a product's handle -> the lines' keys
  function keysOf(ref) {
    const s = String(ref == null ? '' : ref);
    if (!Cart.st || !s) return [];
    if (Cart.st.items.some((i) => i.key === s)) return [s];
    return /^\d+$/.test(s) ? Cart.st.items.filter((i) => i.vid === +s).map((i) => i.key) : Cart.st.items.filter((i) => i.h === s).map((i) => i.key);
  }
  // (the vault, grouped in the cart: the lines of every kit of the collection)
  const vaultKeys = () => (Cart.st ? Cart.st.items.filter((i) => KITS.some((k) => k.h === i.h)).map((i) => i.key) : []);
  // (THEME: in the line too: the lines' keys are read when its turn comes)
  function cartRemove(ref) {
    return cartQueue(() => {
      const keys = ref === '*' ? (Cart.st ? Cart.st.items.map((i) => i.key) : []) : ref === 'vault' ? vaultKeys() : keysOf(ref);
      if (!keys.length) return false;
      if (keys.length === 1) return cartPost(`${ROUTES.cart_change}.js`, { id: keys[0], quantity: 0 }).then(() => true);
      const updates = {};
      for (const k of keys) updates[k] = 0;
      return cartPost(`${ROUTES.cart_update}.js`, { updates }).then(() => true);
    });
  }
  function changeQty(ref, q) {
    q = Math.max(0, Math.round(+q || 0));
    if (!q) return cartRemove(ref);
    // (not in the cart when its turn comes: added, in the line again)
    return cartQueue(() => { const keys = keysOf(ref); return keys.length ? cartPost(`${ROUTES.cart_change}.js`, { id: keys[0], quantity: q }).then(() => true) : null; })
      .then((r) => (r === null ? cartAdd(ref) : r));
  }
  function syncCount() {
    const n = Cart.st ? Cart.st.count : 0;
    for (const el of $$('[data-cart-count], #cart-count')) { el.textContent = n; el.dataset.n = n; }
    // (THEME: [data-cart-bubble] is the pill that carries the count: its state; a bare bubble, its number)
    for (const el of $$('[data-cart-bubble]')) { el.dataset.n = n; if (!el.firstElementChild) el.textContent = n; }
    for (const el of $$('[data-cart-open]')) {
      el.dataset.n = n;
      el.setAttribute('aria-label', n === 1 ? S('cart_one', 'cart, 1 kit') : S('cart_other', 'cart, 9999 kits').replace('9999', String(n)));
      el.setAttribute('aria-haspopup', 'dialog'); el.setAttribute('aria-controls', 'cart-drawer');
    }
  }
  // what the bundle does now, in one line (the add bar's; the cart's own is
  // printed by the snippet cart-tier). THEME: the words of the locale.
  const pct = (t) => S('off', '−{percent} %').replace('{percent}', String(Math.round(t.say * 100)));
  const pcOf = (t) => `<span class="off">${esc(pct(t))}</span>`;
  const wrapPc = (s, t) => esc(s).replace(esc(pct(t)), pcOf(t));
  function bundleLine(T, short) {
    if (!T.n) return '';
    // (r8) the launch sale: its −50 % is the cart's, never a tier's
    if (T.sale) return `${esc('launch —')} ${pcOf({ say: .5 })} ${esc('on every kit')}`;
    // THEME: a tier is claimed only when the cart really takes something off
    // (T.off, the cart's own discount: Kaching's or Shopify's). None: only
    // what the next tier would do, when it is in reach, else nothing (the
    // add bar then says the promises) — the rule of cart-tier.
    const real = T.off > 0;
    if (T.next && (T.next !== VAULT || T.next.n - T.n <= 2)) {
      const m = T.next.n - T.n;
      // (the bar is one short line: what the cart already takes off, then what one more would)
      const nx = wrapPc(S('next_tier', 'add {count} more → −{percent} %').replace('{count}', String(m)).replace('{percent}', String(Math.round(T.next.say * 100))), T.next);
      return short && T.tier && real ? `${pcOf(T.tier)} · ${nx}` : nx;
    }
    if (!real) return '';
    if (T.tier === VAULT) return wrapPc(S('whole_vault', 'the whole vault, −{percent} %.').replace('{percent}', String(Math.round(VAULT.say * 100))), VAULT);
    if (T.tier) {
      // (the add bar: the tier in the cart, as the mockup's short line; the cart's own line is cart-tier's)
      if (short) return wrapPc(S('in_cart_tier', '{count} kits · −{percent} % in the cart').replace('{count}', String(T.n)).replace('{percent}', String(Math.round(T.tier.say * 100))), T.tier);
      const at = wrapPc(S('tier_reached', '−{percent} % on the {count} kits.').replace('{percent}', String(Math.round(T.tier.say * 100))).replace('{count}', String(T.n)), T.tier);
      return `${at} ${wrapPc(S('vault_offer', 'or the vault: all {count}, −{percent} %').replace('{count}', String(VAULT.n)).replace('{percent}', String(Math.round(VAULT.say * 100))), VAULT)} — <a class="lnk" href="${esc(VAULT_URL)}">${esc(S('vault_link', 'open the vault'))}</a>`;
    }
    return '';
  }
  // THEME: every add key of the page, one listener (delegated, see
  // delegates(): the keys the cart brings back in its sections work at
  // once, and a section reloaded in the editor never gets a second one)
  function onAdd(e, b) {
    e.preventDefault();
    if (b.disabled || b.getAttribute('aria-busy') === 'true') return;
    const h = b.dataset.add, ref = b.dataset.variant || h, had = Cart.has(ref);
    const inDrawer = !!b.closest('.drawer');
    // (inside the cart: into it, the cart follows; a key already "in cart" opens it)
    if (had) { if (!inDrawer) openDrawer(b); return; }
    b.setAttribute('aria-busy', 'true');
    cartAdd(ref).then(() => {
      if (inDrawer) { if (DW) DW.dw.focus({ preventScroll: true }); return; }
      // a product page's own pill opens the cart; a card's add key does not
      // (the add bar says it, and a 2nd and 3rd kit are one tap each)
      if (b.hasAttribute('data-open')) openDrawer(b); else note(h, b);
    }).catch((err) => { console.error(err); note(h, b, err); })
      .finally(() => { b.removeAttribute('aria-busy'); });
  }
  function addButtons(scope) { syncAdd(scope); }
  function syncAdd(scope = doc) {
    for (const b of $$('[data-add]', scope)) {
      const ref = b.dataset.variant || b.dataset.add, on = Cart.has(ref);
      if (b._on === on && b._ref === ref) continue; b._on = on; b._ref = ref;
      b.classList.toggle('on', on);
      if (b.disabled) continue;   // (THEME: sold out: its words stay)
      // its words: "add" / "in cart", or data-label's ("get {name}" -> "get 10k" / "10k in cart")
      const k = BY[b.dataset.add], lab = b.dataset.label, name = (k && k.name) || b.dataset.name || '';
      const s = $('.lb', b) || $('span', b);
      if (s) s.textContent = on ? (lab && lab.includes('{name}') && name ? `${name} ${S('in_cart', 'in cart')}` : S('in_cart', 'in cart')) : (lab ? lab.replace('{name}', name) : S('add', 'add'));
    }
  }
  // THEME: "get the vault" ([data-vault-add]): every kit of the collection
  // at once (the vault's "kits" mode), or the vault product's version
  // ("product" mode) — then the cart opens
  function vaultAdd(el) {
    const v = CONFIG.vault || {};
    if (el.getAttribute('aria-busy') === 'true') return;
    el.setAttribute('aria-busy', 'true');
    // (r8) the cart's own key (its tier bar, in the drawer or on /cart): into it, the cart follows
    const inDrawer = !!el.closest('.drawer'), o = inDrawer || onCartPage() ? {} : { open: true, from: el };
    const go = v.mode === 'product' && v.variant ? cartAdd(v.variant, o) : cartAddMany(Array.isArray(v.handles) && v.handles.length ? v.handles : KITS.map((k) => k.h), o);
    go.then(() => { if (inDrawer && DW) DW.dw.focus({ preventScroll: true }); })
      .catch((err) => { console.error(err); note(null, el, err); }).finally(() => { el.removeAttribute('aria-busy'); });
  }
  // THEME: "remove" ([data-rm]: a line's key, or "vault"), in the cart or on /cart
  function removeFrom(rm) {
    if (rm.getAttribute('aria-busy') === 'true') return;
    const inDrawer = !!rm.closest('.drawer');
    rm.setAttribute('aria-busy', 'true');
    cartRemove(rm.dataset.rm).then(() => {
      // (the focus goes on: to the next "remove" of the cart, or its close key)
      if (inDrawer && DW) { const f = $('[data-rm]', DW.dw) || $('[data-dw-x]', DW.dw); if (f) f.focus({ preventScroll: true }); }
    }).catch((err) => { console.error(err); note(null, rm, err); })
      .finally(() => { if (rm.isConnected) rm.removeAttribute('aria-busy'); });
  }
  // THEME: a product's version changed (the product page's picker says so:
  // drayki:variant, { h, variant: { id, title, price, compare, avail } }):
  // its prices, its keys (the version they add, their words) follow
  function onVariant(e) {
    const d = (e && e.detail) || {}, h = d.h, v = d.variant || {};
    if (!h || !v.id) return;
    const k = BY[h];
    if (k) { k.vid = +v.id; k.price = +v.price || 0; k.compare = +v.compare > +v.price ? +v.compare : null; k.avail = v.avail !== false; }
    const cmp = +v.compare > +v.price;
    for (const el of $$('[data-price]').filter((x) => x.dataset.price === h)) {
      el.innerHTML = `<b>${esc(fmt(v.price))}</b>${cmp ? `<s><span class="vh">${esc(S('was', 'was'))} </span>${esc(fmt(v.compare))}</s>` : ''}`;
    }
    for (const el of $$('[data-price-off]').filter((x) => x.dataset.priceOff === h)) {
      el.hidden = !cmp;
      el.textContent = cmp ? S('off', '−{percent} %').replace('{percent}', String(Math.round((v.compare - v.price) * 100 / v.compare))) : '';
    }
    for (const b of $$('[data-add]').filter((x) => x.dataset.add === h)) {
      b.dataset.variant = String(v.id); b._on = null;
      b.disabled = v.avail === false;
      if (b.disabled) { const s = $('.lb', b) || $('span', b); if (s) s.textContent = S('sold_out', 'sold out'); }
    }
    syncAdd();
  }

  /* ------------------------------------------------------------ the add bar */
  let AB = null;
  function addbarDOM() {
    if (AB) return AB;
    const el = doc.createElement('div');
    el.className = 'addbar';
    el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
    el.innerHTML = `<p class="ab-t"><span class="nm"></span><span class="nx"></span></p><a class="go sm" href="${esc(ROUTES.cart)}" data-cart-open><span class="lb">${esc(S('cart_title', 'cart'))}</span>${arrow(true)}</a>`;   // THEME: the cart's page without the script; the locale's word
    doc.body.appendChild(el);
    // (THEME: its cart key is one of the page's [data-cart-open]: the delegated listener opens the cart)
    AB = { el, nm: $('.nm', el), nx: $('.nx', el), y0: 0, t: 0 };
    // a finger put down anywhere else (but on another add key, which
    // updates it) sends it away at once: it never waits over the page
    doc.addEventListener('pointerdown', (e) => {
      if (AB.el.classList.contains('on') && !AB.el.contains(e.target) && !(e.target.closest && e.target.closest('[data-add]'))) hideNote();
    }, { passive: true, capture: true });
    return AB;
  }
  // Where it comes up: at the foot (the thumb's), unless that would cover
  // one of the next add keys (not in the cart yet, in the pressed key's row
  // or below it: the next tap) — then under the top line, if none of those
  // is there. Read once, as it comes up.
  function placeNote(A, from) {
    const vh = W.innerHeight, h = A.el.offsetHeight + 28;   // (its height, its margin, and a little air: never flush on a key)
    const hh = TOP ? TOP.getBoundingClientRect().bottom : 0;
    const y = from && from.isConnected ? from.getBoundingClientRect().top - 4 : -1e4;
    const next = (y0, y1) => $$('[data-add]').some((b) => {
      if (b.classList.contains('on') || b.closest('.drawer, .dock, .top')) return false;
      const r = b.getBoundingClientRect();
      return r.width > 0 && r.top >= y && r.bottom > y0 && r.top < y1;
    });
    const top = next(vh - h, vh) && !next(hh, hh + h);
    if (top === A.el.classList.contains('at-top')) return;
    // (the side changes while it is down: no slide between the two sides)
    A.el.style.transition = 'none';
    A.el.classList.toggle('at-top', top);
    void A.el.offsetWidth;
    A.el.style.transition = '';
  }
  // (THEME: err — the cart said no: its word, instead of the kit's)
  function note(h, from, err) {
    const A = addbarDOM(), k = BY[h], T = Cart.totals();
    const name = k ? k.name : (from && from.dataset && from.dataset.name) || '';
    if (err) {
      A.nm.textContent = S('error', "that didn't work. try again.");
      A.nx.textContent = err.data && err.data.description ? String(err.data.description).toLowerCase() : '';
    } else {
      A.nm.textContent = S('added', '{name} in the cart').replace('{name}', name);
      A.nx.innerHTML = bundleLine(T, true) || esc(S('promises', 'instant download · royalty-free'));
    }
    // (already up: it stays where it is, only its words change)
    if (!A.el.classList.contains('on')) placeNote(A, from);
    A.el.classList.add('on'); A.y0 = W.scrollY;
    for (const dk of $$('.dock')) dk.classList.add('held');
    barsUp();
    syncCount();
    clearTimeout(A.t); A.t = setTimeout(hideNote, 4000);
  }
  function hideNote() {
    if (!AB || !AB.el.classList.contains('on')) return;
    clearTimeout(AB.t);
    AB.el.classList.remove('on');
    for (const dk of $$('.dock')) dk.classList.remove('held');
    barsUp();
  }

  /* -------------------------------------------------------- the drawer */
  let DW = null, opener = null;
  // THEME: the drawer is the theme's section cart-drawer (printed by Liquid,
  // then swapped part by part by the cart's answers, see swapDrawer): the
  // script adopts it instead of building it; its behaviour is the mockup's
  // (a dialog: focus trapped, Escape, focus back to its opener; a phone's
  // sheet pulled down by its head). Adopted again when the editor reloads it.
  function drawerDOM() {
    if (DW && DW.dw.isConnected) return DW;
    DW = null;
    const dw = doc.getElementById('cart-drawer');
    if (!dw) return null;
    const pv = dw.previousElementSibling;
    const scrim = $('[data-dw-scrim]') || (pv && pv.classList.contains('scrim') ? pv : null);
    DW = { scrim, dw, body: $('[data-dw-body]', dw), n: $('[data-dw-n]', dw), end: $('[data-dw-end]', dw), sum: $('[data-dw-sum]', dw), open: dw.classList.contains('open') };
    if (dw._dw) return DW;
    dw._dw = true;
    if (scrim) scrim.addEventListener('click', closeDrawer);
    dw.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      const f = $$('a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])', dw).filter((x) => x.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (doc.activeElement === first || doc.activeElement === dw)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    // ("remove" and "+ add" in it: the page's delegated listener; the close key here)
    dw.addEventListener('click', (e) => { if (e.target.closest('[data-dw-x]')) closeDrawer(); });
    const head = $('.dw-top', dw);
    if (head) pullDown(head, dw);
    return DW;
  }
  // A phone's sheet is pulled down by its head: it follows the finger (a
  // pull up gives a little and no more), and goes when let go past a third
  // of its height (at most 140px) or with a downward flick; else it springs
  // back. Only a transform, only while held.
  function pullDown(head, dw) {
    let id = null, y0 = 0, dy = 0, ly = 0, lt = 0, v = 0;
    head.addEventListener('pointerdown', (e) => {
      if (!mqPhone.matches || id !== null || (e.pointerType === 'mouse' && e.button !== 0) || e.target.closest('button, a')) return;
      id = e.pointerId; y0 = ly = e.clientY; lt = e.timeStamp; dy = 0; v = 0;
      try { head.setPointerCapture(id); } catch (err) { /* ignore */ }
    });
    head.addEventListener('pointermove', (e) => {
      if (e.pointerId !== id) return;
      dy = e.clientY - y0;
      const dt = Math.max(1, e.timeStamp - lt); v = lerp(v, (e.clientY - ly) / dt, .5); ly = e.clientY; lt = e.timeStamp;
      if (!dw.classList.contains('held')) { if (Math.abs(dy) < 4) return; dw.classList.add('held'); }
      const t = dy >= 0 ? dy : -Math.min(24, Math.sqrt(-dy) * 2.4);
      dw.style.transform = `translateY(${t.toFixed(1)}px)`;
    });
    const up = (e) => {
      if (e.pointerId !== id) return;
      id = null;
      if (!dw.classList.contains('held')) return;
      const go = e.type !== 'pointercancel' && (dy > Math.min(140, dw.offsetHeight / 3) || (v > .45 && dy > 20));
      dw.classList.remove('held');
      dw.style.transform = '';
      if (go) closeDrawer();
    };
    head.addEventListener('pointerup', up);
    head.addEventListener('pointercancel', up);
  }
  // THEME: the drawer the cart sent back (a parsed document), in place: its
  // count, its body, its foot and its state — the panel itself stays, open
  // or not, with its focus kept where it can be; the bar fills from what was
  // last seen (barSync). Returns whether the cart's state was read.
  function swapDrawer(d) {
    const dw = drawerDOM(), nd = d && d.getElementById('cart-drawer');
    if (!dw || !nd) return false;
    const st = $('script[data-cart-state]', nd);
    let ok = false;
    if (st) { try { Cart.set(JSON.parse(st.textContent || '{}')); ok = true; } catch (e) { ok = false; } }
    const had = dw.dw.contains(doc.activeElement) && doc.activeElement !== dw.dw;
    for (const sel of ['[data-dw-n]', '[data-dw-body]', '[data-dw-end]', 'script[data-cart-state]']) {
      const a = $(sel, dw.dw), b = $(sel, nd);
      if (!a || !b) continue;
      if (sel === '[data-dw-body]' || sel === '[data-dw-end]') unmount(a);
      a.innerHTML = b.innerHTML;
      a.hidden = b.hasAttribute('hidden');
      if (sel === '[data-dw-body]' || sel === '[data-dw-end]') mount(a);
    }
    dw.sum = $('[data-dw-sum]', dw.dw);
    if (had && !dw.dw.contains(doc.activeElement) && dw.open) dw.dw.focus({ preventScroll: true });
    barSync();
    return ok;
  }
  // where n kits stand on the bar: each tier ends a step of the same length
  // (2 kits a third of the way, 3 kits two thirds, the vault the end), and
  // between two tiers the kits share the step (1 kit: half the first)
  function barAt(n) {
    let a = 0;
    for (let i = 0; i < TIERS.length; i++) {
      const lo = i ? TIERS[i - 1].n : 0, hi = TIERS[i].n;
      if (n >= hi) { a = (i + 1) / TIERS.length; continue; }
      return a + clamp((n - lo) / (hi - lo), 0, 1) / TIERS.length;
    }
    return 1;
  }
  // the bar fills (or empties) from what was last seen in the open cart to
  // what the cart holds now, in the next frame (a transition of its fill:
  // transform only, then nothing runs); the LEDs light as it passes them.
  // Closed, the cart keeps what was seen: opened after an add from a card,
  // it fills in front of the eye. Reduced motion: at once.
  const BAR = { seen: null, raf: 0 };
  // THEME: the bar is printed by Liquid at the cart's state (cart-tier: --p
  // and data-p on the fill, .on on the tiers reached). Open (or swapped while
  // open), it is set back to where it was last seen in the open cart — at
  // once, no transition — and eased to the printed state two frames later
  // (a transition of its fill: transform only, then nothing runs; the LEDs
  // light as it passes them). Closed, the cart keeps what was seen: opened
  // after an add from a card, it fills in front of the eye; the first time,
  // from zero. Reduced motion: as printed.
  const barOf = (box) => { const f = $('.dt-f', box); return { at: f ? parseFloat(f.getAttribute('data-p') || f.style.getPropertyValue('--p')) || 0 : 0, on: $$('.dt-l > li', box).map((li) => li.classList.contains('on')) }; };
  function barSet(box, to, now) {
    const f = $('.dt-f', box), lis = $$('.dt-l > li', box), leds = lis.map((li) => $('.led', li));
    const still = [f, ...lis, ...leds].filter(Boolean);
    if (now) for (const x of still) x.style.transition = 'none';
    if (f) f.style.setProperty('--p', to.at.toFixed(4));
    lis.forEach((li, i) => { li.classList.toggle('on', !!to.on[i]); if (leds[i]) leds[i].classList.toggle('on', !!to.on[i]); });
    if (now) { void box.offsetWidth; for (const x of still) x.style.transition = ''; }
  }
  function barSync() {
    if (!DW) return;
    W.cancelAnimationFrame(BAR.raf);
    const box = $('.dw-tier', DW.body);
    if (!box) { if (DW.open) BAR.seen = null; return; }
    const to = barOf(box);
    if (!DW.open) return;
    const from = BAR.seen || { at: 0, on: to.on.map(() => false) };
    BAR.seen = to;
    if (from.at === to.at || REDUCE) { barSet(box, to, true); return; }
    // (two frames: the first paints where it was, the second moves it)
    barSet(box, from, true);
    BAR.raf = W.requestAnimationFrame(() => { BAR.raf = W.requestAnimationFrame(() => barSet(box, to, false)); });
  }
  function openDrawer(from) {
    const d = drawerDOM();
    if (!d) { location.href = ROUTES.cart; return; }   // (THEME: no drawer on this page: the cart's own page)
    hideNote();
    d.open = true;
    opener = from || doc.activeElement;
    if (d.scrim) d.scrim.classList.add('open');
    d.dw.classList.add('open');
    root.style.setProperty('--sb', `${Math.max(0, W.innerWidth - root.clientWidth)}px`);
    root.classList.add('lock');
    overlayChanged();
    barSync();   // (THEME: in place of renderDrawer: the bar fills from what was last seen)
    // focus goes to the panel itself (announced as the dialog; the next Tab reaches its first control)
    setTimeout(() => d.dw.focus({ preventScroll: true }), 60);
  }
  function closeDrawer() {
    if (!DW || !DW.dw.classList.contains('open')) return;
    DW.open = false;
    if (DW.scrim) DW.scrim.classList.remove('open'); DW.dw.classList.remove('open');
    root.classList.remove('lock');
    overlayChanged();
    if (opener && opener.focus && opener.isConnected) opener.focus({ preventScroll: true });
    opener = null;
  }
  // THEME: on the cart's own page (/cart, a market's prefix with it) the
  // cart is the page: what opens the cart brings its top back to the eye
  // and gives it the focus — the drawer over it showed the same cart twice
  const onCartPage = () => { const b = (s) => String(s || '').replace(/\/+$/, '') || '/'; return b(location.pathname) === b(ROUTES.cart); };
  function toCartTop() {
    hideNote();
    const m = doc.getElementById('main');
    if (!m) { W.scrollTo(0, 0); return; }
    m.scrollIntoView({ block: 'start', behavior: E.on ? 'smooth' : 'auto' });
    m.focus({ preventScroll: true });
  }

  /* --------------------------------------------------------- the theme */
  // (r7, drayki: "les deux thèmes qu'on garde sont violet night et le light
  // mode, j'aimerais qu'on puisse switch le thème via une icône dans le
  // header, et que ça se synchronise en fonction de notre thème actuel sur
  // l'appareil sur lequel on regarde le site") Two palettes: paper stock
  // (light) and violet night (dark). The page FOLLOWS THE DEVICE by default
  // (prefers-color-scheme), live: turn the phone dark with the page open and
  // it turns. The icon in the top line (<button data-theme-toggle>, a half
  // filled circle, aria-pressed = dark) turns it over, and that choice is
  // kept WITH THE DEVICE'S OWN IT WAS MADE AGAINST (localStorage
  // 'drayki-theme' = 'night@paper': night, pressed while the device was
  // light; 'paper@night' the other way) — and only while the device stays
  // there. (r7: kept for good, one press made the page stop following the
  // device: pressed to night on a light phone, the phone turned dark and
  // back, the page stayed night — "the sync doesn't work".) The device
  // turning is the latest word: the choice goes, the page follows it, live
  // or at the next visit. A press that brings back the device's own keeps
  // nothing. (An old plain 'night' / 'paper' — or 'dark' / 'light' — is
  // read as made against the device of the moment, and written so.) The
  // head's script sets it before the first paint (no flash), with the same
  // rule. The turn: the new palette wipes out from the icon in a circle, a
  // little over half a second (a view transition: two pictures of the page,
  // nothing laid out again, no fade of every element); at once where motion
  // is reduced or the browser has no view transitions.
  const PAL = { paper: ['light', '#edeae4'], night: ['dark', '#1d1748'] };
  const mqDark = W.matchMedia('(prefers-color-scheme: dark)');
  const sysTheme = () => (mqDark.matches ? 'night' : 'paper');
  const palOf = (t) => (t === 'night' || t === 'dark' ? 'night' : t === 'paper' || t === 'light' ? 'paper' : null);
  // the choice kept, if the device is still where it was when it was made
  // (else it goes); an old plain value is pinned to the device of the moment
  const keptTheme = () => {
    const raw = store.get('drayki-theme');
    if (!raw) return null;
    const [a, b] = String(raw).split('@'), c = palOf(a), dev = palOf(b), sys = sysTheme();
    if (!c || c === sys || (dev && dev !== sys)) { store.del('drayki-theme'); return null; }
    if (!dev) store.set('drayki-theme', `${c}@${sys}`);
    return c;
  };
  // a band in the other palette: violet night on paper, paper on violet night
  function others() {
    const want = (root.getAttribute('data-theme') || 'paper') === 'night' ? 'paper' : 'night';
    for (const el of $$('[data-other]')) if (el.getAttribute('data-theme') !== want) el.setAttribute('data-theme', want);
  }
  function theme() {
    const cur = () => (root.getAttribute('data-theme') === 'night' ? 'night' : 'paper');
    const apply = (p) => {
      // (for the frame the palette changes in, no colour eases on its own
      // clock: every element turns at once, in the picture or out of it)
      root.classList.add('th-now');
      root.setAttribute('data-theme', p);
      // THEME: the theme's own colours (css-variables). HALO's download page
      // is its dark plate from edge to edge (html's own ground there, see
      // the style; theme-init prints it): the browser's bar keeps that
      const m = $('meta[name="theme-color"]');
      if (m) {
        const plate = $('.halo-get[data-room]') ? getComputedStyle(root).backgroundColor : null;
        if (plate == null) m.setAttribute('content', getComputedStyle(root).getPropertyValue('--bg').trim() || PAL[p][1]);
        else if (plate && plate !== 'transparent' && !/^rgba\(.*,\s*0\)$/.test(plate)) m.setAttribute('content', plate);
      }
      for (const b of $$('[data-theme-toggle]')) { b.setAttribute('aria-pressed', p === 'night' ? 'true' : 'false'); b.setAttribute('aria-label', S('dark_mode', 'dark mode')); }
      others();
      if (D.ready) { headerLayout(); layoutSoon(0); }
      W.requestAnimationFrame(() => W.requestAnimationFrame(() => root.classList.remove('th-now')));
      W.dispatchEvent(new CustomEvent('drayki:theme', { detail: { theme: p } }));
    };
    const set = (p, from) => {
      if (p === cur()) return;
      // (r8, drayki: "quand on passe en dark mode ou light mode la cover se retourne en mode miroir un
      // instant sur mobile") a touch screen's browser flattens the 3D covers in the transition's pictures
      // (their backs drawn over their faces): there the page turns at once, no wipe
      const vt = from && doc.startViewTransition && !REDUCE && !doc.hidden && !mqCoarse.matches ? doc.startViewTransition(() => apply(p)) : null;
      if (!vt) { apply(p); return; }
      // (the wipe: from the icon's centre to the farthest corner of the screen)
      const r = from.getBoundingClientRect(), x = r.left + r.width / 2, y = r.top + r.height / 2;
      const R = Math.ceil(Math.hypot(Math.max(x, W.innerWidth - x), Math.max(y, W.innerHeight - y)));
      root.classList.add('vt-wipe');
      vt.ready.then(() => {
        root.animate({ clipPath: [`circle(0px at ${x}px ${y}px)`, `circle(${R}px at ${x}px ${y}px)`] },
          { duration: 560, easing: 'cubic-bezier(.65, 0, .35, 1)', pseudoElement: '::view-transition-new(root)' });
      }).catch(() => {});
      vt.finished.finally(() => root.classList.remove('vt-wipe'));
    };
    const toggle = (from) => {
      const p = cur() === 'night' ? 'paper' : 'night', sys = sysTheme();
      if (p === sys) store.del('drayki-theme'); else store.set('drayki-theme', `${p}@${sys}`);
      set(p, from);
    };
    apply(keptTheme() || sysTheme());
    // the device turns: followed, always — a choice made against the other
    // side of the device goes with it
    onMQ(mqDark, () => { store.del('drayki-theme'); set(sysTheme(), null); });
    // (another tab turned it)
    W.addEventListener('storage', (e) => { if (e.key === 'drayki-theme') set(keptTheme() || sysTheme(), null); });
    W.draykiToggleTheme = () => toggle(null);
    THEME.toggle = toggle; THEME.cur = cur;
  }
  // (every theme key, the header's and one a section brings later)
  const THEME = { toggle: null, cur: null };
  function themeKeys(scope) {
    for (const b of $$('[data-theme-toggle]', scope)) {
      if (b._th || !THEME.toggle) continue; b._th = true;
      b.setAttribute('aria-pressed', THEME.cur() === 'night' ? 'true' : 'false');
      if (!b.hasAttribute('aria-label')) b.setAttribute('aria-label', S('dark_mode', 'dark mode'));
      b.addEventListener('click', () => THEME.toggle(b));
    }
  }

  /* ----------------------------------------------------- the top line */
  let TOP = null, rooms = [];
  const H = {};
  function header() {
    TOP = $('.top');
    if (!TOP) return;
    const mb = $('.menu-b', TOP);
    const nav = $('.nav', TOP);
    let panel = $('.top-p', TOP);
    if (!panel && nav) {
      panel = doc.createElement('div'); panel.className = 'top-p';
      nav.before(panel);
      panel.appendChild(nav);
    }
    if (panel && !panel.id) panel.id = 'top-p';
    if (!mb || !panel) return;
    mb.setAttribute('aria-controls', panel.id);
    if (mb.compareDocumentPosition(panel) & Node.DOCUMENT_POSITION_PRECEDING) panel.before(mb);
    const was = $('body > .mscrim'); if (was) was.remove();   // THEME: a header reloaded in the editor: one scrim
    const scrim = doc.createElement('div'); scrim.className = 'mscrim'; scrim.setAttribute('aria-hidden', 'true');
    doc.body.appendChild(scrim);
    let y0 = 0;
    const isOpen = () => TOP.classList.contains('open');
    const setOpen = (on, back) => {
      if (on === isOpen()) return;
      TOP.classList.toggle('open', on); scrim.classList.toggle('open', on);
      mb.setAttribute('aria-expanded', on ? 'true' : 'false'); mb.textContent = on ? S('close', 'close') : S('menu', 'menu');
      y0 = W.scrollY;
      overlayChanged();
      if (!on && back) mb.focus({ preventScroll: true });
    };
    H.menu = setOpen;
    mb.addEventListener('click', () => setOpen(!isOpen()));
    scrim.addEventListener('click', () => setOpen(false));
    TOP.addEventListener('keydown', (e) => { if (e.key === 'Escape' && isOpen()) { setOpen(false, true); } });
    panel.addEventListener('click', (e) => { if (e.target.closest('a')) setOpen(false); });
    TOP.addEventListener('focusout', (e) => { if (isOpen() && e.relatedTarget && !TOP.contains(e.relatedTarget)) setOpen(false); });
    // (THEME: called by the page's one scroll listener and the menu query's one listener: a header reloaded in the editor replaces them)
    H.scroll = () => { if (isOpen() && Math.abs(W.scrollY - y0) > 24) setOpen(false); };
    H.mq = (e) => { if (!e.matches) setOpen(false); };
  }
  function headerLayout() {
    rooms = $$('[data-room]').map((r) => { const b = r.getBoundingClientRect(); return { top: b.top + W.scrollY, bottom: b.bottom + W.scrollY, theme: r.getAttribute('data-theme') }; });
    E.hh = TOP ? TOP.offsetHeight : 0;
    headerScroll();
  }
  function headerScroll() {
    if (!TOP) return;
    const y = E.Y;
    const lifted = y > 2;
    if (lifted !== TOP._l) { TOP._l = lifted; TOP.classList.toggle('lifted', lifted); }
    const mid = y + E.hh / 2;
    const r = rooms.find((x) => mid >= x.top && mid < x.bottom);
    const th = r ? r.theme : '';
    if (th !== TOP._th) { TOP._th = th; if (th) TOP.setAttribute('data-theme', th); else TOP.removeAttribute('data-theme'); }
  }

  /* ------------------------------------------------------------ the dock */
  // <aside class="dock" data-dock="#buy-gone">: the product page's slim bar.
  // It comes up once the element the attribute names has gone above the
  // screen, and goes down while anything [data-dock-hide], the newsletter
  // or the foot is on the screen. Where the dock is not drawn (wide), the
  // same state puts the page's pill in the top line (.top-buy on <html>).
  // Observers only: nothing runs on scroll, nothing at rest.
  function docks(scope = doc) {
    for (const dk of $$('[data-dock]', scope)) {
      if (dk._dock) continue; dk._dock = true;
      dk.classList.add('dock');
      if (!('IntersectionObserver' in W)) continue;
      const watch = dk.dataset.dock ? $(dk.dataset.dock) : null;
      const hides = $$('[data-dock-hide], .foot-s, .nl');
      let above = !watch;
      const seen = new Set();
      const sync = () => {
        const on = above && !seen.size;
        if (on !== dk._on) { dk._on = on; dk.classList.toggle('on', on); }
        root.classList.toggle('top-buy', on && !mqDock.matches);
        barsUp();
      };
      onMQ(mqDock, sync);
      const hh = TOP ? TOP.offsetHeight : 0;
      const ob = new IntersectionObserver((es) => {
        for (const e of es) {
          if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target);
          if (e.target === watch) above = !e.isIntersecting && e.boundingClientRect.bottom <= hh + 1;
        }
        sync();
      }, { rootMargin: `-${hh}px 0px 0px 0px` });
      if (watch) ob.observe(watch);
      hides.forEach((h) => ob.observe(h));
    }
  }

  /* ------------------------------------------------------- the newsletter */
  // get exclusive access (a mockup: nothing is sent; in the theme, Shopify's customer form)
  function newsletters(scope) {
    for (const f of $$('.nl-f', scope)) {
      if (f._nl) continue; f._nl = true;
      // THEME: a newsletter is a form with an email field (the search page's
      // field wears .nl-f too, and goes as it is); its word is the one in its
      // own container, never another's on the page
      const i = $('input[type="email"]', f);
      if (!i) continue;
      const said = f.parentElement ? $('.nl-said', f.parentElement) : null;
      f.addEventListener('submit', (e) => {
        // THEME: a good address goes (Shopify's customer form: the page comes back with its word); a wrong one stays here
        // — and no one else hears of it: Shopify's bot check (its hCaptcha, bound to the form after this) opened a challenge for an address never sent
        if (!i.value || !i.checkValidity()) { e.preventDefault(); e.stopImmediatePropagation(); if (said) said.textContent = S('email_error', 'that email doesn’t look right.'); i.focus(); }
      });
    }
  }

  /* ------------------------------------------------ made with (the player) */
  // (r6, drayki: "un « made with --- » avec les previews. actuellement
  // j'utilise untitled mais si tu peux me dev un truc dans le style du site
  // ça serait bcp plus cool") HALO's listen, made the store's:
  //   <div class="mw" data-madewith></div>                   every track
  //   <div class="mw" data-madewith="machina halovst"></div>  the tracks made with these
  //   [data-limit="6"]  the first n;  [data-tracks="therapy void-dance"]  these, in this order
  // It writes the track in hand (made with …, the name, who made it, its
  // waveform — a slider —, its time, back / play / next, the volume) and
  // the list (each row one button: the title, the artist, "made with
  // halo", the length — r7: no chip, drayki: "enlève les icônes dans la
  // section listen"). ONE <audio> for the
  // page, made at the first press (nothing is fetched before). Once a track
  // has started, and while no list is in sight, a slim bar at the foot of
  // the screen keeps it at hand (play, the track and its time, back, next,
  // the volume wide, ×); it rides over the product page's dock and the add
  // bar when they are up (html.bar-up), and goes away under the cart. The
  // waveform is the track's own shape, hairline bars, what has played in
  // the accent; frames run only while a track plays (a timer's events
  // where motion is reduced): nothing runs at rest. The volume is kept
  // (localStorage 'drayki-volume', try/catch); a mute lasts the visit.
  const MW = { a: null, AC: null, GN: null, VN: null, cur: null, q: TRACKS, vol: .8, muted: false, lastVol: .8, lvl: 1, started: false, closed: false, views: [], waves: [], seen: new Set(), mini: null, miniOn: false, raf: 0, inks: null, p: -1, at: '', ms: -1 };
  const LEVEL = -18;
  const mwFmt = (s) => { if (!isFinite(s) || s < 0) return '0:00'; const m = Math.floor(s / 60); return `${m}:${String(Math.floor(s % 60)).padStart(2, '0')}`; };
  const slug = (s) => String(s).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  {
    const v = parseFloat(store.get('drayki-volume'));
    if (v >= 0 && v <= 1) MW.vol = v;
    if (MW.vol > 0) MW.lastVol = MW.vol;
  }
  // the theme's tracks, if it prints them (a metaobject list, as JSON)
  // the theme's tracks, as it prints them (a metaobject list, as JSON: the
  // snippet tracks-json) — THEME: every <script data-tracks> of the page,
  // merged by id (a track made with several kits: kits, its handles)
  function readTracks() {
    const seen = new Set(), list = [];
    for (const el of $$('script[type="application/json"][data-tracks]')) {
      let v = null;
      try { v = JSON.parse(el.textContent || '[]'); } catch (e) { v = null; }
      if (!Array.isArray(v)) continue;
      for (const t of v) {
        if (!t || !t.title || !t.src) continue;
        const id = String(t.id || slug(t.title));
        if (seen.has(id)) continue;
        seen.add(id);
        const kits = Array.isArray(t.kits) ? t.kits.filter(Boolean).map(String) : [];
        const kit = String(t.kit || kits[0] || 'halovst');
        list.push({
          id, title: String(t.title).toLowerCase(), by: String(t.by || t.artist || '').toLowerCase(), kit, kits: kits.length ? kits : [kit],
          src: t.src, len: +t.len || 0, lufs: isFinite(+t.lufs) && t.lufs !== '' && t.lufs != null ? +t.lufs : LEVEL, shape: String(t.shape || ''),
        });
      }
    }
    if (list.length) TRACKS.splice(0, TRACKS.length, ...list);
  }
  const tracksFor = (kits, ids, limit) => {
    let l = ids && ids.length ? ids.map((i) => TRACKS.find((t) => t.id === i)).filter(Boolean) : TRACKS.filter((t) => !kits || !kits.length || kits.includes(t.kit) || (t.kits || []).some((x) => kits.includes(x)));   // THEME: a track made with several kits
    if (limit > 0) l = l.slice(0, limit);
    return l;
  };
  // (a track without its shape: a low even line, never a few odd bars)
  const peaksOf = (t) => (t._pk || (t._pk = t.shape ? [...t.shape].map((c) => (parseInt(c, 36) || 0) / 35) : new Array(170).fill(.12)));
  // a track's shape, from its file (for the owner, once per track, in the
  // browser's console on a page of the store: await DRAYKI.shapeOf(url) —
  // the string to paste in the track's "shape" field). The peak of each
  // 170th of the first channel, scaled to the loudest, one base-36 digit a
  // bin (0 silent … z full). Never called by the pages.
  async function shapeOf(url, bins = 170) {
    const K = W.AudioContext || W.webkitAudioContext;
    const buf = await (await fetch(url)).arrayBuffer();
    const ac = new K(), a = await ac.decodeAudioData(buf);
    try { ac.close(); } catch (e) { /* fine */ }
    const d = a.getChannelData(0), step = Math.max(1, Math.floor(d.length / bins)), pk = [];
    for (let i = 0; i < bins; i++) { let m = 0; for (let j = i * step, e = Math.min(d.length, j + step); j < e; j++) { const v = Math.abs(d[j]); if (v > m) m = v; } pk.push(m); }
    const M = Math.max(...pk) || 1;
    return pk.map((v) => Math.round((v / M) * 35).toString(36)).join('');
  }
  const madeWith = (t) => BY[t.kit] || { h: t.kit, name: t.kit === 'halovst' ? 'halo' : String(t.kit || 'halo'), href: t.kit && t.kit !== 'halovst' ? `/products/${t.kit}` : HALO_URL, local: true };   // THEME: a kit the catalogue does not hold
  const mwSays = (t, playing) => (playing ? S('pause', 'pause {title}').replace('{title}', t.title) : S('play', 'play {title}, by {artist}').replace('{title}', t.title).replace('{artist}', t.by));   // THEME: the locale's words
  // (the page it is on: "made with machina" on machina's own page is not a link)
  const here = (href) => { try { const u = new URL(href, location.href); return u.pathname === location.pathname && !u.hash; } catch (e) { return false; } };
  const IC = {
    pp: '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="pl" d="M6 3.2 20 12 6 20.8Z"/><path class="ps" d="M6 3h3.4v18H6ZM14.6 3H18v18h-3.4Z"/></svg>',
    bk: '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M13.5 2.5 5 8l8.5 5.5ZM2.5 2.5v11"/></svg>',
    nx: '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2.5 2.5 11 8l-8.5 5.5ZM13.5 2.5v11"/></svg>',
    mu: '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M1.5 6h2.7L7.5 3.2v9.6L4.2 10H1.5Z"/><path class="w1" d="M10 5.9a3 3 0 0 1 0 4.2"/><path class="w2" d="M12.2 3.8a6 6 0 0 1 0 8.4"/><path class="mx" d="M10.3 6.2l3.6 3.6M13.9 6.2l-3.6 3.6"/></svg>',
    x: '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M1.5 1.5l9 9M10.5 1.5l-9 9"/></svg>',
  };
  const volHTML = (id) => `<div class="mw-vol"><button class="mw-mu" type="button" aria-label="${esc(S('mute', 'mute'))}" aria-pressed="false" data-lv="2">${IC.mu}</button><input class="mw-v" type="range" min="0" max="1" step="0.01" value="${MW.vol}" aria-label="${esc(S('volume', 'volume'))}"${id ? ` id="${id}"` : ''}></div>`;

  // the sound: one element, the graph built at the first press (a browser
  // starts no audio without one); level (per track, down to -18) → the
  // listener's volume → out. Without Web Audio the element's own volume
  // carries both.
  function mwAudio() {
    if (MW.a) return MW.a;
    const a = MW.a = new Audio();
    a.crossOrigin = 'anonymous'; a.preload = 'none';
    a.addEventListener('loadedmetadata', () => { if (MW.pend != null) { a.currentTime = MW.pend * a.duration; MW.pend = null; } mwPaint(); });
    a.addEventListener('ended', () => mwStep(1));
    a.addEventListener('play', () => { MW.started = true; MW.closed = false; });
    ['play', 'pause', 'playing', 'waiting'].forEach((ev) => a.addEventListener(ev, mwSync));
    a.addEventListener('error', () => { if (!a.paused) a.pause(); mwSync(); });
    // (where motion is reduced, no frames: the element's own time events)
    if (REDUCE) a.addEventListener('timeupdate', mwPaint);
    return a;
  }
  function mwGraph() {
    if (MW.AC || MW.noAC) return;
    const K = W.AudioContext || W.webkitAudioContext;
    if (!K) { MW.noAC = true; return; }
    try {
      MW.AC = new K();
      const src = MW.AC.createMediaElementSource(MW.a);
      MW.GN = MW.AC.createGain(); MW.VN = MW.AC.createGain();
      src.connect(MW.GN); MW.GN.connect(MW.VN); MW.VN.connect(MW.AC.destination);
    } catch (e) { MW.AC = MW.GN = MW.VN = null; MW.noAC = true; }
  }
  function mwGain(now) {
    const v = MW.muted ? 0 : MW.vol, a = MW.a;
    if (!a) return;
    if (MW.GN) {
      MW.GN.gain.value = MW.lvl; a.volume = 1; a.muted = false;
      const g = MW.VN.gain, t = MW.AC.currentTime;
      g.cancelScheduledValues(t);
      if (now) g.setValueAtTime(v, t); else { g.setValueAtTime(g.value, t); g.setTargetAtTime(v, t, .015); }
    } else { a.volume = Math.min(1, MW.lvl * MW.vol); a.muted = MW.muted; }
  }
  const mwDur = () => { const a = MW.a, t = MW.cur; return a && isFinite(a.duration) && a.duration > 0 ? a.duration : t ? t.len || 1 : 1; };
  const mwPlaying = () => !!(MW.a && MW.cur && !MW.a.paused && !MW.a.error);
  function mwStart(t, q, at) {
    if (!t) return;
    const a = mwAudio(), fresh = !MW.AC;
    MW.started = true; MW.closed = false;
    if (q && q.length) MW.q = q;
    mwGraph();
    if (MW.AC && MW.AC.state === 'suspended') MW.AC.resume();
    if (MW.cur !== t || a.error) { MW.cur = t; a.src = t.src; MW.pend = null; }
    MW.lvl = Math.min(1, Math.pow(10, (LEVEL - (isFinite(t.lufs) ? t.lufs : LEVEL)) / 20));
    mwGain(fresh);
    if (at != null) mwSeek(at);
    const go = a.play();
    if (go && go.catch) go.catch(() => mwSync());
    mwSync();
  }
  function mwToggle(t, q) { if (t && MW.cur === t && mwPlaying()) MW.a.pause(); else mwStart(t || MW.cur || (q || MW.q)[0], q); }
  function mwStep(d) {
    const q = MW.q && MW.q.length ? MW.q : TRACKS, i = MW.cur ? q.indexOf(MW.cur) : -1;
    mwStart(q[i < 0 ? (d > 0 ? 0 : q.length - 1) : (i + d + q.length) % q.length], q);
  }
  // back: to the start of the track once it has played a few seconds, else the one before
  function mwBack() { if (MW.cur && MW.a && !MW.a.error && MW.a.currentTime > 3) mwStart(MW.cur, null, 0); else mwStep(-1); }
  function mwSeek(f) {
    f = clamp(f, 0, 1);
    const a = MW.a;
    if (a && isFinite(a.duration) && a.duration > 0) a.currentTime = f * a.duration; else MW.pend = f;
    mwPaint();
  }
  function mwSetVol(v) {
    MW.vol = Math.round(clamp(v, 0, 1) * 100) / 100; MW.muted = false;
    if (MW.vol > 0) MW.lastVol = MW.vol;
    mwGain(); mwVolPaint();
    store.set('drayki-volume', String(MW.vol));
  }
  function mwVolPaint() {
    const v = MW.muted ? 0 : MW.vol, lv = v <= 0 ? 0 : v < .5 ? 1 : 2, txt = MW.muted ? 'muted' : `${Math.round(MW.vol * 100)} %`;
    for (const el of $$('.mw-v')) { el.value = String(v); el.style.setProperty('--v', `${v * 100}%`); el.setAttribute('aria-valuetext', txt); }
    for (const b of $$('.mw-mu')) { b.dataset.lv = String(lv); b.setAttribute('aria-pressed', String(MW.muted)); }
  }
  function mwVolBind(scope) {
    for (const el of $$('.mw-v', scope)) {
      if (el._mw) continue; el._mw = true;
      el.addEventListener('input', () => mwSetVol(+el.value));
    }
    for (const b of $$('.mw-mu', scope)) {
      if (b._mw) continue; b._mw = true;
      b.addEventListener('click', () => { if (MW.vol <= 0) { mwSetVol(MW.lastVol); return; } MW.muted = !MW.muted; mwGain(); mwVolPaint(); });
    }
  }

  // the waveform: a hairline bar a bin (never more than one to every 2.5px:
  // a bar then takes the loudest of the bins it covers), mirrored about
  // the middle, what has played in the accent, the rest in the page's line
  // colour, the bar the time is in split at it. A canvas as many pixels as
  // it covers; sized when it changes size, redrawn only when the time has
  // moved by a pixel, the track changes, or the palette does.
  // (each waveform takes the colours where it stands: a list in a band of
  // the other palette draws in that band's accent and line)
  const mwInks = (v) => {
    if (!v.inks) { const cs = getComputedStyle(v.bar); v.inks = { on: cs.getPropertyValue('--accent').trim() || '#5c44fb', off: cs.getPropertyValue('--line').trim() || 'rgba(29,23,72,.5)' }; }
    return v.inks;
  };
  function mwWave(bar, track) {
    const cv = doc.createElement('canvas');
    cv.setAttribute('aria-hidden', 'true');
    bar.appendChild(cv);
    const v = { bar, cv, w: 0, h: 0, dpr: 1, key: '', track };
    MW.waves.push(v);
    if (MW.ro) MW.ro.observe(bar); else { v.w = bar.clientWidth; v.h = bar.clientHeight; mwSeat(v, v.w, v.h); }
    // the time, clicked or dragged, or moved by keys
    let drag = false;
    const fx = (e) => { const r = bar.getBoundingClientRect(); return (e.clientX - r.left) / (r.width || 1); };
    const target = () => v.track || MW.cur;
    bar.addEventListener('pointerdown', (e) => {
      if (e.button !== 0) return;
      drag = true; try { bar.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      const t = target();
      if (t !== MW.cur) mwStart(t, v.q, fx(e)); else mwSeek(fx(e));
    });
    bar.addEventListener('pointermove', (e) => { if (drag) mwSeek(fx(e)); });
    const up = () => { drag = false; };
    bar.addEventListener('pointerup', up); bar.addEventListener('pointercancel', up);
    bar.addEventListener('keydown', (e) => {
      const t = target(), d = t === MW.cur ? mwDur() : (t && t.len) || 1, now = t === MW.cur && MW.a ? MW.a.currentTime : 0;
      const k = e.key;
      const to = k === 'ArrowRight' || k === 'ArrowUp' ? now + 5 : k === 'ArrowLeft' || k === 'ArrowDown' ? now - 5 : k === 'PageUp' ? now + d / 10 : k === 'PageDown' ? now - d / 10 : k === 'Home' ? 0 : k === 'End' ? d - .5 : null;
      if (to === null) return;
      e.preventDefault();
      if (t !== MW.cur) mwStart(t, v.q, to / d); else mwSeek(to / d);
    });
    return v;
  }
  function mwSeat(v, w, h) {
    const dpr = Math.min(3, W.devicePixelRatio || 1);
    if (w === v.w && h === v.h && dpr === v.dpr && v.cv.width > 1) return;
    v.w = w; v.h = h; v.dpr = dpr; v.key = '';
    v.cv.width = Math.max(1, Math.round(w * dpr)); v.cv.height = Math.max(1, Math.round(h * dpr));
  }
  function mwDraw(v) {
    const t = v.track || MW.cur || (MW.q && MW.q[0]);
    if (!t || !v.w || !v.h) return;
    const p = t === MW.cur && MW.a ? clamp(MW.a.currentTime / mwDur(), 0, 1) : 0;
    const pk = peaksOf(t), Wd = v.cv.width, Hd = v.cv.height, n = Math.max(8, Math.min(pk.length, Math.floor(v.w / 2.5)));
    // (rise: the arrival, 0 → 1 — each bar grows from the middle line in
    // its turn, left to right; 1 once arrived, and on the bar at hand)
    const rise = v.rise == null ? 1 : v.rise;
    const at = Math.round(p * Wd), key = `${t.id}|${Wd}x${Hd}|${at}|${rise.toFixed(3)}`;
    if (key === v.key) return;
    v.key = key;
    const x = v.cv.getContext('2d'), c = mwInks(v), lw = Math.max(1, Math.round(v.dpr)), pitch = Wd / n;
    x.clearRect(0, 0, Wd, Hd);
    for (let k = 0; k < n; k++) {
      const rk = rise >= 1 ? 1 : out3(seg(rise, (k / n) * .55, (k / n) * .55 + .45));
      if (rk <= 0) continue;
      const a = Math.floor((k * pk.length) / n), b = Math.max(a + 1, Math.floor(((k + 1) * pk.length) / n));
      let m = 0;
      for (let j = a; j < b; j++) m = Math.max(m, pk[j]);
      const bx = Math.round(k * pitch + (pitch - lw) / 2), bh = Math.max(lw, 2 * Math.round(m * Hd * .47 * rk)), by = Math.round((Hd - bh) / 2);
      if (bx + lw <= at) { x.fillStyle = c.on; x.fillRect(bx, by, lw, bh); }
      else if (bx >= at) { x.fillStyle = c.off; x.fillRect(bx, by, lw, bh); }
      else { x.fillStyle = c.on; x.fillRect(bx, by, at - bx, bh); x.fillStyle = c.off; x.fillRect(at, by, bx + lw - at, bh); }
    }
  }

  // what is shown: the time (words, the sliders' values, the current row's
  // hairline) and the waveforms — only what has changed
  function mwPaint() {
    const t = MW.cur, a = MW.a;
    const d = mwDur(), now = t && a ? a.currentTime : 0, p = t ? clamp(now / d, 0, 1) : 0;
    const pr = p.toFixed(4);
    if (pr !== MW.p) { MW.p = pr; for (const V of MW.views) if (V.row) V.row.li.style.setProperty('--p', pr); }
    for (const v of MW.waves) mwDraw(v);
    const s = `${mwFmt(now)}|${mwFmt(d)}`;
    if (s !== MW.at) {
      MW.at = s;
      const A = mwFmt(now), Dd = mwFmt(d);
      for (const V of MW.views) {
        if (V.t !== t) continue;
        V.atEl.textContent = A; V.duEl.textContent = Dd;
        V.wave.setAttribute('aria-valuemax', String(Math.round(d))); V.wave.setAttribute('aria-valuenow', String(Math.round(now))); V.wave.setAttribute('aria-valuetext', S('position', '{time} of {length}').replace('{time}', A).replace('{length}', Dd));
        if (V.row && a && isFinite(a.duration)) $('.mw-d', V.row.li).textContent = Dd;
      }
      if (MW.mini) {
        MW.mini.at.textContent = A;
        const w = MW.mini.wave; w.setAttribute('aria-valuemax', String(Math.round(d))); w.setAttribute('aria-valuenow', String(Math.round(now))); w.setAttribute('aria-valuetext', S('position', '{time} of {length}').replace('{time}', A).replace('{length}', Dd));
      }
    }
  }
  // frames only while a track plays (and none where motion is reduced)
  function mwLoop() {
    MW.raf = 0;
    if (!mwPlaying() || REDUCE) return;
    mwPaint();
    MW.raf = W.requestAnimationFrame(mwLoop);
  }
  function mwSync() {
    const playing = mwPlaying(), t = MW.cur;
    for (const V of MW.views) {
      // the track in hand: the one playing if it is in this list, else its first
      const show = t && V.list.includes(t) ? t : V.list[0];
      if (show !== V.t) mwShow(V, show);
      const mine = !!t && V.t === t;
      V.el.classList.toggle('playing', mine && playing);
      V.pp.setAttribute('aria-label', mwSays(V.t, mine && playing));   // THEME: the locale's words
      for (const r of V.rows) {
        const on = r.t === t;
        r.li.classList.toggle('on', on); r.li.classList.toggle('playing', on && playing);
        if (on) r.b.setAttribute('aria-current', 'true'); else r.b.removeAttribute('aria-current');
        r.b.setAttribute('aria-label', `${mwSays(r.t, on && playing)}, ${S('made_with', 'made with {kit}').replace('{kit}', madeWith(r.t).name)}`);   // THEME: the locale's words
      }
      V.row = V.rows.find((r) => r.t === t) || null;
      for (const r of V.rows) if (r !== V.row) r.li.style.removeProperty('--p');
    }
    mwMiniSync();
    // the system's own keys (a keyboard's, a phone's lock screen)
    const ms = navigator.mediaSession;
    if (ms && t && MW.ms !== t && W.MediaMetadata) {
      MW.ms = t;
      const k = madeWith(t);
      try { ms.metadata = new MediaMetadata({ title: t.title, artist: t.by, album: S('made_with', 'made with {kit}').replace('{kit}', k.name), artwork: k.local ? [] : [{ src: cover(k, 240), sizes: '240x240' }, { src: cover(k, 540), sizes: '540x540' }] }); } catch (e) { /* fine */ }
    }
    mwPlace(); MW.p = -1; MW.at = ''; mwPaint();
    if (playing && !MW.raf && !REDUCE) MW.raf = W.requestAnimationFrame(mwLoop);
    doc.dispatchEvent(new CustomEvent('drayki:player', { detail: { id: t ? t.id : null, playing } }));
  }
  function mwShow(V, t) {
    V.t = t;
    const k = madeWith(t), link = !here(k.href);
    V.withEl.innerHTML = `<span>${esc(S('made_with', 'made with {kit}')).replace('{kit}', link ? `<a class="lnk" href="${esc(k.href)}">${esc(k.name)}</a>` : esc(k.name))}</span>`;   // THEME: the locale's words
    V.nm.textContent = t.title; V.by.textContent = t.by;
    V.wv.track = t; V.wv.key = '';
    V.atEl.textContent = '0:00'; V.duEl.textContent = mwFmt(t.len);
  }
  // the bar at hand: once a track has started, not closed since, while no
  // list is in sight (and never over the cart)
  function mwPlace() {
    const on = MW.started && !MW.closed && !!MW.cur && !MW.seen.size;
    if (on && !MW.mini) mwMini();
    if (!MW.mini) return;
    root.classList.toggle('mw-room', MW.started && !MW.closed);
    if (on === MW.miniOn) return;
    MW.miniOn = on;
    const had = MW.mini.el.contains(doc.activeElement);
    if (on) { MW.mini.wv.key = ''; mwSeat(MW.mini.wv, MW.mini.wave.clientWidth, MW.mini.wave.clientHeight); }
    MW.mini.el.classList.toggle('on', on);
    MW.mini.el.toggleAttribute('inert', !on);
    if (!on && had) { const V = MW.views.find((x) => x.t === MW.cur) || MW.views[0]; if (V) V.pp.focus({ preventScroll: true }); }
  }
  // (the bar at hand says what plays: its words, its key)
  function mwMiniSync() {
    const M = MW.mini, t = MW.cur;
    if (!M || !t) return;
    const playing = mwPlaying();
    M.el.classList.toggle('playing', playing);
    // (short of room, the artist gives way before the track does: whole or not at all)
    if (M.t !== t) { M.t = t; M.nm.textContent = t.title; M.by.textContent = t.by; M.wv.key = ''; M.el.classList.remove('noby'); M.el.classList.toggle('noby', M.by.scrollWidth > M.by.clientWidth + 1); }
    M.pp.setAttribute('aria-label', mwSays(t, playing));   // THEME: the locale's words
  }
  function mwMini() {
    const el = doc.createElement('div');
    el.className = 'mw-mini'; el.setAttribute('role', 'region'); el.setAttribute('aria-label', S('now_playing', 'now playing'));
    el.innerHTML = `<button class="mw-pp" type="button">${IC.pp}</button>` +
      '<div class="mw-mm"><p class="mw-mt"><span class="mw-mn"></span><span class="mw-mb"></span><span class="mw-mat" aria-hidden="true">0:00</span></p>' +
      '<div class="mw-wave" role="slider" tabindex="0" aria-label="time" aria-valuemin="0" aria-valuemax="0" aria-valuenow="0"></div></div>' +
      `<button class="mw-bk" type="button" aria-label="${esc(S('previous', 'back: the start of the track, or the one before'))}">${IC.bk}</button>` +
      `<button class="mw-nx" type="button" aria-label="${esc(S('next', 'next track'))}">${IC.nx}</button>` +
      `${volHTML()}<button class="mw-x" type="button" aria-label="${esc(S('stop', 'close the player and stop'))}">${IC.x}</button>`;
    el.setAttribute('inert', '');
    doc.body.appendChild(el);
    const M = MW.mini = { el, pp: $('.mw-pp', el), nm: $('.mw-mn', el), by: $('.mw-mb', el), at: $('.mw-mat', el), wave: $('.mw-wave', el), t: null };
    M.wv = mwWave(M.wave, null);
    M.pp.addEventListener('click', () => mwToggle(MW.cur, MW.q));
    $('.mw-bk', el).addEventListener('click', mwBack);
    $('.mw-nx', el).addEventListener('click', () => mwStep(1));
    $('.mw-x', el).addEventListener('click', () => { MW.closed = true; if (MW.a) MW.a.pause(); mwSync(); });
    mwVolBind(el); mwVolPaint();
    mwMiniSync();
  }
  function madeWiths(scope) {
    for (const el of $$('[data-madewith]', scope)) {
      if (el._mw) continue; el._mw = true;
      const kits = (el.dataset.madewith || '').trim().split(/\s+/).filter(Boolean);
      const ids = (el.dataset.tracks || '').trim().split(/\s+/).filter(Boolean);
      const list = tracksFor(kits, ids, +el.dataset.limit || 0);
      if (!list.length) { el.hidden = true; continue; }
      el.classList.add('mw');
      const n = MW.views.length;
      el.innerHTML = '<div class="mw-now"><p class="mw-with"></p><p class="mw-nm"></p><p class="mw-by"></p>' +
        '<div class="mw-wave" role="slider" tabindex="0" aria-label="time" aria-valuemin="0" aria-valuemax="0" aria-valuenow="0"></div>' +
        '<p class="mw-tm"><span class="mw-at">0:00</span><span class="mw-du"></span></p>' +
        `<div class="mw-ctl"><button class="mw-bk" type="button" aria-label="${esc(S('previous', 'back: the start of the track, or the one before'))}">${IC.bk}</button>` +
        `<button class="mw-pp" type="button">${IC.pp}</button><button class="mw-nx" type="button" aria-label="${esc(S('next', 'next track'))}">${IC.nx}</button>${volHTML(`mw-v${n}`)}</div></div>` +
        `<ol class="mw-list" id="mw-l${n}">${list.map((t) => `<li><button class="mw-r" type="button">` +
          `<span class="mw-t">${esc(t.title)}</span><span class="mw-s"><span class="mw-a">${esc(t.by)}</span><i class="dot" aria-hidden="true">·</i><span class="mw-w">${esc(S('made_with', 'made with {kit}').replace('{kit}', madeWith(t).name))}</span></span><span class="mw-d">${mwFmt(t.len)}</span></button></li>`).join('')}</ol>`;
      const V = {
        el, list, t: null, row: null,
        withEl: $('.mw-with', el), nm: $('.mw-nm', el), by: $('.mw-by', el), wave: $('.mw-now .mw-wave', el),
        atEl: $('.mw-at', el), duEl: $('.mw-du', el), pp: $('.mw-now .mw-pp', el),
        rows: $$('.mw-list > li', el).map((li, i) => ({ li, b: $('button', li), t: list[i] })),
      };
      V.wv = mwWave(V.wave, list[0]); V.wv.q = list;
      MW.views.push(V);
      V.pp.addEventListener('click', () => mwToggle(V.t, list));
      $('.mw-now .mw-bk', el).addEventListener('click', () => { if (MW.cur !== V.t) mwStart(V.t, list, 0); else mwBack(); });
      $('.mw-now .mw-nx', el).addEventListener('click', () => { if (MW.cur && list.includes(MW.cur)) mwStep(1); else mwStart(list[Math.min(1, list.length - 1)], list); });
      V.rows.forEach((r) => r.b.addEventListener('click', () => mwToggle(r.t, list)));
      mwVolBind(el);
      // (a list in sight: the bar at hand stays away)
      if (!MW.io && 'IntersectionObserver' in W) MW.io = new IntersectionObserver((es) => { for (const e of es) { if (e.isIntersecting) MW.seen.add(e.target); else MW.seen.delete(e.target); } mwPlace(); }, { rootMargin: '-10% 0px -10% 0px' });
      if (MW.io) MW.io.observe(el);
      mwShow(V, list[0]);
      // (r8, drayki: "affiche les 6 premiers avec un bouton more") THE FOLD:
      // the first rows, the rest behind a key under the list (more / less,
      // like the about card's). The player never opens it by itself: the
      // page would jump under whoever reads further down.
      const fold = +el.dataset.fold || 0;
      if (fold && list.length > fold) {
        const more = el.dataset.more || 'more', less = el.dataset.less || 'less', cut = V.rows.slice(fold);
        for (const r of cut) r.li.hidden = true;
        el.insertAdjacentHTML('beforeend', `<button class="lnk mw-more" type="button" aria-expanded="false" aria-controls="mw-l${n}">${esc(more)}</button>`);
        const key = $('.mw-more', el);
        key.addEventListener('click', () => {
          const on = key.getAttribute('aria-expanded') !== 'true';
          for (const r of cut) r.li.hidden = !on;
          key.setAttribute('aria-expanded', on ? 'true' : 'false');
          key.textContent = on ? less : more;
          // (folded from far down: back to the key)
          const top = ($('.top') || {}).offsetHeight || 0;
          if (!on && key.getBoundingClientRect().top < top) key.scrollIntoView({ block: 'center', behavior: REDUCE ? 'auto' : 'smooth' });
        });
      }
      // (r7, drayki: "ça manque de scrolling animations sur la page
      // produit") THE ARRIVAL, read off the scroll, once, like the boards
      // round it: the waveform's bars rise from its middle line, left to
      // right; each title in the list is uncovered by the page's own ground
      // (the curtain, row after row as the rows come up); the play key's
      // ring is drawn round. A canvas, transforms, a stroke — nothing runs
      // at rest; reduced motion (and no script): all as they end.
      if (E.on) {
        V.wv.rise = 0; mwDraw(V.wv);
        register(new Once(V.wave, (p) => { V.wv.rise = p; mwDraw(V.wv); }, 1.2, .98, .5), V.wave);
        for (const t of $$('.mw-t', el)) { if (t.closest('li').hidden) continue; t.setAttribute('data-cur', ''); t._cur = new Curtain(t, 'row'); t._cur.layout(); register(t._cur, t); }
        V.pp.insertAdjacentHTML('beforeend', '<svg class="mw-ring" viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="32" r="31.5" pathLength="100"/></svg>');
        V.pp.classList.add('rg');
        const ring = $('.mw-ring circle', V.pp), draw = (p) => { ring.style.strokeDashoffset = (100 * (1 - out3(p))).toFixed(2); };
        draw(0);
        register(new Once(V.pp, draw, 1.1, .98, .55), V.pp);
      }
    }
    if (MW.views.length) { mwVolPaint(); mwSync(); }
  }
  // (a section taken out in the theme's editor: its lists let go; the sound,
  // if it plays, goes on in the bar at hand)
  function mwUnmount(scope) {
    const gone = MW.views.filter((V) => scope.contains(V.el));
    if (!gone.length) return;
    for (const V of gone) { if (MW.io) MW.io.unobserve(V.el); MW.seen.delete(V.el); V.el._mw = false; }
    MW.views = MW.views.filter((V) => !gone.includes(V));
    MW.waves = MW.waves.filter((v) => { const g = scope.contains(v.bar); if (g && MW.ro) MW.ro.unobserve(v.bar); return !g; });
    mwPlace();
  }
  // (the waveforms' sizes, and the palette's colours)
  if ('ResizeObserver' in W) MW.ro = new ResizeObserver((es) => { for (const e of es) { const v = MW.waves.find((q) => q.bar === e.target); if (v) mwSeat(v, e.contentRect.width, e.contentRect.height); } for (const v of MW.waves) mwDraw(v); });
  new MutationObserver(() => { for (const v of MW.waves) { v.inks = null; v.key = ''; mwDraw(v); } }).observe(root, { attributes: true, attributeFilter: ['data-theme'] });
  {
    const ms = navigator.mediaSession;
    if (ms) {
      const h = { play: () => mwToggle(MW.cur, MW.q), pause: () => { if (MW.a) MW.a.pause(); }, previoustrack: mwBack, nexttrack: () => mwStep(1) };
      for (const k in h) { try { ms.setActionHandler(k, h[k]); } catch (e) { /* fine */ } }
    }
  }

  // THE BARS AT THE FOOT (r6): whether one is up there now — the product
  // page's dock (where it is drawn) or the add bar at the foot — so the
  // player's bar rides over it (html.bar-up), never under it
  function barsUp() {
    const dk = mqDock.matches && $$('.dock').some((d) => d.classList.contains('on') && !d.classList.contains('held'));
    const ab = !!(AB && AB.el.classList.contains('on') && !AB.el.classList.contains('at-top'));
    root.classList.toggle('bar-up', dk || ab);
  }

  /* ------------------------------------------------------------ mounting */
  // everything new under a scope: the fills, the objects (every width read
  // in one pass before any is built), the stacks, the curtains, the
  // drawings, the counters, the ticker, the covers, the rails, the
  // questions, the stars, the explorer, the add keys, the docks
  function mount(scope = doc) {
    fill(scope);
    const fresh = $$('[data-kit]', scope).filter((el) => !el._obj);
    fresh.forEach((el) => { el._w = el.getBoundingClientRect().width; });
    for (const el of fresh) {
      const o = new Obj(el);
      if (!E.on) continue;
      if (el.hasAttribute('data-travel')) continue;          // travels() drives it
      if (o.lay || o.turn || el.dataset.cycle) {
        o.layout();
        // (its first frame is already its pose for where it stands on the
        // screen: never drawn upright, then laid back once it is seen)
        if (o.lay) { const p = o.layPose(); o.write(p.rx, p.ry, p.rz); }
        register(o, el);
      }
      if (el.dataset.cycle) o.cycle(el.dataset.cycle.trim().split(/\s+/), { every: el.dataset.cycleEvery, rounds: el.dataset.cycleRounds });
    }
    for (const el of $$('[data-stack]', scope)) {
      if (el._stack) continue;
      const s = new Stack(el);
      if (E.on) { s.layout(); register(s, el); }
    }
    if (E.on) {
      // (a heading's own line is uncovered with it, just after: the
      // questions' "anything else — …", the newsletter's line — never
      // there first, under a heading still to come)
      for (const el of $$('.qa-h > [data-cur] ~ .meta, .nl-h[data-cur] + .nl-r > .say', scope)) el.setAttribute('data-cur', '');
      for (const el of $$('[data-t]', scope)) if (!el._cur) { el._cur = new Curtain(el, 'word'); el._cur.layout(); register(el._cur, el); }
      for (const el of $$('[data-cur]', scope)) if (!el._cur) { el._cur = new Curtain(el, 'row'); el._cur.layout(); register(el._cur, el); }
    }
    drawings(scope);
    odometers(scope);
    tickers(scope);
    uncovers(scope);
    crops(scope);
    rails(scope);
    questions(scope);
    stars(scope);
    explorers(scope);
    addButtons(scope);
    docks(scope);
    newsletters(scope);
    madeWiths(scope);
    themeKeys(scope);
    recs(scope);   // THEME: [data-recs] (the cart keys, [data-cart-open], are the delegated listener's)
    syncCount();
    wake();
  }
  // a page's own section: its init runs once the system has started, and
  // again on the theme editor's section:load (with that section as scope)
  const SECTIONS = [];
  function section(name, init) {
    SECTIONS.push({ name, init });
    if (D.ready) init(doc);
  }

  /* ------------------------------------------------- who is at the keys */
  // (r7, drayki: "bug sur le cart, quand on clique dessus sur mobile le
  // statut hover (entouré) reste") A focus ring is the keyboard's. When the
  // script gives the focus back — the cart closed (to the key that opened
  // it), a row removed (to the next "remove") — after a finger or a mouse,
  // a browser may still draw its ring there (Safari on a phone does, round
  // the cart key, and nothing takes it off until the next tap elsewhere).
  // html.tap says the last hand was a pointer: the style then draws no
  // focus ring and no focused fill (every :focus-visible rule of site.css
  // is under :where(html:not(.tap))). The first key that moves the focus
  // takes it off, and the rings are back. Hover fills are for a mouse only
  // (@media (hover: hover) and (pointer: fine)): a tap never leaves one.
  function hands() {
    doc.addEventListener('pointerdown', () => { if (!root.classList.contains('tap')) root.classList.add('tap'); }, { capture: true, passive: true });
    doc.addEventListener('keydown', (e) => {
      if (e.metaKey || e.ctrlKey || e.altKey || !/^(Tab|Enter| |Escape|Arrow|Home|End|Page)/.test(e.key)) return;
      if (root.classList.contains('tap')) root.classList.remove('tap');
    }, true);
  }

  /* ---------------------------------------------------------- the start */
  // The screen's height, KEPT (--vh in the style, E.vh here): read at the
  // start and whenever the window really changes (turned, resized); never
  // when only a phone's bars fold away or come back as the page scrolls
  // (the same width, under 160px, the page moved). At the very top of the
  // page, where that cannot be seen, it follows them.
  function readVH() {
    const vv = W.visualViewport;
    let ih = W.innerHeight || 0;
    if (!ih && vv) ih = vv.height * (vv.scale || 1);
    return [root.clientWidth || W.innerWidth, Math.round(ih || root.clientHeight)];
  }
  function setVH(force) {
    const [w, h] = readVH();
    if (!h) return false;
    if (!force && w === E.kw && h === E.kh) return false;
    if (!force && w === E.kw && W.scrollY > 2 && Math.abs(h - E.kh) < 160 && (mqCoarse.matches || mqPhone.matches)) return false;
    E.kw = w; E.kh = h;
    root.style.setProperty('--vh', `${h}px`);
    return true;
  }
  // THEME: the page's listeners that are delegated — one each, attached once
  // at the start, never again (the editor's reloads can't stack them): an
  // add key, a "remove", "get the vault", anything that opens the cart
  function delegates() {
    doc.addEventListener('click', (e) => {
      const t = e.target;
      if (!t || !t.closest || e.defaultPrevented) return;
      // (the foot's "questions" — the home's, /#questions — on a page that
      // has questions of its own: to this page's, never away from it)
      const qa = t.closest('a[href$="/#questions"]');
      if (qa && doc.getElementById('questions')) { qa.setAttribute('href', '#questions'); return; }
      const add = t.closest('[data-add]');
      if (add) { onAdd(e, add); return; }
      const rm = t.closest('[data-rm]');
      if (rm) { e.preventDefault(); removeFrom(rm); return; }
      const va = t.closest('[data-vault-add]');
      if (va) { e.preventDefault(); vaultAdd(va); return; }
      const co = t.closest('[data-cart-open]');
      if (co) { e.preventDefault(); if (onCartPage()) toCartTop(); else openDrawer(co); }
    });
    doc.addEventListener('drayki:variant', onVariant);
  }
  // THEME: [data-recs] — a row of "more kits" from Shopify's recommendations:
  // the address in the attribute renders the section again (Section
  // Rendering, recommendations performed); its cards take the place of the
  // collection's, printed first. None offered: the collection's stay.
  function recs(scope) {
    for (const el of $$('[data-recs]', scope)) {
      if (el._rc) continue; el._rc = true;
      fetch(el.dataset.recs, { credentials: 'same-origin' }).then((r) => (r.ok ? r.text() : '')).then((html) => {
        if (!html) return;
        const d = new DOMParser().parseFromString(html, 'text/html');
        const fresh = d.querySelector('.shelf'), shelf = el.matches('.shelf') ? el : $('.shelf', el);
        if (!fresh || !shelf || !fresh.querySelector('.item')) return;
        unmount(shelf);
        shelf.innerHTML = fresh.innerHTML;
        mount(shelf);
        shelf.dispatchEvent(new Event('scroll'));   // (the rail's keys, on or off at its ends)
        layoutSoon();
      }).catch(() => { /* the collection's cards stay */ });
    }
  }
  // THEME: a product page that goes straight to checkout (main-product's
  // "aller droit au paiement": its pill is a link, a[data-permalink] to
  // /cart/<id>:1, as HALO's page does): the top line's key goes there too,
  // never into the cart (product.js keeps its href on the chosen version)
  function directTop() {
    const pill = $('#AddToCart-Main[data-permalink]'), key = TOP && $('.top-add', TOP);
    if (!pill || !key || key.hasAttribute('data-permalink')) return;
    key.setAttribute('href', pill.getAttribute('href'));
    key.setAttribute('data-permalink', pill.getAttribute('data-permalink'));
    key.removeAttribute('data-add'); key.removeAttribute('data-open'); key.removeAttribute('data-variant');
  }
  // THEME: the editor's "section selected": its arrivals end at once (the
  // owner sees the final state)
  function finishIn(scope) {
    for (const f of E.fx) {
      if (f.dead || !f.el || !scope.contains(f.el)) continue;
      if (f instanceof Once) { f.p = 1; f.w(1); f.done = true; f.dead = true; f.hot = false; E.dirty = true; }
      else if (f instanceof Curtain) { f.p = 1; f.write(); f.finish(); }
      else if (f instanceof Stack) { f.q = 1; f.done = true; f.write(true); }
    }
    wake();
  }
  function start() {
    E.on = !REDUCE && root.classList.contains('mo');
    setVH(true);
    // (a pixel of the screen, in CSS px: the face's edge, see .kit-fc::after)
    root.style.setProperty('--hp', `${(1 / Math.max(1, W.devicePixelRatio || 1)).toFixed(3)}px`);
    Cart.set(CONFIG.cart);   // THEME: the cart as the page was printed
    liveCounts();            // THEME: a product page's kit counted from its manifest, if its counts are out of date
    readTracks();
    hands();
    header();
    theme();
    delegates();             // THEME
    drawerDOM();             // THEME: the server's drawer, adopted
    mount(doc);
    directTop();             // THEME
    travels();
    D.ready = true;
    for (const s of SECTIONS) { try { s.init(doc); } catch (err) { console.error(err); } }
    layout();
    W.addEventListener('scroll', () => {
      E.Y = W.scrollY;
      headerScroll();
      if (H.scroll) H.scroll();   // (THEME: the phone's menu, closed by a scroll)
      if (AB && AB.el.classList.contains('on') && Math.abs(W.scrollY - AB.y0) > 140) hideNote();
      clearTimeout(E.restT);
      E.restT = setTimeout(atRest, 360);
      wake();
    }, { passive: true });
    onMQ(mqMenu, (e) => { if (H.mq) H.mq(e); });   // (THEME: the menu's own, once)
    // (the page at rest as it opens: a word or a stack already half in view
    // on the first screen is finished on its own clock, as after a scroll)
    E.restT = setTimeout(atRest, 700);
    const resized = () => { const w = W.innerWidth; if (setVH(false) || w !== E.vw) layoutSoon(120); };
    W.addEventListener('resize', resized);
    if (W.visualViewport) W.visualViewport.addEventListener('resize', resized);
    W.addEventListener('orientationchange', () => setTimeout(() => { setVH(true); layout(); }, 250));
    // (THEME: a page given back by the history is as it was left: its cart is read again)
    W.addEventListener('pageshow', (e) => { if (!e.persisted) return; if (setVH(false)) layout(); refresh(); });
    // (iOS shows :active, the pill's pressed fill, only once the page listens for touches)
    root.addEventListener('touchstart', () => {}, { passive: true });
    doc.addEventListener('visibilitychange', () => { if (doc.hidden) { if (E.raf) { W.cancelAnimationFrame(E.raf); E.raf = 0; } } else wake(); });
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(() => layoutSoon(0));
    W.addEventListener('load', () => layoutSoon(0));
    if ('ResizeObserver' in W) { let first = true; new ResizeObserver(() => { if (first) { first = false; return; } layoutSoon(); }).observe(doc.body); }
    // the theme's editor: a section added, taken out, moved (THEME: the
    // header and the drawer adopted again; selected: its arrivals finished,
    // the drawer opened; a question's block selected: it opens)
    doc.addEventListener('shopify:section:load', (e) => {
      const t = e.target;
      if ($('#cart-drawer', t)) { DW = null; drawerDOM(); }
      if ($('.top', t)) header();
      readTracks();
      liveCounts();
      mount(t);
      directTop();
      for (const s of SECTIONS) { try { s.init(t); } catch (err) { console.error(err); } }
      layoutSoon(0);
    });
    doc.addEventListener('shopify:section:unload', (e) => unmount(e.target));
    doc.addEventListener('shopify:section:reorder', () => layoutSoon(0));
    doc.addEventListener('shopify:section:select', (e) => { finishIn(e.target); if ($('#cart-drawer', e.target)) openDrawer(); });
    doc.addEventListener('shopify:section:deselect', (e) => { if ($('#cart-drawer', e.target)) closeDrawer(); });
    doc.addEventListener('shopify:block:select', (e) => {
      const t = e.target, q = t && t.matches && (t.matches('details.q') ? t : $('details.q', t));
      if (q && !q.open) { const s = $('summary', q); if (s) s.click(); }
    });
  }
  function boot() {
    // (if anything fails here, nothing is left hidden: motion is taken off,
    // every word and card shows whole)
    try { start(); } catch (err) { root.classList.remove('mo'); D.ready = true; console.error(err); }
  }

  /* ------------------------------------------------------------ public */
  Object.assign(D, {
    PRODUCTS, KITS, BY, TIERS, VAULT, TYPE, HALO_URL, DRAW, SOUNDS, CATS, TRACKS,
    config: CONFIG, catalog: new Map(PRODUCTS.map((p) => [p.h, p])),   // THEME
    shapeOf,
    tracks: (kits, ids, limit) => tracksFor(kits ? [].concat(kits) : null, ids ? [].concat(ids) : null, limit || 0),
    player: {
      play: (id) => { const t = TRACKS.find((x) => x.id === id) || MW.cur || TRACKS[0]; if (t && (MW.cur !== t || !mwPlaying())) mwStart(t); },
      pause: () => { if (MW.a) MW.a.pause(); },
      toggle: (id) => mwToggle(id ? TRACKS.find((x) => x.id === id) : MW.cur, null),
      current: () => (MW.cur ? { id: MW.cur.id, title: MW.cur.title, by: MW.cur.by, kit: MW.cur.kit, playing: mwPlaying(), time: MW.a ? MW.a.currentTime : 0 } : null),
    },
    fmt, priceHTML, sumHTML, typeLabel, metaOf, thick, cover,
    manifest, parseManifest, countKit, kitCounts,   // THEME: countKit, kitCounts
    tpl: TPL,
    mount, unmount, register, unregister, section, layout, wake, fitWords, syncAdd,
    phone: () => mqPhone.matches,
    engine: E,
    Obj, Stack, Once,
    // THEME: the real cart (Promises; ref = a variant's id or a product's handle)
    cart: {
      add: (ref, o) => cartAdd(ref, o || {}),
      addMany: (refs, o) => cartAddMany(refs, o || {}),
      remove: (ref) => cartRemove(ref),
      has: (ref) => Cart.has(ref),
      items: () => Cart.items(),
      totals: () => Cart.totals(),
      refresh: (o) => refresh(o || {}),
    },
  });
  W.openCartDrawer = () => openDrawer();
  W.closeCartDrawer = closeDrawer;
  W.refreshCartUI = (o = {}) => refresh(o);                  // THEME: Section Rendering
  W.changeQty = (ref, q) => changeQty(ref, q);               // THEME: a line's key or a handle; 0 = out

  // THEME: window.DRAYKI is whole as soon as this file is evaluated (the
  // page modules — home.js, product.js…, type="module", run after it — call
  // DRAYKI.section() and add DRAYKI.DRAW.x); the system starts at
  // DOMContentLoaded, after them (a deferred script runs while readyState is
  // already "interactive": the mockup's test would have started it first).
  let booted = false;
  const bootOnce = () => { if (!booted) { booted = true; boot(); } };
  if (doc.readyState === 'complete') bootOnce();
  else { doc.addEventListener('DOMContentLoaded', bootOnce); W.addEventListener('load', bootOnce); }
})();
